<template>
  <div id="lodging-show">
    <portal to="modals">
      <Modalsignup v-if="showSignupModal" :showModalLogin="showModalLogin" @close="setUser" />
    </portal>
     <portal to="modals">
       <ExperienceMapModal v-if="showExperienceMap" :visible="showExperienceMap" :lodging="lodging"
         :focusedExperience="selectedExperienceForMap" @close="handleExperienceMapClose()"></ExperienceMapModal>
     </portal>
    <portal to="modals">
      <Modalshare v-if="showModal" @close="showModal = false" :for="this.lodging"></Modalshare>
    </portal>
    <portal to="modals">
      <RoomPlanModal
        v-if="supportsStructuredRoomPlans"
        :visible="showRoomPlanModal"
        :roomPlans="roomPlansDraft"
        :totals="roomPlanTotals"
        :error="roomPlanModalError"
        @close="closeRoomPlanModal"
        @add-room="addRoomPlan"
        @remove-room="removeRoomPlan"
        @update-room-value="updateRoomPlanValueFromEvent"
        @update-room-children="updateRoomChildrenCountFromEvent"
        @update-room-child-age="updateRoomChildAgeFromEvent"
        @save="saveRoomPlansFromModal"
      />
    </portal>
    <template v-if="isChoosing">
      <!-- Banner -->
      <template>
        <div class="w-100 lodge-banner-container" :class="isPhone ? 'px-3' : 'px-5'">
          <div class="w-100 d-flex justify-content-between align-items-center phone banner-top">
            <div @click="goBack" class="back-button d-flex align-items-center">
              <a class="mr-2">
                <i class="fa fa-angle-left" style="color: white; width: 7px; height: 14px;"></i>
              </a>
              <span class="raleway-semi-p15">Retour</span>
            </div>
            <div class="interaction">
              <div class="faves">
                <div>
                  <img src="../../images/wishlistOnWhite.svg" alt="Coeur plein" v-if="isIncludeInWishlist()"
                    @click="toggleLike()" />
                  <img src="../../images/wishlistWhite.svg" alt="Coeur vide" v-else @click="toggleLike()" />
                </div>
              </div>
              <div class="share d-flex" @click="showModal = true">
                <img src="../../images/ShareWhite.svg" v-set-alt />
              </div>
            </div>
          </div>
          <div id="banner-lodging" :style="getBackgroundStyle()" class="position-relative">
            <div class="image-gradient-bottom"></div>
            <div class="experience-name-text no-translate" :class="isPhone ? 'merriweather-reg-20' : 'merriweather-reg-24'" v-if="this.experienceName">
              {{ this.experienceName[0] }} <br>
              <span :class="isPhone ? 'merriweather-italic-20 no-translate' : 'merriweather-italic-24 no-translate'">{{ this.experienceName[1] }}</span>
            </div>
            <ModalGallery :lodging="this.lodging" :photoKeys="this.lodging.photos_keys" v-if="modalGallery"
              @close="modalGallery = false"></ModalGallery>
            <div class="banner-content-area">
              <div class="d-flex flex-column justify-content-center align-items-center text-center" :class="isPhone ? '' : 'mb-5'">
                <h1 class="text-center text-white mb-0 no-translate" :class="isPhone ? 'merriweather-reg-32' : 'merriweather-reg-40'">{{ this.lodging.name }}</h1>
                <div
                  v-if="Number(lodging.classification_outside_france) > 0"
                  class="d-flex standing justify-content-center text-white"
                >
                  <div
                    v-for="i in Number(lodging.classification_outside_france)"
                    :key="i"
                  >
                    <img
                      src="../../images/picto_logement_entier.svg"
                      alt="Classification - hors atout france"
                      style="width: 18px; height: 18px; margin: 0 2px;"
                    />
                  </div>
                </div>

                <div
                  v-else-if="Number(lodging.standing) > 0"
                  class="standing justify-content-center text-white"
                >
                  <i
                    v-for="i in Number(lodging.standing)"
                    :key="i"
                    class="fa-regular fa-star"
                  ></i>
                </div>
                <div class="btn-galerie" :class="isPhone ? 'mt-4' : 'mt-2'">
                  <div class="galerie-icon df-jsb-aic" @click="showModalGallery">
                    <img src="../../images/Galerie icone.svg" v-set-alt />
                    <p class="raleway-semi-p13 mb-0 ml-2 text-uppercase">Galerie</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- Horizontal Search Bar -->
            <div v-if="!isPhone && !eventLodging" class="horizontal-search-bar d-flex justify-content-center align-items-center mx-auto"
              :class="{ 'sticky-search-bar': showStickySearchBar }">
              <div class="search-bar-content px-5">
                <div class="search-bar-info">
                  <p class="search-bar-price raleway-reg-p16">A partir de <span class="raleway-semi-p16">{{ this.lodging.lowest_price }} EUR par nuit</span></p>
                </div>

                <div class="search-bar-inputs">
                  <div class="booking-header-dates">
                    <div class="date-block" @click="openPicker">
                      <div class="label raleway-semi-p16">Arrivée</div>
                      <div class="value raleway-medi-p16">{{ formatDateDisplay(disstartDate) || 'Quand ?' }}</div>
                    </div>
                    
                    <div class="date-block date-block-separator" @click="openPicker">
                      <div class="label raleway-semi-p16">Départ</div>
                      <div class="value raleway-medi-p16">{{ formatDateDisplay(disendDate) || 'Quand ?' }}</div>
                    </div>
                    
                    <div class="date-block">
                      <div class="label raleway-semi-p16">Voyageurs</div>
                      <div class="value raleway-medi-p16" @click="openOccupancySelector" style="cursor: pointer;">
                        {{ formatGuestDisplay() }}
                      </div>
                    </div>
                  </div>

                  <!-- Hidden date picker -->
                  <div style="position: absolute; top: 100%; left: 0; z-index: 1001; display: none;" ref="datePickerWrapper">
                    <CommonDatePicker :startingDateValue="disstartDate" :endingDateValue="disendDate" ref="datePicker"
                      @periodSelected="selectDates" :alwaysVisible="true" @datepickerClosed="submitAndClose"
                      :disabledDates="effectiveBlockedDates" />
                  </div>

                  <Guestinfo v-if="showGuestInfo" @ageSelected="updateChildAges" @increaseChilds="updateChildren"
                    @decreaseChilds="updateChildren" @increaseAdults="updateAdults" @decreaseAdults="updateAdults"
                    @closed="handleGuestInfoClose" @updatedGuestState="updateGuestStateInfo($event)" :initialAdults="adults" :initialChilds="children"
                    :initialChildAges="childAges" :ageErrorTrigger="guestAgeErrorTrigger" style="margin-top: 5px;" />

                  <div class="search-bar-button">
                    <button class="hortense-btn-primary search-btn"
                      @click="checkIfAvailableTwo(koediaFrom, koediaTo, guestNumber)" :disabled="isSearching">
                      {{ availabilitySearchButtonCaption }}
                    </button>
                    <label
                      v-if="showStickySearchBar && !lodging.is_entire"
                      class="search-bar-multiple-rooms-toggle raleway-reg-p13"
                    >
                      <input
                        type="checkbox"
                        v-model="selectMultipleRooms"
                      />
                      <span>Souhaitez-vous réserver plus d'une chambre ?</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div class="nav-lodging">
              <div class="menu-lodging">
                <div class="list-menu">
                  <p class="menu-item raleway-bold-p15 mb-0">
                    <a @click="showModalGallery">Galerie</a>
                  </p>
                  <p class="menu-item raleway-bold-p15 mb-0">
                    <a @click="scrollToElement('lodging-rooms-container')">CHAMBRES</a>
                  </p>
                  <p class="menu-item raleway-bold-p15 mb-0">
                    <a @click="scrollToElement('equipment-services')">LES ÉQUIPEMENTS ET SERVICES</a>
                  </p>
                  <p class="menu-item raleway-bold-p15 mb-0">
                    <a @click="scrollToElement('information-importantes')">LES INFORMATIONS PRATIQUES</a>
                  </p>
                  <p class="menu-item raleway-bold-p15 mb-0" v-if="this.lodging && this.lodging.ratings.length > 0">
                    <a @click="scrollToElement('traveler-reviews')">AVIS</a>
                  </p>
                  <p class="menu-item raleway-bold-p15 mb-0" v-if="!eventLodging">
                    <a @click="scrollToElement('lodge-experience-privileges')">LE CLUB HORTENSE</a>
                  </p>
                  <p class="menu-item raleway-bold-p15 mb-0" v-if="!eventLodging">
                    <a @click="scrollToElement('la-green-note')">LA GREEN NOTE</a>
                  </p>
                  <p class="menu-item raleway-bold-p15 mb-0" style="border-right: none;">
                    <a @click="scrollToElement('experiences-lodging')">LE CARNET D’ADRESSES</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div id="lodging-info" class="lodging-info pt-3 d-flex w-100 justify-content-between" :class="isPhone ? 'px-3' : 'px-5'">
        <div class="lodging-info-content">
          <div class="d-flex" :class="isPhone ? 'flex-column align-items-start' : 'align-items-center'">
            <div class="d-flex">
              <div class="lodge-type raleway-semi-p11 text-uppercase">
                {{ lodgeTypeMapping[lodging.type] || lodging.type }}
              </div>
              <span v-if="isPhone" class="mx-1">• </span>
              <div v-if="isPhone && !eventLodging" class="first d-flex align-items-center green_score_cont" data-aos="fade-left" data-aos-duration="900">
                <img v-if="this.lodging.score" class="mr-1" :src="greenNotePicto(this.lodging.score.toFixed())" style="width: 11px;height: 16px;" :alt="this.lodging.score.toFixed()" />
                <div class="content d-flex align-items-center" v-if="this.lodging.score">
                  <p class="raleway-semi-p11 text-green mb-0">GREEN NOTE</p>
                  <div class="note d-flex align-items-end ml-1">
                    <p class="raleway-semi-p16 mb-0">{{ this.lodging.score.toFixed() }}/</p>
                    <p class="raleway-medi-p11 mb-0 mr-1">10</p>
                    <p class="raleway-bold-p11 mb-0 text-uppercase">
                      {{ this.lodging.green_note_mention }}
                    </p>
                  </div>
                </div>
                <div class="content d-flex flex-column" v-else>
                  <p class="raleway-semi-p15 text-green mb-0">GREEN NOTE</p>
                  <div class="note d-flex align-items-end">
                    <p class="raleway-semi-p16 mb-0">_/</p>
                    <p class="raleway-medi-p11 mb-0 mr-2">10</p>
                    <p class="raleway-bold-p11 mb-0"></p>
                  </div>
                </div>
              </div>
            </div>
            <p class="raleway-reg-p15 mb-0" :class="isPhone ? 'mt-2' : 'ml-2'">
              <span v-if="!isPhone">•</span>
              Cet établissement propose {{ this.lodging.is_entire ? this.lodging.rooms_count : this.lodging.number_of_room }} {{ (this.lodging.is_entire ? this.lodging.rooms_count : this.lodging.number_of_room) == 1 ? 'chambre.' :
                'chambres.' }}
            </p>
            <div class="ml-2 d-flex" v-if="!isPhone && tripadvisorAllReviews.length">
              • <div class="d-flex align-items-center raleway-medi-p15 ml-2">
                  <i class="fa-solid fa-star ta-starr"></i>
                  <span class="raleway-semi-p15 ml-1">{{ (tripadvisorGlobalRating || 5) }}/5</span>

                  <a
                    :href="`/reservation-hotel/${lodging.slug}/avis`"
                    :target="isPhone ? '_self' : '_blank'"
                    :rel="isPhone ? null : 'noopener noreferrer'"
                    class="raleway-reg-p13 ta-muted ml-2"
                    style="cursor:pointer; text-decoration: underline; color: #707070;"
                  >
                    {{ (tripadvisorAllReviews.length || 0) }} avis
                  </a>
                </div>
            </div>
            <div v-else class="ml-1">
              • <a class="text-underline text-green raleway-semi-p15" @click="scrollToElement('lodging-rooms-container')">Voir les chambres</a>
            </div>
          </div>
          <div v-if="isPhone && lodging.ratings.length > 0" class="snd d-flex align-items-center mt-2 mb-3" data-aos="fade-right" data-aos-duration="900">
            <img src="../../images/Note.svg" class="mr-2" v-set-alt style="width: 25px; height: 30px;" />
            <div class="content">
              <p class="raleway-reg-p15 mb-0">Note des voyageurs</p>
              <div class="note d-flex">
                <i class="fa-solid fa-star ta-starr"></i>
                <p class="raleway-semi-p13 mb-0 ml-1">{{ this.lodging.lodging_description.rating_value || this.average
                  }}/
                </p>
                <p class="raleway-semi-p13 mb-0 mr-2">5</p>
                <a :href="'/reservation-hotel/' + this.lodging.slug + '/avis'" target="_blank" class="link-hortense raleway-semi-p14">
                  {{ this.lodging.ratings.length || 0 }} avis
                </a>
              </div>
            </div>
          </div>
          <div class="mt-2 d-flex">
            <p class="raleway-reg-p15">
              {{ this.lodging.address }}, {{ this.lodging.zip_code }},
              {{ this.city.name }}
              <span v-if="isPhone" class="raleway-reg-p15">, {{ fullLocation }}</span>
              <span v-if="isPhone">
                • <span class="text-underline text-green raleway-semi-p15 cursor-pointer" @click="displayMapfind">Voir sur la carte</span>
              </span>
            </p>
            <p class="raleway-reg-p15 mb-2 ml-2" v-if="!isPhone"><span class="raleway-semi-p15">• </span>{{ fullLocation }}</p>
            <p v-if="!isPhone" class="ml-2 mb-2 d-flex">
              • <p v-if="!isPhone" class="text-underline text-green raleway-semi-p15 cursor-pointer ml-1" @click="displayMapfind">Voir sur la carte</p>
            </p>
          </div>
          <portal to="modals">
          <Maplodgingshow v-if="showMapfind" :markers="this.markers" :selected-lodging="lodging"
            :nearby-lodgings="nearbyLodgings" @markerSelected="selectCard" @close="showMapfind = false"></Maplodgingshow>
          </portal>
        </div>
        <div class="lodging-info-content-right" v-if="!isPhone && !eventLodging">
          <div class="d-flex" style="gap: 10px;">
            <div class="first d-flex green_score_cont" data-aos="fade-left" data-aos-duration="900">
              <img v-if="this.lodging.score" :src="greenNotePicto(this.lodging.score.toFixed())" style="width: 23px;height: 33px;" :alt="this.lodging.score.toFixed()" />
              <div class="content d-flex flex-column" v-if="this.lodging.score">
                <p class="raleway-semi-p15 text-green mb-0">GREEN NOTE</p>
                <div class="note d-flex align-items-end">
                  <p class="raleway-medi-p20 mb-0">{{ this.lodging.score.toFixed() }}/</p>
                  <p class="raleway-medi-p13 mb-0 mr-2">10</p>
                  <p class="raleway-bold-p13 mb-0 text-uppercase">
                    {{ this.lodging.green_note_mention }}
                  </p>
                </div>
              </div>
              <div class="content d-flex flex-column" v-else>
                <p class="raleway-semi-p15 text-green mb-0">GREEN NOTE</p>
                <div class="note d-flex align-items-end">
                  <p class="raleway-medi-p20 mb-0">_/</p>
                  <p class="raleway-medi-p13 mb-0 mr-2">10</p>
                  <p class="raleway-bold-p13 mb-0"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 70% container wrapper -->
      <div class="main-content-wrapper d-flex">
        <div class="content-left">
          <div class="container-profil phone">
            <div id="container-profil">
              <div id="row-basicinfo">
                <div id="description" :class="isPhone ? '' : 'lodging-discover'">
                  <div class="accordion-header" @click.prevent="isExpand = !isExpand"
                    :class="this.isExpand ? 'active' : ''">
                    <h2 :class="isPhone ? 'merriweather-reg-20' : 'merriweather-reg-24'">A la découverte de l’hébergement</h2>
                  </div>
                  <h3 v-if="this.lodging.lodging_description.catch_sentence && this.lodging.lodging_description.catch_sentence != 'null'"
                    :class="isPhone ? 'merriweather-light-18' : 'merriweather-light-20'">{{ this.lodging.lodging_description.catch_sentence }}
                  </h3>
                  <div v-if="this.lodging.lodging_description.lodging_discover" class="accordion-body" :class="isExpand ? 'active' : ''">
                    <p class="raleway-reg-p15">
                      <!-- Display either truncated or full text based on showMore -->
                      <span v-if="!showMore">
                        {{ truncatedText(isPhone ? 150 : 550, this.lodging.lodging_description.lodging_discover) }}
                      </span>
                      <span v-else>
                        {{ this.lodging.lodging_description.lodging_discover }}
                      </span>
                    </p>

                    <!-- Show More / Show Less toggle -->
                    <button @click="toggleText" class="show-more-btn raleway-semi-p15 text-green text-underline pl-0">
                      {{ showMore ? 'Voir moins' : 'Voir plus' }}
                    </button>
                  </div>
                </div>
                <hr :class="isPhone ? 'my-4' : 'my-5'" />
                <div class="lodging-rooms-container">
                  <div class="lodging-entire-container">
                    <LodgingshowEntire ref="lodgingEntireComponent" :lodging="lodging" :user="user" :adults="adults" :initialChildAges="childAges"
                      @display-user-info="displayUserInfo" @display-user-info-koedia="displayUserInfoKoedia"
                      @open-guest-modal="openGuestModal" @show-modal="handleShowModal" @open-login-modal="openLoginModal"
                      @datesUpdated="handleDatesUpdated" @searchUpdated="handleSearchUpdated($event)"
                      @room-availability-updated="handleRoomAvailabilityUpdate" />
                  </div>
                  <LodgingshowRooms v-if="this.rooms.length" ref="lodgingRoomsComponent" :class="isPhone ? 'mt-3' : ''"
                    :lodging="this.lodging" :rooms="this.rooms" :entireLodging="this.lodging.is_entire" :adults="adults"
                    :initialChildAges="childAges" :selectMultipleRooms="selectMultipleRooms" :roomPlans="roomPlans"
                    @searchComplete="isSearching = false" @display-user-info="displayUserInfo"
                    @display-user-info-koedia="displayUserInfoKoedia" @open-guest-modal="openGuestModal" @room-availability-updated="handleRoomAvailabilityUpdate"
                    @open-date-picker="handleOpenDatePickerFromRooms" @reserve-multiple="handleReserveMultiple" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!eventLodging" class="content-right" :class="isPhone ? '' : 'pt-5'">
          <LodgingInfo v-if="!isPhone" :lodging="lodging" />
        </div>
      </div>
      <div class="secondary-content-wrapper">
        <hr class="mb-5" v-if="isPhone" />
        <div class="essential equipment-services" :class="isPhone ? 'px-3' : 'px-5'">
          <div class="row-essentials">
            <div class="col-description-services" v-if="this.lodging.is_entire">
              <div class="accordion-header"
                @click.prevent="isExpandDescriptionServices = !isExpandDescriptionServices"
                :class="this.isExpandDescriptionServices ? 'active' : ''">
                <h2 :class="isPhone ? 'merriweather-reg-20' : 'merriweather-reg-24'">Équipements et services</h2>
                <h3 :class="isPhone ? 'merriweather-light-18' : 'merriweather-light-20'">Des détails qui subliment votre séjour.</h3>
              </div>
              <div class="accordion-body" :class="this.isExpandDescriptionServices ? 'active' : ''">
                <div class="row-services-description">
                  <template v-for="(services, category, index) in (showAllServicesEntiers ? this.groupedServiceEntiers : limitedGroupedServiceEntiers)">
                    <div class="experience-categories" data-aos="fade-up" data-aos-duration="900" :key="index">
                      <h4 class="raleway-semi-p15 mb-2 text-uppercase">{{ category }}</h4>
                      <ul class="services-list">
                        <li v-for="service in services" :key="service.id">
                          <div class="list-services top">
                            <div class="service-item">
                              <p class="raleway-reg-p15 mb-0">{{ `${service.name} ${formatDispo(service.disponibility)}` }}</p>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </template>
                </div>
                <div v-if="categoryServiceEntiers.length > serviceCategoryLimit" class="mt-3">
                  <button @click="showAllServicesEntiers = !showAllServicesEntiers" class="show-more-btn raleway-semi-p15 text-green text-underline">
                    {{ showAllServicesEntiers ? 'VOIR MOINS' : 'VOIR PLUS' }}
                  </button>
                </div>
              </div>
            </div>
            <div class="col-description-services" v-else>
              <div class="accordion-header"
                @click.prevent="isExpandDescriptionServices = !isExpandDescriptionServices"
                :class="this.isExpandDescriptionServices ? 'active' : ''">
                <h2 :class="isPhone ? 'merriweather-reg-20' : 'merriweather-reg-24'">Équipements et services</h2>
                <h3 :class="isPhone ? 'merriweather-light-18' : 'merriweather-light-20'">Des détails qui subliment votre séjour.</h3>
              </div>
              <div class="accordion-body" :class="this.isExpandDescriptionServices ? 'active' : ''">
                <div class="row-services-description">
                  <template v-for="(services, category, index) in (showAllServices ? this.groupedServices : limitedGroupedServices)">
                    <div class="experience-categories" data-aos="fade-up" data-aos-duration="900" :key="index">
                      <h4 class="raleway-semi-p15 mb-2 text-uppercase">{{ category }}</h4>
                      <ul class="services-list">
                        <li v-for="service in services" :key="service.id">
                          <div class="list-services top">
                            <div class="service-item">
                              <p class="raleway-reg-p15 mb-0">
                                {{ `${service.name} ${formatDispo(service.disponibility)}` }}
                              </p>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </template>
                </div>
                <div v-if="categoryServices.length > serviceCategoryLimit" class="mt-3">
                  <button @click="showAllServices = !showAllServices" class="show-more-btn raleway-semi-p15 text-green text-underline">
                    {{ showAllServices ? 'VOIR MOINS' : 'VOIR PLUS' }}
                  </button>
                </div>
              </div>
            </div>
            <hr :class="isPhone ? 'my-5 w-100' : 'my-5 mx-5 w-100'"  v-if="kids_corners && kids_corners.length > 0" />
            <div class="lodge-kids-corner" v-if="kids_corners && kids_corners.length > 0" :class="isPhone ? '' : ''">
              <template>
                <div class="accordion-header" @click.prevent="isExpandKids = !isExpandKids"
                  :class="this.isExpandKids ? 'active' : ''">
                  <h4 class="raleway-semi-p15 mb-3">LE KIDS CORNER</h4>
                </div>
                <ul class="accordion-body kids-service-container" :class="this.isExpandKids ? 'active' : ''">
                  <li class="list-services" v-for="(service, index) in (showAllKids ? kids_corners : kids_corners.slice(0, itemsDisplayLength))" :key="service.id">
                    <div class="service-item">
                      <!-- <img :src="displayPicto(service)" :alt="service.name" /> -->
                      <p class="raleway-reg-p15 mb-0">{{ service.name }}</p>
                    </div>
                  </li>
                </ul>
              </template>
              <p v-if="kids_corners.length > itemsDisplayLength" class="mt-3">
                <button @click="showAllKids = !showAllKids" class="show-more-btn raleway-semi-p15 text-green text-underline">
                  {{ showAllKids ? 'VOIR MOINS' : 'VOIR PLUS' }}
                </button>
              </p>
            </div>
            <hr class="my-5 w-100" />
            <div class="information-importantes">
              <div class="accordion-header" @click.prevent="isExpandInfo = !isExpandInfo"
                :class="this.isExpandInfo ? 'active' : ''">
                <h2 :class="isPhone ? 'merriweather-reg-20' : 'merriweather-reg-24'">Informations importantes</h2>
                <h3 :class="isPhone ? 'merriweather-light-18' : 'merriweather-light-20'">Tout ce qu'il faut pour un séjour serein.</h3>
              </div>
              <div class="accordion-body" :class="[this.isExpandInfo ? 'active' : '', isPhone ? 'px-3' : '']">
                <ul class="list-info" data-aos="fade-up" data-aos-duration="900">
                  <template v-for="(item, index) in importantInfoItems">
                    <li :key="index" :class="item.class">
                      <template v-if="item.type === 'simple'">
                        {{ item.text }}
                      </template>
                      <template v-else-if="item.type === 'nested'">
                        {{ item.label }}
                        <ul class="languages-list">
                          <li v-for="(subItem, subIndex) in item.items" :key="subIndex" class="raleway-reg-p15 mb-0 payement">
                            {{ subItem }}
                          </li>
                        </ul>
                      </template>
                      <template v-else-if="item.type === 'with-paragraph'">
                        {{ item.label }}
                        <p class="raleway-reg-p15 pmr">
                          {{ item.text }}
                        </p>
                      </template>
                    </li>
                  </template>
                </ul>
              </div>
               <!-- <div class="mt-3">
                 <button @click="showAllInfo = !showAllInfo" class="show-more-btn raleway-semi-p15 text-green text-underline pl-0">
                   {{ showAllInfo ? 'VOIR MOINS' : 'VOIR PLUS' }}
                 </button>
               </div> -->
               <hr class="my-5 w-100" v-if="supplementsToDisplay.length > 0" />
                <!-- Tarifs et supplémentaires -->
                <div class="tarifs-supplements" v-if="supplementsToDisplay.length > 0">
                  <h2 :class="isPhone ? 'merriweather-reg-20' : 'merriweather-reg-24'">Tarifs &amp; suppléments</h2>
                  <h3 :class="isPhone ? 'merriweather-light-18' : 'merriweather-light-20'" class="supplements-subtitle">Prestations optionnelles disponibles à la réservation ou sur place.</h3>
                  <div class="supplements-table-wrapper">
                    <div
                      class="supplements-table"
                      :class="{ 'supplements-table--single': supplementsToDisplay.length === 1 }"
                    >
                      <div
                        v-for="(item, idx) in supplementsToDisplay"
                        :key="item.key"
                        class="supplement-col"
                        :class="{ 'supplement-col--last': idx === supplementsToDisplay.length - 1 }"
                      >
                        <img :src="item.iconSrc" :alt="item.label" class="supplement-col-icon" />
                        <p class="raleway-semi-p13 text-uppercase supplement-col-label">{{ item.label }}</p>
                        <p class="supplement-col-price">
                          <template v-if="item.price">{{ item.price }} €</template>
                          <template v-else>— €</template>
                        </p>
                        <p class="raleway-reg-p13 supplement-col-info" v-if="item.info">{{ item.info }}</p>
                        <p class="raleway-reg-p13 supplement-col-info" v-else>&nbsp;</p>
                        <div class="supplement-col-badges" v-if="item.selectionOptions && item.selectionOptions.length">
                          <span
                            v-for="selection in item.selectionOptions"
                            :key="`${item.key}-${selection}`"
                            class="supplement-col-badge"
                            :class="'supplement-badge--' + selection"
                          >
                            {{ getSupplementBadgeLabel(selection) }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
               <div v-if="this.lodging.lodging_profile.good_to_know && this.lodging.lodging_profile.good_to_know != ''"
                 class="d-flex flex-column align-items-start w-100 pt-3">
                   <h2 :class="isPhone ? 'merriweather-reg-20' : 'merriweather-reg-24'">Bon à savoir</h2>
                   <div class="w-100" :class="isPhone ? 'px-3' : ''">
                     <p class="raleway-reg-p15 good-2-know-content" v-html="this.lodging.lodging_profile.good_to_know"></p>
                   </div>
               </div>
             </div>
             <hr class="my-5 w-100" v-if="service_mesures && service_mesures.length > 0" />
             <div class="lodge-service-mesures" v-if="service_mesures && service_mesures.length > 0">
               <template v-if="service_mesures && service_mesures.length > 0">
                 <div class="accordion-header" @click.prevent="isExpandMesures = !isExpandMesures"
                   :class="this.isExpandMesures ? 'active' : ''">
                   <h2 class="mb-3" :class="isPhone ? 'merriweather-reg-20' : 'merriweather-reg-24'">Services sur mesure</h2>
                 </div>
                 <ul class="accordion-body service-mesures-container" :class="[this.isExpandMesures ? 'active' : '', isPhone ? 'mx-3' : 'mx-5']">
                   <li class="list-services" v-for="(service, index) in service_mesures" :key="service.id">
                     <div class="service-item">
                       <p class="raleway-reg-p15 mb-0">{{ service.name }}</p>
                     </div>
                   </li>
                 </ul>
               </template>
             </div>
          </div>
        </div>
        <hr class="mb-5" v-if="isPhone && showTripadvisorReviews && tripadvisorAllReviews.length" />
        <section
            v-if="showTripadvisorReviews && tripadvisorAllReviews.length"
            class="traveler-reviews mt-2"
            :class="isPhone ? 'px-3' : 'px-5'"
          >
            <div class="ta-section-header">
              <div
                class="ta-title-row d-flex"
                :class="isPhone ? 'align-items-center' : 'align-items-center'"
              >
                <h2 :class="isPhone ? 'merriweather-reg-20' : 'merriweather-reg-24'" class="mb-0">
                  Les avis des voyageurs
                </h2>

                <div class="ta-global-summary d-flex align-items-center raleway-medi-p20 ml-4">
                  <i class="fa-solid fa-star ta-starr"></i>
                  <span class="raleway-semi-p20 ml-1">{{ (tripadvisorGlobalRating || 5) }}/5</span>

                  <a
                    :href="`/reservation-hotel/${lodging.slug}/avis`"
                    :target="isPhone ? '_self' : '_blank'"
                    :rel="isPhone ? null : 'noopener noreferrer'"
                    class="raleway-reg-p13 ta-muted ml-2"
                    style="cursor:pointer; text-decoration: underline;"
                  >
                    {{ (tripadvisorAllReviews.length || 0) }} avis
                  </a>
                </div>
              </div>

              <h3 class="ta-subtitle" :class="isPhone ? 'merriweather-light-18' : 'merriweather-light-20'">
                La qualité de service, véritable signature des hôtes sélectionnés par Hortense
              </h3>
            </div>

            <div v-if="isPhone" class="traveler-reviews-scroll">
              <div
                v-for="(r, idx) in tripadvisorReviews"
                :key="reviewKey(r, idx)"
                class="ta-review-slide review-item"
              >
                <div class="ta-review-card" :class="{ 'is-expanded': isReviewExpanded(reviewKey(r, idx)) }">
                  <div class="ta-review-header d-flex justify-content-between align-items-start">
                    <div class="d-flex align-items-center">
                      <div class="ta-avatar text-green">{{ avatarLetter(r.user_name) }}</div>
                      <div class="ml-3">
                        <p class="raleway-semi-p15 mb-0">{{ r.user_name || "Voyageur" }}</p>
                        <p class="raleway-reg-p13 mb-0 ta-muted">{{ formatMonthYear(r.rated_at || r.created_at) }}</p>
                      </div>
                    </div>

                    <div class="d-flex align-items-center ta-rating">
                      <i class="fa-solid fa-star ta-star"></i>
                      <span class="raleway-semi-p15 ml-1">{{ (r.global || 5) }}/5</span>
                    </div>
                  </div>

                  <p v-if="r.source == 'tripadvisor'" class="raleway-semi-p15 mt-3 mb-2 ta-title text-uppercase">{{ r.title }}</p>

                  <p
                    class="raleway-reg-p15 mb-0 ta-content"
                    :class="{ 'is-clamped': !isReviewExpanded(reviewKey(r, idx)) }"
                  >
                    {{ r.review }}
                  </p>

                  <button
                    v-if="shouldShowReviewToggle(r)"
                    class="ta-see-more raleway-semi-p15 text-green text-underline pl-0"
                    @click.stop.prevent="toggleReview(reviewKey(r, idx))"
                    @touchstart.stop
                  >
                    {{ isReviewExpanded(reviewKey(r, idx)) ? "Voir moins" : "Voir plus" }}
                  </button>
                </div>
              </div>
            </div>

            <slither-slider
              v-else
              ref="taSlider"
              class="traveler-reviews-slider"
              :options="{
                numberOfSlides: 3,
                dots: false,
                controls: true,
                autoHeight: true,
              }"
            >
              <div
                v-for="(r, idx) in tripadvisorReviewsPadded"
                :key="reviewKeyy(r, idx)"
                class="ta-review-slide review-item"
              >
                <div class="ta-review-card" :class="{ 'is-expanded': isReviewExpanded(reviewKeyy(r, idx)) }">
                  <div class="ta-review-header d-flex justify-content-between align-items-start">
                    <div class="d-flex align-items-center">
                      <div class="ta-avatar text-green">{{ avatarLetter(r.user_name) }}</div>
                      <div class="ml-3">
                        <p class="raleway-semi-p15 mb-0">{{ r.user_name || "Voyageur" }}</p>
                        <p class="raleway-reg-p13 mb-0 ta-muted">
                          {{ formatMonthYear(r.rated_at || r.created_at) }}
                        </p>
                      </div>
                    </div>

                    <div class="d-flex align-items-center ta-rating">
                      <i class="fa-solid fa-star ta-star"></i>
                      <span class="raleway-semi-p15 ml-1">{{ (r.global || 5) }}/5</span>
                    </div>
                  </div>

                  <p v-if="r.source == 'tripadvisor'" class="raleway-semi-p15 mt-3 mb-2 ta-title text-uppercase">{{ r.title }}</p>

                  <p
                    class="raleway-reg-p15 mb-0 ta-content"
                    :class="{ 'is-clamped': !isReviewExpanded(reviewKeyy(r, idx)) }"
                  >
                    {{ r.review }}
                  </p>

                  <button
                    v-if="shouldShowReviewToggle(r)"
                    class="ta-see-more raleway-semi-p15 text-green text-underline pl-0"
                    @click.stop.prevent="toggleReview(reviewKeyy(r, idx))"
                    @pointerdown.stop
                    @mousedown.stop
                    @touchstart.stop
                  >
                    {{ isReviewExpanded(reviewKeyy(r, idx)) ? "Voir moins" : "Voir plus" }}
                  </button>
                </div>
              </div>

              <template slot="previous">
                <div class="circle-iconn previous-slide-buttonn">
                  <img src="../../images/arrow-left.svg" style="width: 26px !important; height: 15px !important;" alt="Previous" />
                </div>
              </template>

              <template slot="next">
                <div class="circle-iconn next-slide-buttonn" style="right: 4.5% !important">
                  <img src="../../images/arrow-right.svg" style="width: 26px !important; height: 15px !important;" alt="Next" />
                </div>
              </template>
            </slither-slider>

            <div class="ta-footer mt-3" style="text-align: center;">
              <div class="dicsover-lodging-state">
                <a
                  :href="'/reservation-hotel/' + lodging.slug + '/avis'"
                  class="hortense-btn-primary"
                  :target="isPhone ? '_self' : '_blank'"
                  :rel="isPhone ? null : 'noopener noreferrer'"
                >
                  Voir tous les avis
                </a>
              </div>
            </div>
          </section>
        <hr v-if="isPhone && !eventLodging" class="my-5" />
        <div v-if="!eventLodging" class="row admin-discover" :class="isPhone ? 'px-3' : 'px-5'">
          <div class="col-lg-12" v-if="this.lodging" data-aos="fade-up" data-aos-duration="900">
            <div class="accordion-header" @click.prevent="isExpandAdminDiscover = !isExpandAdminDiscover"
              :class="this.isExpandAdminDiscover ? 'active' : ''">
              <h2 :class="isPhone ? 'merriweather-reg-20' : 'merriweather-reg-24'">À la rencontre de vos hôtes</h2>
              <h3 :class="isPhone ? 'merriweather-light-18' : 'merriweather-light-20'">Entrez dans leur univers, et laissez-vous porter par leur hospitalité.</h3>
            </div>
            <div class="row accordion-body mt-3" :class="this.isExpandAdminDiscover ? 'active' : ''">
               <div class="col-lg-6 col-md-12" >
                <div class="d-flex host-card-container" :class="isPhone ? 'flex-column': ''" data-aos="fade-up" data-aos-duration="900">
                  <img :class="isPhone ? 'mb-2' : 'mr-3'" :src="this.lodging.photo_manager" v-set-alt />
                  <div class="d-flex flex-column justify-content-between host-content align-items-baseline">
                    <div class="manager-text-wrapper" :class="{ expanded: showMoreTwo }">
                      <p v-if="lodging.lodging_description.manager_name" class="mb-1 text-uppercase" :class="isPhone ? 'raleway-semi-p13' : 'raleway-semi-p15'">{{ lodging.lodging_description.manager_name }}</p>
                      <p v-if="lodging.lodging_description.manager_designation" class="mb-1" :class="isPhone ? 'raleway-it-l13' : 'raleway-it-l15'" style="color: #707070;">{{ lodging.lodging_description.manager_designation }}</p>
                      <p class="raleway-reg-p15 manager-text" :class="managerLineClampClass">{{ this.lodging.lodging_description.manager_meet }}</p>
                    </div>
                    <button v-if="lodging.lodging_description.manager_meet && lodging.lodging_description.manager_meet.length > 200" @click="toggleTextTwo" class="show-more-btn raleway-semi-p15 text-green text-underline pl-0">
                      {{ showMoreTwo ? 'VOIR MOINS' : 'VOIR PLUS' }}
                    </button>
                  </div>
                </div>
              </div>
               <div class="col-lg-6 col-md-12" :class="isPhone ? 'mt-3' : ''" v-if="lodging.lodging_description.chief_photo">
                <div class="d-flex host-card-container" :class="isPhone ? 'flex-column': ''" data-aos="fade-up" data-aos-duration="900">
                  <img :class="isPhone ? 'mb-2' : 'mr-3'" :src="this.lodging.lodging_description.chief_photo" v-set-alt />
                  <div class="d-flex flex-column justify-content-between host-content align-items-baseline">
                    <div class="chef-text-wrapper" :class="{ expanded: showMoreCheifIntro }">
                      <p v-if="lodging.lodging_description.chef_name" class="mb-1 text-uppercase" :class="isPhone ? 'raleway-semi-p13' : 'raleway-semi-p15'">{{ lodging.lodging_description.chef_name }}</p>
                      <p v-if="lodging.lodging_description.chef_designation" class="mb-1" :class="isPhone ? 'raleway-it-l13' : 'raleway-it-l15'" style="color: #707070;">{{ lodging.lodging_description.chef_designation }}</p>
                      <p class="raleway-reg-p15 chef-text" :class="chefLineClampClass">{{ this.lodging.lodging_description.chief_intro }}</p>
                    </div>
                    <button v-if="lodging.lodging_description.chief_intro.length > 200" @click="toggleTextChiefIntro" class="show-more-btn raleway-semi-p15 text-green text-underline pl-0">
                      {{ showMoreCheifIntro ? 'VOIR MOINS' : 'VOIR PLUS' }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr v-if="!eventLodging" :class="isPhone ? 'my-5' : 'mx-5 my-5'" />
        <LodgingshowExperienceAndPrivileges v-if="!eventLodging" class="lodge-experience-privileges" :lodging="this.lodging" :user="this.user"
          @open-signup="showSignupModal = true; showModalLogin = false;" @open-login="openLoginModal" />
        <hr v-if="isPhone && !eventLodging" class="my-5" :class="isPhone ? '' : 'mx-5'" />

        <LodgingshowGreenNote v-if="!eventLodging" :lodging="this.lodging" :isPhone="isPhone" />
        <div v-if="!eventLodging" class="container-profil greennote-lodge-container" :class="isPhone ? '' : 'px-5'">
          <ModalEnvironmentalPromise :description="this.lodging.lodging_description" v-if="showModalPromise"
            @close="showModalPromise = false"></ModalEnvironmentalPromise>
          <div class="greennote-lodging" data-aos="fade-up" data-aos-duration="900">
            <div :class="isPhone ? 'mx-3' : ''">
              <p class="raleway-reg-p15">Cette évaluation repose sur <span class="raleway-semi-p15">10 critères et 150 indicateurs d’éco-responsabilité</span>, elle offre aux voyageurs une lecture claire et transparente des actions menées par chaque hôte, pour un tourisme plus conscient et plus durable. Découvrez comment cet hébergement se distingue à travers les 10 critères de la Green Note, révélant son engagement environnemental.</p>
              <div class="row-slidenote green-notes-container" :class="isPhone ? 'd-flex pb-4' : 'mb-2'"  data-aos="fade-up" data-aos-duration="900">
                <div :class="isPhone ? '' : 'col-lg-5 col-xs-8 col-md-8'" >
                  <div class="full-note" :class="isPhone ? 'pl-0' : ''">
                    <div class="title-note d-flex">
                      <div class="d-flex align-items-center">
                        <p class="text-uppercase" :class="isPhone ? 'raleway-semi-p11' : 'raleway-semi-p13'">Politique et gestion environnementale</p>
                        <i class="fas fa-info-circle tooltip-icon ml-1"
                          @mouseenter="!isPhone && (activeGreenNoteTooltip = 'politique')"
                          @mouseleave="!isPhone && (activeGreenNoteTooltip = null)"
                          @click="isPhone && toggleTooltip('politique')"></i>
                        <div v-if="activeGreenNoteTooltip === 'politique' && !isPhone" class="tooltip-content"
                          @mouseenter="activeGreenNoteTooltip = 'politique'"
                          @mouseleave="activeGreenNoteTooltip = null">
                          <ul>
                            <li>Mettre en place une politique environnementale claire et écrite</li>
                            <li>Identifier les zones de gaspillage</li>
                            <li>Identifier les axes d'amélioration</li>
                            <li>Définir des plans d'actions à court, moyen et long terme</li>
                          </ul>
                        </div>
                      </div>
                      <div class="note d-flex" :class="isPhone ? 'raleway-reg-p9' : 'raleway-reg-p11'">
                        <img :src="getGreenNoteImage(this.pol)" :alt="`Green note ${this.pol}`" :style="isPhone ? { width: '11px', height: '16px', marginRight: '5px' } : { width: '15px', height: '22px', marginRight: '5px' }"/>
                        <p class="mb-0">{{ this.pol }}/</p>
                        <p class="mb-0 mr-2">10</p>
                      </div>
                    </div>
                    <div class="slide-note1">
                      <vue-slider :height="isPhone ? 14 : 15" class="raleway-reg-p15 green-note-slider" v-model="pol" v-bind="options"
                        ref="slider" disabled :processStyle="{ backgroundColor: getSliderColor(pol) }" />
                    </div>
                  </div>
                  <div class="full-note" :class="isPhone ? 'pl-0' : ''">
                    <div class="title-note d-flex">
                      <div class="d-flex align-items-center">
                        <p class="text-uppercase" :class="isPhone ? 'raleway-semi-p11' : 'raleway-semi-p13'">Responsabilité sociale</p>
                        <i class="fas fa-info-circle tooltip-icon ml-1"
                          @mouseenter="!isPhone && (activeGreenNoteTooltip = 'responsabilite')"
                          @mouseleave="!isPhone && (activeGreenNoteTooltip = null)"
                          @click="isPhone && toggleTooltip('responsabilite')"></i>
                        <div v-if="activeGreenNoteTooltip === 'responsabilite' && !isPhone" class="tooltip-content"
                          @mouseenter="activeGreenNoteTooltip = 'responsabilite'"
                          @mouseleave="activeGreenNoteTooltip = null">
                          <ul>
                            <li>Instaurer un dialogue social</li>
                            <li>Établir des solutions d'amélioration des conditions de travail</li>
                            <li>Évaluer son empreinte carbone</li>
                            <li>Mettre en place des mesures correctives</li>
                          </ul>
                        </div>
                      </div>
                      <div class="note d-flex" :class="isPhone ? 'raleway-reg-p9' : 'raleway-reg-p11'">
                        <img :src="getGreenNoteImage(this.soc)" :alt="`Green note ${this.soc}`" :style="isPhone ? { width: '11px', height: '16px', marginRight: '5px' } : { width: '15px', height: '22px', marginRight: '5px' }"/>
                        <p class="mb-0">{{ this.soc }}/</p>
                        <p class="mb-0 mr-2">10</p>
                      </div>
                    </div>
                    <div class="slide-note2">
                      <vue-slider :height="isPhone ? 14 : 15" class="raleway-reg-p15 green-note-slider" v-model="soc" v-bind="options"
                        ref="slider" disabled :processStyle="{ backgroundColor: getSliderColor(soc) }" />
                    </div>
                  </div>
                  <div class="full-note" :class="isPhone ? 'pl-0' : ''">
                    <div class="title-note d-flex">
                      <div class="d-flex align-items-center">
                        <p class="text-uppercase" :class="isPhone ? 'raleway-semi-p11' : 'raleway-semi-p13'">Formation du personnel</p>
                        <i class="fas fa-info-circle tooltip-icon ml-1"
                          @mouseenter="!isPhone && (activeGreenNoteTooltip = 'formation')"
                          @mouseleave="!isPhone && (activeGreenNoteTooltip = null)"
                          @click="isPhone && toggleTooltip('formation')"></i>
                        <div v-if="activeGreenNoteTooltip === 'formation' && !isPhone" class="tooltip-content"
                          @mouseenter="activeGreenNoteTooltip = 'formation'"
                          @mouseleave="activeGreenNoteTooltip = null">
                          <ul>
                            <li>Nommer un responsable de la gestion environnementale</li>
                            <li>Fédérer les équipes autour du développement durable</li>
                            <li>Former les salariés aux éco-gestes et aux bonnes pratiques de gestion durable</li>
                            <li>Organiser des réunions sur les questions environnementales</li>
                          </ul>
                        </div>
                      </div>
                      <div class="note d-flex" :class="isPhone ? 'raleway-reg-p9' : 'raleway-reg-p11'">
                        <img :src="getGreenNoteImage(this.per)" :alt="`Green note ${this.per}`" :style="isPhone ? { width: '11px', height: '16px', marginRight: '5px' } : { width: '15px', height: '22px', marginRight: '5px' }"/>
                        <p class="mb-0">{{ this.per }}/</p>
                        <p class="mb-0 mr-2">10</p>
                      </div>
                    </div>
                    <div class="slide-note3">
                      <vue-slider :height="isPhone ? 14 : 15" class="raleway-reg-p15 green-note-slider" v-model="per" v-bind="options"
                        ref="slider" disabled :processStyle="{ backgroundColor: getSliderColor(per) }" />
                    </div>
                  </div>
                  <div class="full-note   -note" :class="isPhone ? 'pl-0' : ''">
                    <div class="title-note d-flex">
                      <div class="d-flex align-items-center">
                        <p class="text-uppercase" :class="isPhone ? 'raleway-semi-p11' : 'raleway-semi-p13'">Sensibilisation des clients</p>
                        <i class="fas fa-info-circle tooltip-icon ml-1"
                          @mouseenter="!isPhone && (activeGreenNoteTooltip = 'sensibilisation')"
                          @mouseleave="!isPhone && (activeGreenNoteTooltip = null)"
                          @click="isPhone && toggleTooltip('sensibilisation')"></i>
                        <div v-if="activeGreenNoteTooltip === 'sensibilisation' && !isPhone" class="tooltip-content"
                          @mouseenter="activeGreenNoteTooltip = 'sensibilisation'"
                          @mouseleave="activeGreenNoteTooltip = null">
                          <ul>
                            <li>Information des clients sur la politique environnementale de l'hébergement</li>
                            <li>Proposer des activités respectueuses de l'environnement</li>
                            <li>Afficher les éco-gestes</li>
                            <li>Informer les clients sur les modes de transport les moins polluants pour leurs
                              déplacements</li>
                          </ul>
                        </div>
                      </div>
                      <div class="note d-flex" :class="isPhone ? 'raleway-reg-p9' : 'raleway-reg-p11'">
                        <img :src="getGreenNoteImage(this.cli)" :alt="`Green note ${this.cli}`" :style="isPhone ? { width: '11px', height: '16px', marginRight: '5px' } : { width: '15px', height: '22px', marginRight: '5px' }"/>
                        <p class="mb-0">{{ this.cli }}/</p>
                        <p class="mb-0 mr-2">10</p>
                      </div>
                    </div>
                    <div class="slide-note4">
                      <vue-slider :height="isPhone ? 14 : 15" class="raleway-reg-p15 green-note-slider" v-model="cli" v-bind="options"
                        ref="slider" disabled :processStyle="{ backgroundColor: getSliderColor(cli) }" />
                    </div>
                  </div>
                  <div class="full-note     note" :class="isPhone ? 'pl-0' : ''">
                    <div class="title-note d-flex">
                      <div class="d-flex align-items-center">
                        <p class="text-uppercase" :class="isPhone ? 'raleway-semi-p11' : 'raleway-semi-p13'">Politique d'achats responsables</p>
                        <i class="fas fa-info-circle tooltip-icon ml-1"
                          @mouseenter="!isPhone && (activeGreenNoteTooltip = 'achats')"
                          @mouseleave="!isPhone && (activeGreenNoteTooltip = null)"
                          @click="isPhone && toggleTooltip('achats')"></i>
                        <div v-if="activeGreenNoteTooltip === 'achats' && !isPhone" class="tooltip-content"
                          @mouseenter="activeGreenNoteTooltip = 'achats'" @mouseleave="activeGreenNoteTooltip = null">
                          <ul>
                            <li>Acheter des produits (alimentation, entretien, papeterie, mobilier, autres achats) en
                              circuit
                              court</li>
                            <li>Privilégier les produits biologiques/durables et de saison</li>
                            <li>Privilégier les emballages recyclables</li>
                            <li>Éviter les emballages individuels</li>
                          </ul>
                        </div>
                      </div>
                      <div class="note d-flex" :class="isPhone ? 'raleway-reg-p9' : 'raleway-reg-p11'">
                        <img :src="getGreenNoteImage(this.ach)" :alt="`Green note ${this.ach}`" :style="isPhone ? { width: '11px', height: '16px', marginRight: '5px' } : { width: '15px', height: '22px', marginRight: '5px' }"/>
                        <p class="mb-0">{{ this.ach }}/</p>
                        <p class="mb-0 mr-2">10</p>
                      </div>
                    </div>
                    <div class="slide-note5">
                      <vue-slider :height="isPhone ? 14 : 15" class="raleway-reg-p15 green-note-slider" v-model="ach" v-bind="options"
                        ref="slider" disabled :processStyle="{ backgroundColor: getSliderColor(ach) }" />
                    </div>
                  </div>
                </div>
                <div :class="isPhone ? 'pr-3' : 'col-lg-5 col-xs-8 col-md-8'" >
                  <div class="full-note">
                    <div class="title-note d-flex">
                      <div class="d-flex align-items-center">
                        <p class="text-uppercase" :class="isPhone ? 'raleway-semi-p11' : 'raleway-semi-p13'">Gestion de l'eau</p>
                        <i class="fas fa-info-circle tooltip-icon ml-1"
                          @mouseenter="!isPhone && (activeGreenNoteTooltip = 'eau')"
                          @mouseleave="!isPhone && (activeGreenNoteTooltip = null)"
                          @click="isPhone && toggleTooltip('eau')"></i>
                        <div v-if="activeGreenNoteTooltip === 'eau' && !isPhone" class="tooltip-content"
                          @mouseenter="activeGreenNoteTooltip = 'eau'" @mouseleave="activeGreenNoteTooltip = null">
                          <ul>
                            <li>Mettre en place un suivi de la consommation</li>
                            <li>Réduire la consommation d'eau par nuitée</li>
                            <li>Collecter et traiter les eaux usées</li>
                            <li>Réduire la pollution</li>
                          </ul>
                        </div>
                      </div>
                      <div class="note d-flex" :class="isPhone ? 'raleway-reg-p9' : 'raleway-reg-p11'">
                        <img :src="getGreenNoteImage(this.eau)" :alt="`Green note ${this.eau}`" :style="isPhone ? { width: '11px', height: '16px', marginRight: '5px' } : { width: '15px', height: '22px', marginRight: '5px' }"/>
                        <p class="mb-0">{{ this.eau }}/</p>
                        <p class="mb-0 mr-2">10</p>
                      </div>
                    </div>
                    <div class="slide-note6">
                      <vue-slider  :height="isPhone ? 14 : 15" class="raleway-reg-p15 green-note-slider" v-model="eau" v-bind="options"
                        ref="slider" disabled :processStyle="{ backgroundColor: getSliderColor(eau) }" />
                    </div>
                  </div>
                  <div class="full-note">
                    <div class="title-note d-flex">
                      <div class="d-flex align-items-center">
                        <p class="text-uppercase" :class="isPhone ? 'raleway-semi-p11' : 'raleway-semi-p13'">Gestion des déchets</p>
                        <i class="fas fa-info-circle tooltip-icon ml-1"
                          @mouseenter="!isPhone && (activeGreenNoteTooltip = 'dechets')"
                          @mouseleave="!isPhone && (activeGreenNoteTooltip = null)"
                          @click="isPhone && toggleTooltip('dechets')"></i>
                        <div v-if="activeGreenNoteTooltip === 'dechets' && !isPhone" class="tooltip-content"
                          @mouseenter="activeGreenNoteTooltip = 'dechets'"
                          @mouseleave="activeGreenNoteTooltip = null">
                          <ul>
                            <li>Tri et recyclage des déchets</li>
                            <li>Réduction des volumes de déchets à la source</li>
                            <li>Réutilisation des déchets produits et recherche d'utilisations alternatives</li>
                            <li>Offrir les surplus alimentaires à des organismes de charité</li>
                          </ul>
                        </div>
                      </div>
                      <div class="note d-flex" :class="isPhone ? 'raleway-reg-p9' : 'raleway-reg-p11'">
                        <img :src="getGreenNoteImage(this.dec)" :alt="`Green note ${this.dec}`" :style="isPhone ? { width: '11px', height: '16px', marginRight: '5px' } : { width: '15px', height: '22px', marginRight: '5px' }"/>
                        <p class="mb-0">{{ this.dec }}/</p>
                        <p class="mb-0 mr-2">10</p>
                      </div>
                    </div>
                    <div class="slide-note7">
                      <vue-slider :height="isPhone ? 14 : 15" class="raleway-reg-p15 green-note-slider" v-model="dec" v-bind="options"
                        ref="slider" disabled :processStyle="{ backgroundColor: getSliderColor(dec) }" />
                    </div>
                  </div>
                  <div class="full-note">
                    <div class="title-note d-flex">
                      <div class="d-flex align-items-center">
                        <p class="text-uppercase" :class="isPhone ? 'raleway-semi-p11' : 'raleway-semi-p13'">Gestion de l'énergie</p>
                        <i class="fas fa-info-circle tooltip-icon ml-1"
                          @mouseenter="!isPhone && (activeGreenNoteTooltip = 'energie')"
                          @mouseleave="!isPhone && (activeGreenNoteTooltip = null)"
                          @click="isPhone && toggleTooltip('energie')"></i>
                        <div v-if="activeGreenNoteTooltip === 'energie' && !isPhone" class="tooltip-content"
                          @mouseenter="activeGreenNoteTooltip = 'energie'"
                          @mouseleave="activeGreenNoteTooltip = null">
                          <ul>
                            <li>Mettre en place un suivi de la consommation</li>
                            <li>Mettre en place une isolation thermique efficace</li>
                            <li>Diminuer la consommation d'énergie par nuitée</li>
                            <li>Augmenter la part des énergies renouvelables</li>
                          </ul>
                        </div>
                      </div>
                      <div class="note d-flex" :class="isPhone ? 'raleway-reg-p9' : 'raleway-reg-p11'">
                        <img :src="getGreenNoteImage(this.ene)" :alt="`Green note ${this.ene}`" :style="isPhone ? { width: '11px', height: '16px', marginRight: '5px' } : { width: '15px', height: '22px', marginRight: '5px' }"/>
                        <p class="mb-0">{{ this.ene }}/</p>
                        <p class="mb-0 mr-2">10</p>
                      </div>
                    </div>
                    <div class="slide-note8">
                      <vue-slider :height="isPhone ? 14 : 15" class="raleway-reg-p15 green-note-slider" v-model="ene" v-bind="options"
                        ref="slider" disabled :processStyle="{ backgroundColor: getSliderColor(ene) }" />
                    </div>
                  </div>
                  <div class="full-note bottom-note">
                    <div class="title-note d-flex">
                      <div class="d-flex align-items-center">
                        <p class="text-uppercase" :class="isPhone ? 'raleway-semi-p11' : 'raleway-semi-p13'">Eco-construction</p>
                        <i class="fas fa-info-circle tooltip-icon ml-1"
                          @mouseenter="!isPhone && (activeGreenNoteTooltip = 'construction')"
                          @mouseleave="!isPhone && (activeGreenNoteTooltip = null)"
                          @click="isPhone && toggleTooltip('construction')"></i>
                        <div v-if="activeGreenNoteTooltip === 'construction' && !isPhone" class="tooltip-content"
                          @mouseenter="activeGreenNoteTooltip = 'construction'"
                          @mouseleave="activeGreenNoteTooltip = null">
                          <ul>
                            <li>Favoriser les constructions et les rénovations durables (label HQE)</li>
                            <li>Améliorer l'intégration paysagère des hébergements</li>
                            <li>Privilégier la plantation d'espèces végétales locales</li>
                            <li>Mettre en place des systèmes de production d'énergie renouvelable</li>
                          </ul>
                        </div>
                      </div>
                      <div class="note d-flex" :class="isPhone ? 'raleway-reg-p9' : 'raleway-reg-p11'">
                        <img :src="getGreenNoteImage(this.con)" :alt="`Green note ${this.con}`" :style="isPhone ? { width: '11px', height: '16px', marginRight: '5px' } : { width: '15px', height: '22px', marginRight: '5px' }"/>
                        <p class="mb-0">{{ this.con }}/</p>
                        <p class="mb-0 mr-2">10</p>
                      </div>
                    </div>
                    <div class="slide-note9">
                      <vue-slider :height="isPhone ? 14 : 15" class="raleway-reg-p15 green-note-slider" v-model="con" v-bind="options"
                        ref="slider" disabled :processStyle="{ backgroundColor: getSliderColor(con) }" />
                    </div>
                  </div>
                  <div class="full-note bottom-note">
                    <div class="title-note d-flex">
                      <div class="d-flex align-items-center">
                        <p class="text-uppercase" :class="isPhone ? 'raleway-semi-p11' : 'raleway-semi-p13'">Environnement extérieur et intérieur</p>
                        <i class="fas fa-info-circle tooltip-icon ml-1"
                          @mouseenter="!isPhone && (activeGreenNoteTooltip = 'environnement')"
                          @mouseleave="!isPhone && (activeGreenNoteTooltip = null)"
                          @click="isPhone && toggleTooltip('environnement')"></i>
                        <div v-if="activeGreenNoteTooltip === 'environnement' && !isPhone" class="tooltip-content"
                          @mouseenter="activeGreenNoteTooltip = 'environnement'"
                          @mouseleave="activeGreenNoteTooltip = null">
                          <ul>
                            <li>Aménager des espaces verts</li>
                            <li>Entretenir les espaces verts</li>
                            <li>Ne pas utiliser de produits chimiques polluants</li>
                            <li>Limiter le tabagisme dans les espaces communs et dans les chambres</li>
                          </ul>
                        </div>
                      </div>
                      <div class="note d-flex" :class="isPhone ? 'raleway-reg-p9' : 'raleway-reg-p11'">
                        <img :src="getGreenNoteImage(this.env)" :alt="`Green note ${this.env}`" :style="isPhone ? { width: '11px', height: '16px', marginRight: '5px' } : { width: '15px', height: '22px', marginRight: '5px' }"/>
                        <p class="mb-0">{{ this.env }}/</p>
                        <p class="mb-0 mr-2">10</p>
                      </div>
                    </div>
                    <div class="slide-note10">
                      <vue-slider :height="isPhone ? 14 : 15" class="raleway-reg-p15 green-note-slider" v-model="env" v-bind="options"
                        ref="slider" disabled :processStyle="{ backgroundColor: getSliderColor(env) }" />
                    </div>
                  </div>
                </div>
              </div>

              <!-- Mobile Green Note Tooltip Portal -->
              <div v-if="activeGreenNoteTooltip && isPhone" class="mobile-tooltip-portal"
                @click="activeGreenNoteTooltip = null">
                <div class="tooltip-content mobile-tooltip" @click.stop>
                  <div class="mobile-tooltip-header">
                    <button class="mobile-tooltip-close" @click="activeGreenNoteTooltip = null">×</button>
                  </div>
                  <ul v-if="activeGreenNoteTooltip === 'politique'">
                    <li>Mettre en place une politique environnementale claire et écrite</li>
                    <li>Identifier les zones de gaspillage</li>
                    <li>Identifier les axes d'amélioration</li>
                    <li>Définir des plans d'actions à court, moyen et long terme</li>
                  </ul>
                  <ul v-else-if="activeGreenNoteTooltip === 'responsabilite'">
                    <li>Instaurer un dialogue social</li>
                    <li>Établir des solutions d'amélioration des conditions de travail</li>
                    <li>Évaluer son empreinte carbone</li>
                    <li>Mettre en place des mesures correctives</li>
                  </ul>
                  <ul v-else-if="activeGreenNoteTooltip === 'formation'">
                    <li>Nommer un responsable de la gestion environnementale</li>
                    <li>Fédérer les équipes autour du développement durable</li>
                    <li>Former les salariés aux éco-gestes et aux bonnes pratiques de gestion durable</li>
                    <li>Organiser des réunions sur les questions environnementales</li>
                  </ul>
                  <ul v-else-if="activeGreenNoteTooltip === 'sensibilisation'">
                    <li>Information des clients sur la politique environnementale de l'hébergement</li>
                    <li>Proposer des activités respectueuses de l'environnement</li>
                    <li>Afficher les éco-gestes</li>
                    <li>Informer les clients sur les modes de transport les moins polluants pour leurs déplacements
                    </li>
                  </ul>
                  <ul v-else-if="activeGreenNoteTooltip === 'achats'">
                    <li>Acheter des produits (alimentation, entretien, papeterie, mobilier, autres achats) en circuit
                      court</li>
                    <li>Privilégier les produits biologiques/durables et de saison</li>
                    <li>Privilégier les emballages recyclables</li>
                    <li>Éviter les emballages individuels</li>
                  </ul>
                  <ul v-else-if="activeGreenNoteTooltip === 'eau'">
                    <li>Mettre en place un suivi de la consommation</li>
                    <li>Réduire la consommation d'eau par nuitée</li>
                    <li>Collecter et traiter les eaux usées</li>
                    <li>Réduire la pollution</li>
                  </ul>
                  <ul v-else-if="activeGreenNoteTooltip === 'dechets'">
                    <li>Tri et recyclage des déchets</li>
                    <li>Réduction des volumes de déchets à la source</li>
                    <li>Réutilisation des déchets produits et recherche d'utilisations alternatives</li>
                    <li>Offrir les surplus alimentaires à des organismes de charité</li>
                  </ul>
                  <ul v-else-if="activeGreenNoteTooltip === 'energie'">
                    <li>Mettre en place un suivi de la consommation</li>
                    <li>Mettre en place une isolation thermique efficace</li>
                    <li>Diminuer la consommation d'énergie par nuitée</li>
                    <li>Augmenter la part des énergies renouvelables</li>
                  </ul>
                  <ul v-else-if="activeGreenNoteTooltip === 'construction'">
                    <li>Favoriser les constructions et les rénovations durables (label HQE)</li>
                    <li>Améliorer l'intégration paysagère des hébergements</li>
                    <li>Privilégier la plantation d'espèces végétales locales</li>
                    <li>Mettre en place des systèmes de production d'énergie renouvelable</li>
                  </ul>
                  <ul v-else-if="activeGreenNoteTooltip === 'environnement'">
                    <li>Aménager des espaces verts</li>
                    <li>Entretenir les espaces verts</li>
                    <li>Ne pas utiliser de produits chimiques polluants</li>
                    <li>Limiter le tabagisme dans les espaces communs et dans les chambres</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="label-environment" :class="isPhone ? 'px-3' : 'px-5'" v-if="environmentImagesExists">
          <h2 :class="isPhone ? 'raleway-semi-p15' : 'raleway-semi-p20'">LABELS ENVIRONNEMENTAUX</h2>
          <div class="d-flex label-environment-items" :class="isPhone ? '' : 'pl-5 pt-4'" data-aos="fade-up" data-aos-duration="900">
            <div class="item-data" v-if="lodging.lodging_description.green_globe">
              <img src="../../images/green_globe.png" v-set-alt class="img-fluid"
                style="width: 100px; height: 100px;">
              <span :class="isPhone ? 'raleway-semi-p11 text-center' : 'raleway-semi-p15'">GREEN GLOBE</span>
            </div>
            <div class="item-data" v-if="lodging.lodging_description.green_key">
              <img src="../../images/verte.png" v-set-alt class="img-fluid"
                style="width: 100px; height: 100px;">
              <span :class="isPhone ? 'raleway-semi-p11 text-center' : 'raleway-semi-p15'">LA CLEF VERTE</span>
            </div>
            <div class="item-data" v-if="lodging.lodging_description.ecolabel">
              <img src="../../images/eco_label.png" v-set-alt class="img-fluid"
                style="width: 100px; height: 100px;">
              <span :class="isPhone ? 'raleway-semi-p11 text-center' : 'raleway-semi-p15'">ECO LABEL</span>
            </div>
          </div>
          <!-- <img src="../../images/Label.svg" class="label" v-set-alt> -->
        </div>

        <div v-if="!eventLodging" class="col-lg-12" :class="isPhone ? 'px-3 pt-5' : 'px-5 pt-5'">
          <div class="" v-if="this.lodging.lodging_description.environmental_promise">
            <h2 class="mb-3" :class="isPhone ? 'raleway-semi-p15' : 'raleway-semi-p20'">LEUR PROMESSE ENVIRONNEMENTALE</h2>
            <p class="raleway-it-l15 mb-3">
              «
              {{ this.lodging.lodging_description.environmental_promise }} »<br />
            </p>
            <!-- Voir plus / Voir moins button for mobile -->
            <div v-if="isPhone" class="mb-3">
              <button @click="toggleEnvironmentalPromise" class="show-more-btn raleway-semi-p15 text-green text-underline pl-0">
                {{ showEnvironmentalPromise ? 'Voir moins' : 'Voir plus' }}
              </button>
            </div>
            <!-- Show sections only on desktop or when expanded on mobile -->
            <div v-if="!isPhone || showEnvironmentalPromise" class="row" :class="isPhone ? 'px-3 pb-4' : 'px-5'" data-aos="fade-up" data-aos-duration="900">
              <div class="promise-conditions-container col-lg-5 col-md-12" v-if="this.lodging.lodging_description.pros">
                <div class="d-flex flex-column align-items-start promise-conditions">
                  <p class="raleway-semi-p15">LES POINTS FORTS DE CET HÉBERGEMENT</p>
                  <pre class="raleway-reg-p15" v-html="this.lodging.lodging_description.pros"></pre>
                </div>
              </div>
              <div class="col-lg-1"></div>
              <div v-if="this.lodging.lodging_description.future_action" class="promise-conditions-container col-lg-5 col-md-12" :class="isPhone ? 'mt-2' : ''">
                <div class="d-flex flex-column align-items-start promise-conditions">
                  <p class="raleway-semi-p15 mb-0">LES ACTIONS FUTURES</p>
                  <pre class="raleway-reg-p15" v-html="this.lodging.lodging_description.future_action"></pre>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr :class="isPhone ? 'py-3' : 'mx-5 my-5'" />
        <div class="w-100">
          <LodgingExperience :lodging="this.lodging" :isPhone="isPhone" />
        </div>
        <div id="lodging-resto">
          <div class="hortense-fav" data-aos="fade" data-aos-duration="900">
            <p class="text-uppercase" :class="isPhone ? 'raleway-semi-p15' : 'raleway-semi-p20'">Le coup de cœur de Hortense</p>
            <p v-if="this.lodging.lodging_description.hortense_crush && this.lodging.lodging_description.hortense_crush !== 'null'" class="text-center hortense-crush" :class="isPhone ? 'mx-3 merriweather-italic-15' : 'merriweather-italic-20'">
              « {{ this.lodging.lodging_description.hortense_crush }} »
            </p>
          </div>
        </div>
        <!-- <hr :class="isPhone ? 'py-3' : 'mx-5 my-5'" /> -->
        <!-- <hr
          v-if="showTripadvisorReviews && tripadvisorAllReviews.length"
          :class="isPhone ? 'py-3' : 'mx-5 my-5'"
        /> -->

        <hr v-if="isPhone" :class="isPhone ? 'py-3' : 'mx-5 my-5'" />


        <div data-aos="fade-up" data-aos-duration="900" class="lodging-header-container mt-4">
          <div class=" col-description-services">
            <div class="accordion-header" @click.prevent="isExpandCarnetAddress = !isExpandCarnetAddress"
              :class="this.isExpandCarnetAddress ? 'active' : ''">
              <h2 class="col-margin" :class="isPhone ? 'merriweather-reg-20' : 'merriweather-reg-24'">Le carnet d'adresses</h2>
            </div>

            <div class="accordion-body" :class="this.isExpandCarnetAddress ? 'active' : ''">
              <div class="lodging-header">
                <div class="d-flex align-items-baseline">
                  <h3 class="merriweather-light-18 mb-0">Découvrez des expériences authentiques à proximité de cet
                    établissement. <a class="raleway-semi-p15 text-green text-underline pl-0 cursor-pointer" @click="displayExperienceMap">Voir sur la carte</a>
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        <LodgingShowPhone :experiences="this.lodging.experiences" :carnetAdress="this.lodging.address_book"
          :user="user" v-if="this.targetShare" class="accordion-body"
          :class="this.isExpandCarnetAddress ? 'active' : ''" @showExperienceOnMap="showExperienceOnMap">
        </LodgingShowPhone>
        <div id="experiences-lodging" class="experiences-lodging mt-4" data-aos="fade-up" data-aos-duration="900"
          v-if="!this.targetShare">
          <div :class="isPhone ? 'px-3' : 'px-5'">
            <div class="row d-flex justify-content-around">
              <div class=" col-lg-12 pt-2">
                <div class="lodging-header-desktop">

                  <h2 class="title-first" :class="isPhone ? 'merriweather-reg-20' : 'merriweather-reg-24'">Le carnet d'adresses</h2>
                  <div class="d-flex align-items-baseline">
                    <h3 class="merriweather-light-20 mb-0">Découvrez des expériences authentiques à proximité de cet
                      établissement.
                    </h3>
                    <a class="raleway-semi-p15 ml-2 text-green text-underline cursor-pointer" @click="displayExperienceMap">Voir sur la carte</a>
                  </div>
                </div>
                <div class="exp-filter">
                  <ul class="filter-exp">
                    <li>
                      <a class="exp-category active" href="#" @click.prevent="selectOption">
                        <p class="raleway-reg-p15" data-value="culturelles">culturelles</p>
                      </a>
                    </li>
                    <li>
                      <a class="exp-category" href="#" @click.prevent="selectOption">
                        <p class="raleway-reg-p15" data-value="au naturel">au naturel</p>
                      </a>
                    </li>
                    <li>
                      <a class="exp-category" href="#" @click.prevent="selectOption">
                        <p class="raleway-reg-p15" data-value="au bord de l'eau">au bord de l'eau</p>
                      </a>
                    </li>
                    <li>
                      <a class="exp-category" href="#" @click.prevent="selectOption">
                        <p class="raleway-reg-p15" data-value="sportives">sportives</p>
                      </a>
                    </li>
                    <li>
                      <a class="exp-category" href="#" @click.prevent="selectOption">
                        <p class="raleway-reg-p15" data-value="immersives">immersives</p>
                      </a>
                    </li>
                    <li>
                      <a class="exp-category" href="#" @click.prevent="selectOption">
                        <p class="raleway-reg-p15" data-value="culinaires">culinaires</p>
                      </a>
                    </li>
                    <li>
                      <a class="exp-category" href="#" @click.prevent="selectOption">
                        <p class="raleway-reg-p15" data-value="diy">DIY</p>
                      </a>
                    </li>
                    <li>
                      <a class="exp-category" href="#" @click.prevent="selectOption">
                        <p class="raleway-reg-p16" data-value="oenologiques">oenologiques</p>
                      </a>
                    </li>
                  </ul>
                </div>

                <slither-slider v-if="experiencesFiltered && experiencesFiltered.length > 0" ref="slither" class="px-5"
                  :options="{ numberOfSlides: 2, dots: false, controls: true }">
                  <div v-for="experience in experiencesFiltered" :key="experience.id">
                    <Cardexplodging :experience="experience" :user="isUserConnected()"
                      @connection="$emit('connection')" @showOnMap="showExperienceOnMap"></Cardexplodging>
                  </div>
                  <template slot="previous">
                    <div class="circle-icon previous-slide-button">
                      <img src="../../images/arrow-left.svg" alt="Previous" />
                    </div>
                  </template>
                  <template slot="next">
                    <div class="circle-icon next-slide-button">
                      <img src="../../images/arrow-right.svg" alt="Next" />
                    </div>
                  </template>
                </slither-slider>

                <br />
                <div class="dicsover-lodging-state" v-if="lodging.address_book">
                  <a :href="'/' + lodging.address_book.slug" class="hortense-btn-primary" target="_blank">
                    DÉCOUVREZ NOTRE CARNET D'ADRESSES
                  </a>
                </div>
                <br />
                <div class="col-lg-12 no-experience" v-if="experiencesFiltered && experiencesFiltered.length == 0">
                  <p class="raleway-reg-p15 text-center">
                    Hortense est à la recherche d'expériences à vous proposer près de cet hébergement
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr :class="isPhone ? 'py-3' : 'mx-5 my-5'" />
        <div class="container-region my-5"
          v-if="lodging && lodging.region && lodging.region.photo && hasTravelGuideLink" data-aos="fade-up"
          data-aos-duration="900" :style="{ backgroundImage: 'url(' + lodging.region.photo + ')' }">
          <div class="image-gradient-bottom"></div>
          <div class="w-100 main-content"
            :class="lodging.lodging_description && !lodging.lodging_description.travel_guide_image && isPhone ? 'py-4' : ''">
            <div class="d-flex flex-md-row flex-column align-items-center h-100 w-100"
              :class="lodging.lodging_description && !lodging.lodging_description.travel_guide_image ? 'pl-5' : ''">
              <div v-if="lodging.lodging_description && lodging.lodging_description.travel_guide_image"
                class="container-region-img py-5">
                <img :src="lodging.lodging_description.travel_guide_image" v-set-alt />
              </div>

              <div class="d-flex flex-column align-items-start" :class="isPhone ? 'align-items-center' : ' pt-3'">
                <p class="raleway-medi-p20">Découvrir la région</p>

                <p class="raleway-reg-p15">
                  {{ lodging.region && lodging.region.content ? lodging.region.content : '' }}
                </p>

                <div v-if="hasTravelGuideLink && user" class="d-flex flex-column align-items-start mt-4"
                  :class="isPhone ? 'align-items-center' : ''">
                  <a v-if="lodging.lodging_description && lodging.lodging_description.travel_guide_link"
                    :href="lodging.lodging_description.travel_guide_link" target="_blank"
                    class="hortense-btn-primary">
                    Découvrir mon guide
                  </a>
                  <p class="raleway-reg-p15 mt-4">
                    Lors de la confirmation de votre réservation, vous avez la possibilité de commander une version
                    papier
                    de ce guide de voyage de 100 pages, qui sera mise à votre disposition dans votre chambre dès votre
                    arrivée, moyennant 15 €
                  </p>
                </div>

                <div v-else class="d-flex flex-column align-items-start justify-content-start mt-3"
                  :class="isPhone ? 'align-items-center' : ''">
                  <p class="raleway-reg-p15 mt-5">
                    Pour accéder à l'intégralité du guide de voyage, créez un compte client ou connectez vous.
                  </p>
                  <div class="d-flex flex-column align-items-center justify-content-center">
                    <a @click="handleShowModal" class="hortense-btn-primary">Je télécharge mon guide</a>
                    <a @click="openLoginModal" class="link-hortense text-white mt-2 raleway-bold-p13">Je me
                      connecte</a>
                  </div>
                </div>
              </div>
            </div>
            <br />
          </div>
        </div>
        <HortenseFaqDisplay v-if="lodging && lodging.hortense_faqs" :faqs="lodging.hortense_faqs" :isMobile="isPhone" class="mb-4" :class="isPhone ? 'px-3' : 'px-5'" />
        <div class="selection-host-card w-100" v-if="nearbyLodgings50km && nearbyLodgings50km.length > 0 && !eventLodging">
          <div class="w-100" :class="isPhone ? 'px-3' : 'px-5'">
            <h2 :class="isPhone ? 'merriweather-reg-20' : 'merriweather-reg-24'">Les autres hébergements à proximité</h2>
            <h3 :class="isPhone ? 'merriweather-light-18' : 'merriweather-light-20'">Vos prochaines inspirations, à quelques pas d’ici.</h3>
          </div>
          <div>
            <GenericLodgingsDisplay :user="isUserConnected()" :lodgings="nearbyLodgings50km" class="mt-5">
            </GenericLodgingsDisplay>
          </div>
          <div class="df-jcc-aic pb-5 pt-4" :class="isPhone ? 'mx-5' : ''">
            <a :href="'/reservation-hotel'" class="hortense-btn-primary">Découvrir nos hébergements</a>
          </div>
        </div>

      </div>
    </template>
    <div v-if="isPhone" ref="datePickerContainer" style="display: none;">
      <CommonDatePicker :startingDateValue="disstartDate" :endingDateValue="disendDate" ref="datePicker"
        @periodSelected="selectDates" :disabledDates="effectiveBlockedDates" />
    </div>
    <div class="d-flex flex-column bottom-content" id="fix-bottom-banner-ls">
      <div v-if="isPhone && !eventLodging" id="fixed-banner" class="fixed-banner">
        <div class="search-bar-button-phone d-flex mb-1" v-if="isPhone && !lodging.is_entire">
          <label
            class="search-bar-multiple-rooms-toggle raleway-reg-p13"
          >
            <input
              type="checkbox"
              v-model="selectMultipleRooms"
            />
            <span>Souhaitez-vous réserver plus d'une chambre ?</span>
          </label>
        </div>
        <div class="fixed-banner-main">
          <div class="banner-content">
            <p class="banner-dates raleway-reg-p15 bottom-bar-font mb-1" v-if="!formattedBannerDates" @click="openPickerTwo" tabindex="0">Aucune date sélectionnée</p>
            <div v-else-if="disstartDate" class="banner-dates" tabindex="0">
              <div class="d-flex align-items-center">
                <div class="d-flex align-items-center flex-column pr-1" style="border-right: 1px solid #CFE5DC; gap: 5px;"  @click="openPickerTwo">
                  <span class="raleway-semi-p15 bottom-bar-font" style="color: #2C5E4BBC">Arrivée</span>
                  <span class="raleway-medi-p15 bottom-bar-font text-center">{{ formatDateDisplay(disstartDate) }}</span>
                </div>
                <div class="ml-1 d-flex align-items-center flex-column" style="border-right: 1px solid #CFE5DC; padding-right: 10px; gap: 5px;"  @click="openPickerTwo">
                  <span class="raleway-semi-p15 bottom-bar-font" style="color: #2C5E4BBC">Départ</span>
                  <span class="raleway-medi-p15 bottom-bar-font text-center">{{ formatDateDisplay(disendDate) }}</span>
                </div>
                <div class="ml-1 d-flex align-items-center flex-column guest-info-banner">
                  <div class="d-flex align-items-center" style="cursor: pointer;" @click.stop="openOccupancySelector">
                    <img src="../../images/person.png" alt="Voyageurs" class="guest-icon" />
                    <span class="raleway-medi-p15 bottom-bar-font ml-2">{{ guestNumber + children }}</span>
                  </div>
                  <MobileGuestInfo v-if="showGuestInfo" @ageSelected="updateChildAges" @increaseChilds="updateChildren"
                    @decreaseChilds="updateChildren" @increaseAdults="updateAdults" @decreaseAdults="updateAdults"
                    @closed="handleGuestInfoClose" @updatedGuestState="updateGuestStateInfo($event)" :initialAdults="adults" :initialChilds="children"
                    :initialChildAges="childAges" :ageErrorTrigger="guestAgeErrorTrigger" />
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex flex-column align-items-end">
            <p class="raleway-reg-p15 bottom-bar-font mb-0" style="color: black;">
              À partir de <span class="raleway-semi-p13 bottom-bar-font">{{ this.lodging.lowest_price }} EUR</span>
            </p>
            <button class="banner-button" @click="openDatePicker">VOIR LES DISPONIBILITÉS</button>
          </div>
        </div>
      </div>
      <div v-if="isPhone" id="fixed-bannertwo" class="fixed-bannertwo">Aucun frais de réservation</div>
    </div>
  </div>
</template>

<script>
import { Loader } from "@googlemaps/js-api-loader";
import fetcher from "../../packs/shared/api.js";
import VueSlider from "vue-slider-component";
import LodgingShowPhone from "../../components/LodgingShowPhone.vue";
import GenericLodgingsDisplay from "../../components/shared/GenericLodgingsDisplay.vue";
import Cardexplodging from "../../components/cards/Cardexplodging.vue";
import ReservationCard from "../../components/cards/ReservationCard";
import Cardcomment from "../../components/cards/Cardcomment.vue";
import Modalshare from "../../components/modals/Modalshare.vue";
import ModalGallery from "../../components/modals/ModalGallery.vue";
import ModalRoomGalery from "../../components/modals/ModalRoomGalery.vue";
import Maplodgingshow from "../../pages/lodgings/Maplodgingshow.vue";
import ModalEnvironmentalPromise from "../../pages/lodgings/ModalEnvironmentalPromise.vue";
import ModalChiefIntro from "../../pages/lodgings/ModalChiefIntro.vue";
import LodgingshowRooms from "./LodgingshowRooms.vue";
import LodgingshowEntire from "./LodgingshowEntire.vue";
import AOS from "aos";
import "mapbox-gl/dist/mapbox-gl.css";
import Modalsignup from "../../components/modals/Modalsignup.vue";
import LodgingshowExperienceAndPrivileges from "../../components/lodgings/LodgingshowExperienceAndPrivileges.vue";
import LodgingExperience from './LodgingExperience'
import RoomGalleryModal from "../../components/modals/RoomGalleryModal.vue";
import ExperienceMapModal from "../../components/ExperienceMapModal.vue";
import LodgingDiscountBadge from "../../components/shared/LodgingDiscountBadge.vue";
import Guestinfo from "../../components/btns/Guestinfo.vue";
import MobileGuestInfo from "components/btns/MobileGuestInfo.vue";
import RoomPlanModal from "../../components/modals/RoomPlanModal.vue";
import LodgingInfo from "../../components/lodgings/LodgingInfo.vue";
import LodgingshowGreenNote from "./LodgingshowGreenNote.vue";
import HortenseFaqDisplay from "../../components/lodgings/HortenseFaqDisplay.vue";
import {
  deriveGuestStateFromRoomPlans,
  expandRoomPlans,
  normalizeReservationSelectionPayload,
  normalizeRoomPlan,
  normalizeRoomPlans,
  toMoney,
  withOspitaTrackingId,
} from "../../utils/reservationFlow";
export default {
  name: "lodging-show",
  components: {
    VueSlider,
    ModalGallery,
    LodgingShowPhone,
    LodgingshowExperienceAndPrivileges,
    ModalRoomGalery,
    GenericLodgingsDisplay,
    Cardcomment,
    Cardexplodging,
    Modalshare,
    Maplodgingshow,
    ModalEnvironmentalPromise,
    ModalChiefIntro,
    ReservationCard,
    Modalsignup,
    LodgingshowExperienceAndPrivileges,
    LodgingExperience,
    RoomGalleryModal,
    ExperienceMapModal,
    LodgingDiscountBadge,
    Guestinfo,
    LodgingshowRooms,
    LodgingshowEntire,
    RoomPlanModal,
    LodgingInfo,
    LodgingshowGreenNote,
    MobileGuestInfo,
    HortenseFaqDisplay
   },
  props: {
    minNights: Number,
    rooms: Array,
    lodging: {
      type: Object,
      required: true
    },
    exclusive: Object,
    user: Object,
    directionsApi: String,
    processStyle: {
      backgroundColor: String,
    },
    selectedLodging: Object,
    showTripadvisorReviews: {
      type: Boolean,
      default: false
    },
    // iCal-derived blocked dates injected by the Rails show action (standard lodgings).
    // Array of "YYYY-MM-DD" strings.
    blockedDates: {
      type: Array,
      default: () => []
    },
    // True when the lodging is managed via the Koedia/Othyssia channel manager.
    // When true, blocked dates are fetched asynchronously from the inventory endpoint.
    isKoediaLodging: {
      type: Boolean,
      default: false
    }
  },
  data() {
    console.log('this.lodginhg', this.lodging)
    return {
      expandedReviewKey: null,
      expandedReviewId: null,
      refund: null,
      nearbyLodgings: [],
      nearbyLodgings50km: [],
      currentDate: new Date(),
      cancellation_message: "",
      expandedReviews: {},
      board_type: "",
      showModalLogin: false,
      showMoreThree: false,
      showMoreTwo: false,
      showMoreCheifIntro: false,
      adults: this.lodging.accommodation_capacity,
      guestNumber: 2,
      children: 0,
      childAges: [],
      showCalendar: false,
      isSwiping: false,
      startX: 0,
      endX: 0,
      moveX: 0,
      startDate: null,
      endDate: null,
      disstartDate: null,
      disendDate: null,
      printStart: null,
      printEnd: null,
      printStarttwo: null,
      printEndtwo: null,
      currentIndex: 0,
      baseUrl: window.location.protocol === 'https:' ? window.location.origin : window.location.origin.replace('http:', 'https:'),
      show_resa_card: false,
      slice_value: [],
      houseHold: null,
      image: 'https://images.pexels.com/photos/164595/pexels-photo-164595.jpeg?auto=compress&cs=tinysrgb&w=600',
      accommodation_code: null,
      totalTaxNotKoedia: String,
      totalHtNotKoedia: String,
      totalTvaNotKoedia: String,
      totalTtcNotKoedia: String,
      touristTax: null,
      availability: null,
      isExpand: true,
      isExpandAdminDiscover: true,
      isExpandEssentials: true,
      isExpandCarnetAddress: true,
      isExpandKids: true,
      isExpandInfo: true,
      isExpandMesures: true,
      isExpandDiscoverLodging: true,
      isExpandDescriptionServices: true,
      isExpandSupplements: true,
      showAllEssentials: false,
      showAllKids: false,
      showAllInfo: false,
      showAllMesures: false,
      showAllServicesEntiers: false,
      showAllServices: false,
      experiencesList: null,
      experiencesFiltered: [],
      isSearching: false,
      searched: false,
      isChoosing: true,
      targetShare: null,
      distanceBetween: null,
      to: null,
      from: null,
      koediaFrom: null,
      koediaTo: null,
      // pricePerNight: null,
      // totalHt: 0,
      nights: null,
      roomOptions: null,
      koediaSessionId: null,
      showModalPromise: false,
      showRoomGalery: false,
      showModalChief: false,
      modalGallery: false,
      showMapfind: false,
      chosenIdx: null,
      groupedQuestions: null,
      markers: [],
      ratedLodgings: [],
      averageList: [],
      average: 0,
      showModal: false,
      showSignupModal: false,
      lodgingsByRegionMounted: null,
      categoryServices: [],
      categoryServiceEntiers: [],
      groupedServiceEntiers: null,
      groupedServices: null,
      wishlistLodgings: null,
      SelectedOption: "culturelles",
      selectedRoomOption: null,
      foodMount: null,
      options: {
        min: 0,
        max: 10,
        dotSize: 60,
        fixed: true,
        clickable: false,
        tooltip: "none",
      },
      availabilitiesNotKoedia: [],
      selectedPriceOptionFee: null,
      showMore: false,
      isExpand: true,
      laGreenNoteSliderData: [],
      minimumNightsMessage: "",
      discountPercentage: 0,
      scrolled: false,
      showExperienceMap: false,
      selectedExperienceForMap: null,
      experienceMapScrollPosition: 0,
      activeGreenNoteTooltip: null,
      showStickySearchBar: false,
      showGuestInfo: false,
      selectMultipleRooms: false,
      roomPlans: [],
      roomPlansDraft: [],
      showRoomPlanModal: false,
      roomPlanModalError: "",
      roomPlansInitializedFromModal: false,
      isSyncingGuestStateFromRoomPlans: false,
      showEnvironmentalPromise: false,
      guestAgeErrorTrigger: 0,
      lodgeTypeMapping: {
        "Hotel": 'Hôtels',
        "Maison et Villa": 'Maisons et Villas',
        "Guestroom": 'Chambres d\'hôtes',
        "Lodge": 'Lodges et lieux insolites',
        "Appartment": 'Appartements',
        "Chalet": 'Chalets'
      },
      // Blocked dates fetched asynchronously for Koedia lodgings.
      koediaBlockedDates: [],
    };
  },
  watch: {
    slice_value: {
      handler(newVal) {
        this.slice_value = newVal;
        //console.log('slice_value');
        //console.log(this.slice_value);
      },
      immediate: true,
      deep: true,
    },
    directionsApi: {
      immediate: true,
      handler(key) {
        const mapsLoader = new Loader({ apiKey: key });
        mapsLoader.load().then(() => this.getLocation());
      },
    },
    isChoosing: {
      handler(newVal) {
        this.isChoosing = newVal;
      },
      immediate: true,
    },
    guestNumber: {
      handler(newVal) {
        if (newVal > 0) {
          this.adults = parseInt(newVal);
        }
      },
      immediate: true,
    },
    children: {
      handler(newVal) {
        if (newVal > 0) {
          this.childs = parseInt(newVal);
        }
      },
      immediate: true,
    },
    scrolled: {
      handler(newVal) {
        const whatsappBtn = document.getElementById('whatsapp-button');
        if (whatsappBtn) {
          whatsappBtn.style.display = newVal ? 'block' : 'none';
        }
      },
      immediate: true
    },
    effectiveBlockedDates: {
      handler() {
        this.clearReservationStateIfDatesAreBlocked();
      },
      immediate: true,
    },
    selectMultipleRooms(newValue, oldValue) {
      if (this.lodging?.is_entire || !this.supportsStructuredRoomPlans) return;
      if (newValue === oldValue) return;

      if (newValue) {
        this.openRoomPlanModal({ resetDraft: !this.roomPlansInitializedFromModal });
      } else {
        this.roomPlans = [];
        this.roomPlansDraft = [];
        this.roomPlanModalError = "";
        this.roomPlansInitializedFromModal = false;
        this.updateReservationState();

        if (this.isKoediaLodging && this.koediaFrom && this.koediaTo) {
          this.$nextTick(() => {
            this.checkIfAvailableTwo(this.koediaFrom, this.koediaTo, this.guestNumber);
          });
        }
      }
    }
  },
  created() {
    // Initialize slider data with dynamic colors based on values
    this.laGreenNoteSliderData = [
      { title: "Politique et gestion environnementale", model: this.pol, color: this.getSliderColor(this.pol) },
      { title: "Responsabilité sociale", model: this.soc, color: this.getSliderColor(this.soc) },
      { title: "Formation du personnel", model: this.per, color: this.getSliderColor(this.per) },
      { title: "Sensibilisation des clients", model: this.cli, color: this.getSliderColor(this.cli) },
      { title: "Politique d'achats responsables", model: this.ach, color: this.getSliderColor(this.ach) },
      { title: "Gestion de l'eau", model: this.eau, color: this.getSliderColor(this.eau) },
      { title: "Gestion des déchets", model: this.dec, color: this.getSliderColor(this.dec) },
      { title: "Gestion de l'énergie", model: this.ene, color: this.getSliderColor(this.ene) },
      { title: "Eco-construction", model: this.con, color: this.getSliderColor(this.con) },
      { title: "Environnement extérieur et intérieur", model: this.env, color: this.getSliderColor(this.env) },
    ]

    this.hydrateReservationStateFromStorage();
  },
  methods: {
    getReservationStateFromStorage() {
      const rawState = JSON.parse(localStorage.getItem('reservationState'));
      if (rawState && rawState.from) {
        const fromDate = new Date(rawState.from);
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        if (fromDate < today) {
          localStorage.removeItem('reservationState');
          return null;
        }
      }

      return rawState;
    },
    isDefaultGuestReservation(state) {
      if (!state) return true;

      const adults = Number.parseInt(state.adults, 10);
      const childs = Number.parseInt(state.childs, 10);

      return adults === 2 && childs === 0;
    },
    hasStoredGuestReservation(state = this.getReservationStateFromStorage()) {
      return !!state && !this.isDefaultGuestReservation(state);
    },
    hydrateReservationStateFromStorage() {
      const state = this.getReservationStateFromStorage();
      if (!state) {
        return null;
      }

      const normalizedChildAges = this.normalizeChildAges(state.children_ages);
      const normalizedRoomPlans = this.supportsStructuredRoomPlans ? expandRoomPlans(state.room_plans) : [];
      const restoredChildrenCount = Number.isFinite(Number(state.childs))
        ? Math.max(0, parseInt(state.childs, 10)) || 0
        : normalizedChildAges.length || 0;
      if (state.from && state.to) {
        this.disstartDate = new Date(this.formatDateKoedia(state.from.replace(/^undefined-undefined-/, '')));
        this.disendDate = new Date(this.formatDateKoedia(state.to.replace(/^undefined-undefined-/, '')));
        this.printStarttwo = this.disstartDate;
        this.printEndtwo = this.disendDate;
        this.koediaFrom = state.koediaFrom;
        this.koediaTo = state.koediaTo;
        this.printStart = this.formatDate(state.from);
        this.printEnd = this.formatDate(state.to);
        this.from = state.from;
        this.to = state.to;
      }
      this.guestNumber = state.adults || 2;
      this.adults = state.adults || 2;
      this.children = restoredChildrenCount;
      this.childs = restoredChildrenCount;
      this.childAges = normalizedChildAges;
      this.roomPlans = normalizedRoomPlans;
      this.roomPlansInitializedFromModal = this.supportsStructuredRoomPlans && normalizedRoomPlans.length > 0;
      this.selectMultipleRooms = this.supportsStructuredRoomPlans && normalizedRoomPlans.length > 1;

      this.clearReservationStateIfDatesAreBlocked();
      return state;
    },
    toDateKey(dateValue) {
      if (!dateValue) return null;
      const date = new Date(dateValue);
      if (Number.isNaN(date.getTime())) return null;

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    hasBlockedDateBetween(startDate, endDate) {
      const blocked = Array.isArray(this.effectiveBlockedDates) ? this.effectiveBlockedDates : [];
      if (!blocked.length || !startDate || !endDate) return false;

      const blockedSet = new Set(
        blocked
          .map((date) => (typeof date === 'string' ? date.slice(0, 10) : this.toDateKey(date)))
          .filter(Boolean)
      );

      const start = new Date(startDate);
      const end = new Date(endDate);
      start.setHours(0, 0, 0, 0);
      end.setHours(0, 0, 0, 0);

      for (let cursor = new Date(start); cursor <= end; cursor.setDate(cursor.getDate() + 1)) {
        const cursorKey = this.toDateKey(cursor);
        if (cursorKey && blockedSet.has(cursorKey)) {
          return true;
        }
      }

      return false;
    },
    clearReservationStateIfDatesAreBlocked() {
      if (!this.disstartDate || !this.disendDate) return;
      if (!this.hasBlockedDateBetween(this.disstartDate, this.disendDate)) return;

      this.selectDates(null, null, null);
    },
    // Fetches Koedia inventory-based blocked dates asynchronously.
    // Called once on mount when isKoediaLodging is true.
    // On month-change the calendar can call this again with a new window.
    async fetchKoediaBlockedDates(fromDate, toDate) {
      if (!this.isKoediaLodging || !this.lodging || !this.lodging.slug) return;
      const dateWindow = this.getKoediaBlockedDatesWindow(fromDate, toDate);
      const from = this.formatDateForKoedia(dateWindow.from);
      const to = this.formatDateForKoedia(dateWindow.to);
      try {
        const res = await fetch(
          `/reservation-hotel/${this.lodging.slug}/koedia_blocked_dates?from=${from}&to=${to}`
        );
        if (!res.ok) return;
        const data = await res.json();
        if (Array.isArray(data.blocked_dates)) {
          // Merge with any existing Koedia dates (e.g. from a previous month fetch)
          const merged = new Set([...this.koediaBlockedDates, ...data.blocked_dates]);
          this.koediaBlockedDates = Array.from(merged);
        }
      } catch (e) {
        // Fail-open: leave koediaBlockedDates unchanged so the calendar stays usable
        console.warn('[Lodgingshow] fetchKoediaBlockedDates failed:', e);
      }
    },
    getKoediaBlockedDatesWindow(fromDate = null, toDate = null) {
      const from = this.toLocalDate(fromDate || new Date());
      from.setHours(0, 0, 0, 0);

      const to = toDate
        ? this.toLocalDate(toDate)
        : new Date(from.getFullYear(), from.getMonth() + 4, 0);
      to.setHours(0, 0, 0, 0);

      return { from, to };
    },
    toLocalDate(value) {
      if (value instanceof Date) {
        return new Date(value);
      }

      if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
        return new Date(`${value}T00:00:00`);
      }

      return new Date(value);
    },
    getSupplementBadgeLabel(selection) {
      if (selection === 'sur_demande') return 'Sur demande';
      if (selection === 'gratuit') return 'Gratuit';
      if (selection === 'payant') return 'Payant';
      return '';
    },
    goToYoga() {
      window.location.href = `/reservation-hotel/${this.lodging.slug}/avis`
    },
    reviewKey(r, idx) {
      const base =
        r?.review_id ??
        r?.uuid ??
        r?.tripadvisor_id ??
        r?.id ??
        `${(r?.user_name || "u").trim()}-${r?.rated_at || r?.created_at || "d"}`;

      return `${base}-${idx}`;
    },
    reviewKeyy(r, idx) {
      const base =
        r?.id ||
        r?.review_id ||
        `${r?.user_name || "u"}-${r?.rated_at || r?.created_at || "t"}-${idx}`;

      return r?.__isClone ? `${base}-clone-${r.__cloneIndex}` : `${base}`;
    },
    isReviewExpanded(key) {
      return this.expandedReviewKey === key;
    },

    // wrappers so your <span> toggles keep working (no UI disturbance)
    isExpanded(r, idx) {
      return this.isReviewExpanded(this.reviewKey(r, idx));
    },

    toggleExpand(r, idx) {
      this.toggleReview(this.reviewKey(r, idx));
    },

    toggleReview(key) {
      this.expandedReviewKey = this.expandedReviewKey === key ? null : key;

      this.$nextTick(() => this.refreshTaSliderHeight());
    },

    refreshTaSliderHeight() {
      const s = this.$refs.taSlider;
      if (!s) return;

      const refresh = () => {
        if (s.refresh) s.refresh();
        if (s.update) s.update();
        if (s.tns?.refresh) s.tns.refresh();
        if (s.tns?.updateSliderHeight) s.tns.updateSliderHeight();
        if (s.swiper?.update) s.swiper.update();
        if (s.swiper?.updateAutoHeight) s.swiper.updateAutoHeight(0);
        window.dispatchEvent(new Event("resize"));
      };

      refresh();
      setTimeout(refresh, 80);
    },

    shouldShowReviewToggle(r) {
      const text = (r?.review ? String(r.review) : "").trim();
      return text.length > 160;
    },

    avatarLetter(name) {
      const s = (name || "").trim();
      return (s[0] || "?").toUpperCase();
    },

    formatMonthYear(dateStr) {
      if (!dateStr) return "";
      const d = new Date(dateStr);
      if (Number.isNaN(d.getTime())) return "";
      return new Intl.DateTimeFormat("fr-FR", { month: "short", year: "numeric" }).format(d);
    },
    submitAndClose() {
      if (this.$refs.datePicker && this.$refs.datePickerWrapper) {
        this.$refs.datePickerWrapper.style.display = 'none';
      }
    },
    setBannerOffset() {
      const banner = document.getElementById('fixed-bannertwo');
      const bannerTwo = document.getElementById('fixed-banner');
      if (banner && bannerTwo) {
        const bannerHeight = banner.offsetHeight;
        bannerTwo.style.bottom = `${bannerHeight - 9}px`;
      }
    },
    formatGuestDisplay() {
      const adultText = this.adults > 1 ? `${this.adults} Adultes` : `${this.adults} Adulte`;
      const childText = this.children > 0 ? ` - ${this.children} Enfant${this.children > 1 ? 's' : ''}` : ' - 0 Enfant';
      return `${adultText}${childText}`;
    },
    formatDateDisplay(date) {
      if (!date) return '';
      const monthsFR = ['janv.', 'fév.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];
      const d = new Date(date);
      const day = d.getDate();
      const month = monthsFR[d.getMonth()];
      const year = d.getFullYear();
      return `${day} ${month} ${year}`;
    },
    handleGuestInfoClose() {
      this.showGuestInfo = false;
      if (this.koediaFrom && this.koediaTo) {
        this.$nextTick(() => {
          this.checkIfAvailableTwo(this.koediaFrom, this.koediaTo, this.guestNumber);
        });
      }
    },
    normalizeChildAges(ages) {
      if (!Array.isArray(ages)) return [];
      return ages.filter(age => age !== null && age !== undefined && age !== '');
    },
    normalizeRoomPlanDraft(plan = {}) {
      const normalizedPlan = normalizeRoomPlan(plan);
      const childrenCount = Math.max(0, parseInt(normalizedPlan.children, 10) || 0);
      const childrenAges = Array.from({ length: childrenCount }, (_, index) => (
        normalizedPlan.children_ages[index] || ''
      ));

      return {
        room_count: 1,
        adults: Math.max(1, parseInt(normalizedPlan.adults, 10) || 1),
        children: childrenCount,
        children_ages: childrenAges,
      };
    },
    buildDefaultRoomPlans() {
      if (!this.supportsStructuredRoomPlans) return [];

      const adults = Math.max(1, parseInt(this.adults || this.guestNumber, 10) || 1);
      const normalizedChildAges = this.normalizeChildAges(this.childAges);
      const initialRoomCount = Math.max(2, this.roomPlans.length || 2);
      const roomCount = Math.min(initialRoomCount, adults);

      const plans = Array.from({ length: roomCount }, () => ({
        room_count: 1,
        adults: 1,
        children: 0,
        children_ages: [],
      }));

      let remainingAdults = adults - roomCount;
      let cursor = 0;
      while (remainingAdults > 0) {
        plans[cursor % roomCount].adults += 1;
        remainingAdults -= 1;
        cursor += 1;
      }

      normalizedChildAges.forEach((age, index) => {
        const target = plans[index % roomCount];
        target.children += 1;
        target.children_ages.push(age);
      });

      return plans.map((plan) => this.normalizeRoomPlanDraft(plan));
    },
    openRoomPlanModal({ resetDraft = false } = {}) {
      if (!this.supportsStructuredRoomPlans) return;

      const sourcePlans = !resetDraft && this.roomPlans.length > 0
        ? this.roomPlans
        : this.buildDefaultRoomPlans();

      this.roomPlansDraft = sourcePlans.map((plan) => this.normalizeRoomPlanDraft(plan));
      this.roomPlanModalError = "";
      this.showRoomPlanModal = true;
    },
    closeRoomPlanModal() {
      if (!this.supportsStructuredRoomPlans) return;

      this.showRoomPlanModal = false;
      this.roomPlanModalError = "";

      if (this.selectMultipleRooms && this.roomPlans.length === 0) {
        this.selectMultipleRooms = false;
      }
    },
    addRoomPlan() {
      if (!this.supportsStructuredRoomPlans) return;
      this.roomPlansDraft.push(this.normalizeRoomPlanDraft({ adults: 1, children: 0 }));
    },
    removeRoomPlan(index) {
      if (!this.supportsStructuredRoomPlans) return;
      if (this.roomPlansDraft.length <= 1) return;
      this.roomPlansDraft.splice(index, 1);
    },
    updateRoomPlanValue(index, field, value) {
      const numericValue = Math.max(field === 'adults' ? 1 : 0, parseInt(value, 10) || 0);
      this.$set(this.roomPlansDraft, index, this.normalizeRoomPlanDraft({
        ...this.roomPlansDraft[index],
        [field]: numericValue,
      }));
    },
    updateRoomPlanValueFromEvent({ index, field, value }) {
      this.updateRoomPlanValue(index, field, value);
    },
    updateRoomChildrenCount(index, value) {
      const children = Math.max(0, parseInt(value, 10) || 0);
      this.$set(this.roomPlansDraft, index, this.normalizeRoomPlanDraft({
        ...this.roomPlansDraft[index],
        children,
      }));
    },
    updateRoomChildrenCountFromEvent({ index, value }) {
      this.updateRoomChildrenCount(index, value);
    },
    updateRoomChildAge(index, childIndex, value) {
      const nextPlan = this.normalizeRoomPlanDraft(this.roomPlansDraft[index]);
      nextPlan.children_ages.splice(childIndex, 1, value?.toString?.().trim?.() || '');
      this.$set(this.roomPlansDraft, index, nextPlan);
    },
    updateRoomChildAgeFromEvent({ index, childIndex, value }) {
      this.updateRoomChildAge(index, childIndex, value);
    },
    roomPlanTotalsFor(plans) {
      return expandRoomPlans(plans).reduce((totals, plan) => {
        totals.adults += parseInt(plan.adults, 10) || 0;
        totals.children += parseInt(plan.children, 10) || 0;
        return totals;
      }, { adults: 0, children: 0 });
    },
    validateRoomPlans(plans) {
      if (!Array.isArray(plans) || plans.length === 0) {
        return "Ajoutez au moins une chambre.";
      }

      for (const [index, rawPlan] of plans.entries()) {
        const plan = this.normalizeRoomPlanDraft(rawPlan);
        if ((parseInt(plan.adults, 10) || 0) < 1) {
          return `La chambre ${index + 1} doit contenir au moins un adulte.`;
        }

        if (plan.children > 0 && plan.children_ages.some((age) => age === '')) {
          return `Renseignez l'âge de chaque enfant pour la chambre ${index + 1}.`;
        }
      }

      return "";
    },
    applyGuestStateFromRoomPlans(roomPlans) {
      const guestState = deriveGuestStateFromRoomPlans(roomPlans);

      this.isSyncingGuestStateFromRoomPlans = true;
      this.adults = guestState.adults || 1;
      this.guestNumber = guestState.adults || 1;
      this.children = guestState.childs || 0;
      this.childs = guestState.childs || 0;
      this.childAges = guestState.children_ages;
      this.$nextTick(() => {
        this.isSyncingGuestStateFromRoomPlans = false;
      });
    },
    saveRoomPlansFromModal() {
      if (!this.supportsStructuredRoomPlans) return;

      const normalizedPlans = this.roomPlansDraft.map((plan) => this.normalizeRoomPlanDraft(plan));
      const validationError = this.validateRoomPlans(normalizedPlans);

      if (validationError) {
        this.roomPlanModalError = validationError;
        return;
      }

      this.roomPlans = normalizedPlans;
      this.roomPlansInitializedFromModal = true;
      this.applyGuestStateFromRoomPlans(normalizedPlans);
      this.updateReservationState({ room_plans: normalizedPlans });
      this.showRoomPlanModal = false;
      this.roomPlanModalError = "";

      if (this.koediaFrom && this.koediaTo) {
        this.$nextTick(() => {
          this.checkIfAvailableTwo(this.koediaFrom, this.koediaTo, this.guestNumber);
        });
      }
    },
    ensureRoomPlansReady() {
      if (!this.supportsStructuredRoomPlans || !this.selectMultipleRooms || this.lodging?.is_entire) return true;

      if (this.roomPlans.length === 0) {
        this.openRoomPlanModal({ resetDraft: true });
        return false;
      }

      const validationError = this.validateRoomPlans(this.roomPlans);
      if (validationError) {
        this.roomPlanModalError = validationError;
        this.openRoomPlanModal();
        return false;
      }

      return true;
    },
    updateGuestStateInfo(guestData) {
      if (guestData) {
        this.adults = guestData.adults;
        this.children = guestData.childs;
        this.guestNumber = guestData.adults;
        this.childAges = this.normalizeChildAges(guestData.ageSelected);
      }
      if (this.selectMultipleRooms && !this.isSyncingGuestStateFromRoomPlans) {
        this.roomPlansInitializedFromModal = false;
        this.roomPlans = [];
      }
      this.updateReservationState();
    },
    hasMissingChildAgesSelection() {
      const childCount = Number.parseInt(this.children, 10) || 0;
      if (childCount <= 0) return false;

      return this.normalizeChildAges(this.childAges).length < childCount;
    },
    openOccupancySelector() {
      if (this.selectMultipleRooms && this.supportsStructuredRoomPlans && !this.lodging?.is_entire) {
        this.openRoomPlanModal({ resetDraft: !this.roomPlansInitializedFromModal });
        this.showGuestInfo = false;
        return;
      }

      this.showGuestInfo = !this.showGuestInfo;
    },
    openGuestModal() {
      if (this.selectMultipleRooms && this.supportsStructuredRoomPlans && !this.lodging?.is_entire) {
        this.showGuestInfo = false;
        this.openRoomPlanModal({ resetDraft: !this.roomPlansInitializedFromModal });
        return;
      }

      this.guestAgeErrorTrigger += 1;
      this.showGuestInfo = true;
    },
    updateAdults(count) {
      this.adults = count;
      this.guestNumber = count;
    },
    updateChildren(count) {
      this.children = count;
      if (this.childAges.length > count) {
        this.childAges = this.childAges.slice(0, count);
      }
      this.updateReservationState();
    },
    updateChildAges(ages) {
      this.childAges = this.normalizeChildAges(ages);
      this.updateReservationState();
    },
    updateReservationState(overrides = {}) {
      const state = JSON.parse(localStorage.getItem('reservationState')) || {};
      state.adults = this.adults;
      state.childs = this.children;
      state.children_ages = this.normalizeChildAges(this.childAges);
      state.room_plans = this.supportsStructuredRoomPlans
        ? normalizeRoomPlans(
            Object.prototype.hasOwnProperty.call(overrides, 'room_plans')
              ? overrides.room_plans
              : this.roomPlans
          )
        : [];
      localStorage.setItem('reservationState', JSON.stringify(withOspitaTrackingId(state)));
    },
    applyEventLodgingGuestDefaults({ persistState = false } = {}) {
      if (!this.eventLodging) return;

      const adultsDefault = Number.isFinite(Number(this.lodging.event_lodging_adults))
        ? Math.max(0, parseInt(this.lodging.event_lodging_adults, 10))
        : null;
      const childsDefault = Number.isFinite(Number(this.lodging.event_lodging_childs))
        ? Math.max(0, parseInt(this.lodging.event_lodging_childs, 10))
        : null;

      if (adultsDefault === null && childsDefault === null) return;

      if (adultsDefault !== null) {
        this.adults = adultsDefault;
        this.guestNumber = adultsDefault;
      }

      if (childsDefault !== null) {
        this.children = childsDefault;
        this.childs = childsDefault;
      }

      if (!persistState) return;

      const state = JSON.parse(localStorage.getItem('reservationState')) || {};
      if (adultsDefault !== null) {
        state.adults = this.guestNumber;
      }
      if (childsDefault !== null) {
        state.childs = this.children;
      }
      localStorage.setItem('reservationState', JSON.stringify(withOspitaTrackingId(state)));
    },
    handleShowModal() {
      this.showSignupModal = true;
    },
    openLoginModal() {
      this.showModalLogin = true;
      this.showSignupModal = true;
    },
    openPicker() {
      if (this.$refs.datePicker && this.$refs.datePickerWrapper) {
        this.$refs.datePickerWrapper.style.display = 'block';
        this.$refs.datePicker.showDatepicker();
      }
    },
    setUser(user) {
      this.user = user;
      this.showSignupModal = false;
    },
    onTouchStart(event) {
      if (event.target.closest('.nav-lodging-phone')) {
        this.isSwiping = false;
        return;
      }
      this.startX = event.touches[0].clientX;
      this.isSwiping = true;
    },
    onTouchMove(event) {
      if (!this.isSwiping) return;
      this.moveX = event.touches[0].clientX;
    },
    onTouchEnd() {
      if (!this.isSwiping) return;
      this.isSwiping = false;

      const swipeDistance = this.startX - this.moveX;
      if (swipeDistance > 100) {
        this.nextSlide();
      } else if (swipeDistance < -100) {
        this.prevSlide();
      }
    },
    goBack() {
      const referrer = localStorage.getItem('reservation_referrer');
      if (referrer) {
        // Ensure HTTPS for referrer URLs
        const httpsReferrer = referrer.startsWith('http://') ? referrer.replace('http://', 'https://') : referrer;
        window.location.href = httpsReferrer;
      } else {
        // Ensure HTTPS for default redirect
        const protocol = window.location.protocol === 'https:' ? 'https:' : 'https:';
        window.location.href = `${protocol}//${window.location.host}/reservation-hotel`;
      }
    },
    updatePhotoCounter(event) {
      this.currentPhotoIndex = event.detail.index;
    },
    openDatePicker() {
      if (this.printStart && this.printEnd) {
        if (this.lodging.is_entire) {
          this.checkIfAvailable(this.printStart, this.printEnd, this.guestNumber);
          this.scrollToElement('booking-form-container', 10);
        } else {
          this.handleGuestInfoClose();
          this.checkIfAvailableTwo(this.koediaFrom, this.koediaTo, this.guestNumber);
        }
      } else if (this.$refs.datePicker) {
        if (this.$refs.datePickerContainer) { this.$refs.datePickerContainer.style.display = 'block'; }
        this.$refs.datePicker.showDatepicker();
      }
    },
    openPickerTwo() {
      if (this.$refs.datePicker) {
        if (this.$refs.datePickerContainer) { this.$refs.datePickerContainer.style.display = 'block'; }
        this.$refs.datePicker.showDatepicker();
      }
    },
    handleOpenDatePickerFromRooms() {
      if (this.isPhone) {
        this.openPickerTwo();
      } else {
        this.openPicker();
      }
    },
    selectDates(event, start, end) {
      this.printEndtwo = end;
      this.printStarttwo = start;
      this.startDate = this.formatDate(start);
      this.endDate = this.formatDate(end);
      this.printStart = this.formatDate(start);
      this.printEnd = this.formatDate(end);
      this.koediaFrom = this.formatDateKoedia(this.printStart);
      this.koediaTo = this.formatDateKoedia(this.printEnd);
      this.disstartDate = start;
      this.disendDate = end;

      // When dates are cleared, reset child components and clear localStorage state
      if (!start && !end) {
        localStorage.removeItem('reservationState');
        if (this.lodging.is_entire && this.$refs.lodgingEntireComponent) {
          this.$refs.lodgingEntireComponent.resetAvailability();
        } else if (this.$refs.lodgingRoomsComponent) {
          this.$refs.lodgingRoomsComponent.resetAvailability();
        }
        if (this.$refs.datePickerContainer) {
          this.$refs.datePickerContainer.style.display = 'none';
        }
        return;
      }

      const state = {
        koediaFrom: this.koediaFrom,
        koediaTo: this.koediaTo,
        from: this.koediaFrom,
        to: this.koediaTo,
        childs: this.children,
        children_ages: this.normalizeChildAges(this.childAges)
      };
      
      // Only add adults and childs to state if not an entire lodging
      if (!this.lodging.is_entire) {
        state.adults = this.guestNumber;
      }
      
      localStorage.setItem('reservationState', JSON.stringify(withOspitaTrackingId(state)));
      this.applyEventLodgingGuestDefaults({ persistState: true });
      if (this.$refs.datePickerContainer) {
        this.$refs.datePickerContainer.style.display = 'none';
      }
      this.updateCalendarStates();
      this.$nextTick(() => {
        this.scrollToElement(!this.lodging.is_entire ? 'room-image-container' : 'booking-form-container')
      });
    },
    updateCalendarStates() {
      if (this.lodging.is_entire) {
        this.$refs.lodgingEntireComponent.loadReservationState();
      } else {
        this.$refs.lodgingRoomsComponent.loadState();
      }
    },
    formatDate(date) {
      if (!date) return null;
      console.log('formatDate', date)
      const set = new Date(date);
      const options = { year: "numeric", month: "numeric", day: "numeric" };
      return set.toLocaleString("fr", options);
    },
    formatDateKoedia(date) {
      if (!date) return null;
      if (date.includes('-') || !date) {
        return date;
      }
      const dateBits = date.split('/');
      return `${dateBits[2]}-${dateBits[1]}-${dateBits[0]}`;
    },
    formatDateForKoedia(dateObj) {
      // Convert Date object to YYYY-MM-DD format
      const year = dateObj.getFullYear();
      const month = String(dateObj.getMonth() + 1).padStart(2, '0');
      const day = String(dateObj.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    truncatedText(textLength, text_content) {
      const text = text_content;
      const maxLength = textLength;
      if (text.length > maxLength) {
        return text.substring(0, maxLength) + "...";
      }
      return text;
    },

    debounce(func, delay) {
      let timeout;
      return function (...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), delay);
      }
    },
    toggleText() {
      this.showMore = !this.showMore;
    },
    toggleTextTwo() {
      this.showMoreTwo = !this.showMoreTwo;
    },
    toggleTextChiefIntro() {
      this.showMoreCheifIntro = !this.showMoreCheifIntro;
    },
    toggleTextThree() {
      this.showMoreThree = !this.showMoreThree;
    },
    toggleEnvironmentalPromise() {
      this.showEnvironmentalPromise = !this.showEnvironmentalPromise;
    },
    getBackgroundStyle() {
      // Ensure HTTPS for background images
      const imageUrl = this.lodging.photo_banner;
      const httpsBaseUrl = this.baseUrl.replace('http:', 'https:');
      return {
        backgroundImage: `url("${httpsBaseUrl}${imageUrl}")`
      };
    },
    applyReservationMeta({ cancellation_message = "", board_type = "", discountPercentage = 0, koediaSessionIdParam = null }) {
      this.cancellation_message = cancellation_message;
      this.board_type = board_type;
      this.discountPercentage = discountPercentage;
      if (koediaSessionIdParam && this.accommodation_code) {
        this.koediaSessionId = koediaSessionIdParam;
      }
    },
    resolveSelectedPriceOptionFee(koediaRoomAvailability, tariff) {
      if (!Array.isArray(koediaRoomAvailability)) return null;
      const selectedOption = koediaRoomAvailability.find((el) => el.tariff === tariff);
      return selectedOption ? selectedOption.tariff_cancel_feed || null : null;
    },
    async displayUserInfo(room, pricePerNightTtc, totalTtc, koediaRoomAvailability, idx, tva, priceHt, houseHOld = null, cancellation_message = "", board_type = "", discountPercentage = 0, koediaSessionIdParam = null) {
      if (this.hasMissingChildAgesSelection()) {
        this.openGuestModal();
        return;
      }

      await this.countNights();
      console.log('=== displayUserInfo DEBUG START ===');
      console.log('Input Parameters:', {
        pricePerNightTtc,
        totalTtc,
        idx,
        tva,
        priceHt,
        koediaRoomAvailability: koediaRoomAvailability ? (Array.isArray(koediaRoomAvailability) ? `Array(${koediaRoomAvailability.length})` : 'Object') : 'null'
      });
      
      this.applyReservationMeta({ cancellation_message, board_type, discountPercentage, koediaSessionIdParam });
      this.nights = isNaN(this.nights) ? 1 : this.nights;
      console.log('Nights calculated:', this.nights);
      
      this.roomChoosed = room;
      this.selectedRoomOption = koediaRoomAvailability;
      if (Array.isArray(koediaRoomAvailability)) {
        const selectedOption = koediaRoomAvailability.find((el) => el.tariff === idx);
        if (selectedOption) {
          this.selectedRoomOption = selectedOption;
        }
      }
      this.chosentPricePerNightHt = pricePerNightTtc;
      this.chosenIdx = idx;
      this.selectedPriceOptionFee = this.resolveSelectedPriceOptionFee(koediaRoomAvailability, idx);

      console.log('Tax info:', {
        lodging_tax: this.lodging.tax,
        tourist_tax: this.lodging.tax?.tourist_tax,
        tva_rate: this.lodging.tax?.tva_rate
      });

      // TAX
      let adult_num = this.guestNumber ? parseInt(this.guestNumber) : this.adults ? this.adults : 2
      this.totalTaxNotKoedia = this.lodging.tax ? (adult_num * (this.lodging.tax.tourist_tax * this.nights)).toFixed(2) : 0;
      console.log('Tourist Tax Calculation:', {
        adult_num,
        tourist_tax_per_adult_per_night: this.lodging.tax?.tourist_tax,
        nights: this.nights,
        totalTaxNotKoedia: this.totalTaxNotKoedia
      });

      // Calculate daily totals for variable tariff pricing
      let dailyHtTotal = 0;
      let dailyTvaTotal = 0;
      
      console.log('Date range:', {
        koediaFrom: this.koediaFrom,
        koediaTo: this.koediaTo,
        formatDate_from: this.formatDate(new Date(this.koediaFrom)),
        formatDate_to: this.formatDate(new Date(this.koediaTo))
      });
      
      // If koediaRoomAvailability has daily breakdown, use it; otherwise use flat rate
      if (Array.isArray(koediaRoomAvailability) && koediaRoomAvailability.length > 0) {
        console.log('Using daily breakdown calculation');
        let currentDate = new Date(this.koediaFrom);
        const endDate = new Date(this.koediaTo);
        let dayCount = 0;
        
        while (currentDate < endDate) {
          const dateStr = this.formatDateForKoedia(currentDate);
          const dailyTariff = koediaRoomAvailability.find((el) => el.date === dateStr && el.tariff === idx);
          
          console.log(`Day ${dayCount + 1} (${dateStr}):`, {
            dateStr,
            idx,
            dailyTariff: dailyTariff ? { date: dailyTariff.date, tariff: dailyTariff.tariff, tariff_price: dailyTariff.tariff_price } : 'NOT FOUND'
          });
          
          if (dailyTariff) {
            const dailyPriceHt = dailyTariff.tariff_price || priceHt;
            const tvaRate = this.lodging.tax?.tva_rate ?? 0;
            const dailyTva = dailyPriceHt * (tvaRate / 100);
            console.log(`  Calculation: HT=${dailyPriceHt}, TVA_Rate=${tvaRate}%, Daily_TVA=${dailyTva}`);
            dailyHtTotal += dailyPriceHt;
            dailyTvaTotal += dailyTva;
          } else {
            // Fallback to flat rate if daily data not available
            console.log(`  Fallback: Using flat rate HT=${priceHt}, TVA=${tva}`);
            dailyHtTotal += priceHt;
            dailyTvaTotal += tva;
          }
          
          currentDate.setDate(currentDate.getDate() + 1);
          dayCount++;
        }
      } else {
        // Use flat rate if no daily breakdown available
        console.log('Using flat rate calculation (no daily breakdown)');
        dailyHtTotal = priceHt * this.nights;
        dailyTvaTotal = tva * this.nights;
        console.log(`Flat rate: HT=${priceHt} × ${this.nights} nights = ${dailyHtTotal}, TVA=${tva} × ${this.nights} nights = ${dailyTvaTotal}`);
      }

      // TOTAL HT
      this.totalHtNotKoedia = dailyHtTotal.toFixed(2);

      // TOTAL TVA
      this.totalTvaNotKoedia = dailyTvaTotal.toFixed(2);

      // TOTAL TTC
      this.totalTtcNotKoedia = (
        (isNaN(parseFloat(this.totalHtNotKoedia)) ? 0 : parseFloat(this.totalHtNotKoedia)) +
        (isNaN(parseFloat(this.totalTvaNotKoedia)) ? 0 : parseFloat(this.totalTvaNotKoedia)) +
        (isNaN(parseFloat(this.totalTaxNotKoedia)) ? 0 : parseFloat(this.totalTaxNotKoedia))
      ).toFixed(2);
      
      console.log('=== FINAL TOTALS ===', {
        totalHtNotKoedia: this.totalHtNotKoedia,
        totalTvaNotKoedia: this.totalTvaNotKoedia,
        totalTaxNotKoedia: this.totalTaxNotKoedia,
        totalTtcNotKoedia: this.totalTtcNotKoedia
      });
      console.log('=== displayUserInfo DEBUG END ===');
      
      this.houseHold = houseHOld;
      this.saveStateNotKoedia();
    },
    async handleReserveMultiple(reservationData) {
      if (this.hasMissingChildAgesSelection()) {
        this.openGuestModal();
        return;
      }

      const {
        selectedTariffsInput,
        cartTotal,
        accommodation_code,
        koediaSessionId,
        selected_rooms,
        room_plans,
        room_count,
      } = normalizeReservationSelectionPayload(reservationData);

      await this.countNights();

      // Normalize and store selected tariffs with room-level totals kept in payload
      const normalizedTariffs = selectedTariffsInput.map((tariffItem) => {
        const qty = Number(tariffItem?.qty) || 1;
        const priceData = tariffItem?.priceData || {};
        return {
          ...tariffItem,
          qty,
          koediaRoomId: tariffItem?.koediaRoomId || tariffItem?.koedia_room_id || tariffItem?.selectedOption?.room_id || null,
          koediaRoomIds: Array.isArray(tariffItem?.koediaRoomIds) ? tariffItem.koediaRoomIds : (Array.isArray(tariffItem?.koedia_room_ids) ? tariffItem.koedia_room_ids : []),
          priceData: {
            ...priceData,
            totalPrice: toMoney(priceData.totalPrice),
            htValueTotal: toMoney(priceData.htValueTotal),
            tvalTotal: toMoney(priceData.tvalTotal),
            taxTotal: toMoney(priceData.taxTotal),
            pricePerNight: toMoney(priceData.pricePerNight),
          }
        };
      });

      // Store selection context
      this.selectedTariffs = normalizedTariffs;
      this.cartTotal = cartTotal;
      this.accommodation_code = accommodation_code;
      if (koediaSessionId && this.accommodation_code) {
        this.koediaSessionId = koediaSessionId;
      }

      // Aggregate totals from ReservationCard payload
      let totalPrice = 0;
      let htValueTotal = 0;
      let tvalTotal = 0;
      let taxTotalFromPayload = 0;

      normalizedTariffs.forEach((tariffItem) => {
        const qty = Number(tariffItem?.qty) || 1;
        const priceData = tariffItem?.priceData || {};
        totalPrice += (Number(priceData.totalPrice) || 0) * qty;
        htValueTotal += (Number(priceData.htValueTotal) || 0) * qty;
        tvalTotal += (Number(priceData.tvalTotal) || 0) * qty;
        taxTotalFromPayload += (Number(priceData.taxTotal) || 0) * qty;
      });

      const adult_num = this.guestNumber ? parseInt(this.guestNumber) : this.adults ? this.adults : 2;
      const fallbackTaxTotal = this.lodging.tax
        ? (adult_num * (this.lodging.tax.tourist_tax * this.nights))
        : 0;

      // Conditional calculation path per requirement
      if (this.accommodation_code) {
        // displayUserInfoKoedia-style path
        if ((htValueTotal === 0 || tvalTotal === 0) && totalPrice > 0) {
          const tvaRate = Number(this.lodging.tax?.tva_rate) || 0;
          const computedHt = totalPrice / (1 + (tvaRate / 100));
          const computedTva = totalPrice - computedHt;
          if (htValueTotal === 0) htValueTotal = computedHt;
          if (tvalTotal === 0) tvalTotal = computedTva;
        }

        this.totalTtc = totalPrice;
        this.totalHtNotKoedia = htValueTotal.toFixed(2);
        this.totalTvaNotKoedia = tvalTotal.toFixed(2);
        this.totalTaxNotKoedia = fallbackTaxTotal.toFixed(2);
        this.totalTtcNotKoedia = (
          parseFloat(this.totalHtNotKoedia || 0) +
          parseFloat(this.totalTvaNotKoedia || 0) +
          parseFloat(this.totalTaxNotKoedia || 0)
        ).toFixed(2);
      } else {
        // displayUserInfo-style path (non-koedia)
        if ((htValueTotal === 0 || tvalTotal === 0) && totalPrice > 0) {
          const tvaRate = Number(this.lodging.tax?.tva_rate) || 0;
          const computedTax = Number.isFinite(taxTotalFromPayload) && taxTotalFromPayload > 0
            ? taxTotalFromPayload
            : fallbackTaxTotal;
          const computedHt = (totalPrice - computedTax) / (1 + (tvaRate / 100));
          const computedTva = (totalPrice - computedTax) - computedHt;
          if (htValueTotal === 0) htValueTotal = computedHt;
          if (tvalTotal === 0) tvalTotal = computedTva;
        }

        const taxTotal = Number.isFinite(taxTotalFromPayload) && taxTotalFromPayload > 0
          ? taxTotalFromPayload
          : fallbackTaxTotal;

        this.totalTtc = totalPrice;
        this.totalHtNotKoedia = htValueTotal.toFixed(2);
        this.totalTvaNotKoedia = tvalTotal.toFixed(2);
        this.totalTaxNotKoedia = taxTotal.toFixed(2);
        this.totalTtcNotKoedia = totalPrice.toFixed(2);
      }
      this.chosenIdx = normalizedTariffs[0]?.tariff || null;
      this.selectedPriceOptionFee = normalizedTariffs[0]?.priceData?.selectedPriceOptionFee || null;

      const houseHoldTotal = normalizedTariffs.reduce((sum, tariffItem) => {
        const qty = Number(tariffItem?.qty) || 1;
        const hh = Number(tariffItem?.priceData?.houseHold) || 0;
        return sum + (hh * qty);
      }, 0);
      this.houseHold = houseHoldTotal > 0 ? houseHoldTotal.toFixed(2) : 0;

      const selectedTariffDiscount = normalizedTariffs.reduce((maxDiscount, tariffItem) => {
        const discount = Number(tariffItem?.priceData?.discountPercentage);
        return Number.isFinite(discount) ? Math.max(maxDiscount, discount) : maxDiscount;
      }, 0);
      if (selectedTariffDiscount > 0) {
        this.discountPercentage = selectedTariffDiscount;
      }

      const cancellationMessages = normalizedTariffs
        .map((tariffItem) => tariffItem?.priceData?.cancellationConditions)
        .filter(Boolean);
      this.cancellation_message = this.accommodation_code
        ? (cancellationMessages[0] || "")
        : cancellationMessages;
      this.board_type = normalizedTariffs[0]?.priceData?.boardType || "";

      const roomtoChoose = this.roomChoosed
        ? { ...this.roomChoosed, availabilities: [] }
        : null;
      const lodgingWithoutAvailabilities = this.lodging
        ? {
            ...this.lodging,
            availabilities: [],
            experiences: [],
            lodging_service_entiers: [],
            lodging_services: [],
            service_entiers: [],
            services: [],
            photos_keys: []
          }
        : null;

      const baseState = {
        koediaFrom: this.koediaFrom,
        koediaTo: this.koediaTo,
        from: this.koediaFrom,
        to: this.koediaTo,
        ospita_tracking_id: this.getReservationStateFromStorage()?.ospita_tracking_id || null,
        user: this.user,
        tax: this.lodging.tax,
        total: totalPrice,
        nights: this.nights,
        adults: parseInt(this.guestNumber || this.adults),
        childs: this.children,
        children_ages: this.normalizeChildAges(this.childAges),
        totalTtc: totalPrice,
        selectedPriceOptionFee: this.selectedPriceOptionFee,
        totalTaxNotKoedia: this.totalTaxNotKoedia,
        totalHtNotKoedia: this.totalHtNotKoedia,
        totalTvaNotKoedia: this.totalTvaNotKoedia,
        totalTtcNotKoedia: this.totalTtcNotKoedia,
        isChoosing: false,
        houseHold: this.houseHold,
        cancellation_message: this.cancellation_message,
        board_type: this.board_type,
        refund: this.refund,
        discountPercentage: this.discountPercentage,
        selectedTariffs: normalizedTariffs,
        selected_rooms: Array.isArray(selected_rooms) ? selected_rooms : [],
        room_plans: Array.isArray(room_plans) ? room_plans : [],
        room_count: Number(room_count) > 0 ? Number(room_count) : normalizedTariffs.reduce((sum, tariffItem) => sum + (Number(tariffItem?.qty) || 1), 0),
        numberOfRooms: normalizedTariffs.reduce((sum, tariffItem) => sum + (Number(tariffItem?.qty) || 1), 0),
        totalPrice: totalPrice,
        accommodation_code: this.accommodation_code,
        koediaSessionId: this.koediaSessionId,
        pricePerNightHt: this.nights > 0 ? (htValueTotal / this.nights).toFixed(2) : "0.00",
        totalHt: htValueTotal.toFixed(2),
        tva: tvalTotal.toFixed(2),
        paymentSchedule: this.lodging?.payment_schedule || null,
      };

      // Conditional path exactly aligned with existing single-room flows
      const state = this.accommodation_code
        ? {
            ...baseState,
            exclusive: this.exclusive,
            roomChoosed: this.roomChoosed || this.lodging,
            selectedOption: this.selectedOption,
            koediaRoomId: this.roomChoosed ? this.koediaRoomId(this.roomChoosed.koedia_room_name) : null,
            lodging: this.lodging,
            childDate: this.childDate,
          }
        : {
            ...baseState,
            roomChoosed: roomtoChoose,
            selectedOption: this.selectedRoomOption,
            lodging: lodgingWithoutAvailabilities,
          };

      this.persistReservationState(state, { openConfirmation: true });
    },
    persistReservationState(state, { openConfirmation = false } = {}) {
      localStorage.removeItem('reservationState');
      localStorage.setItem('reservationState', JSON.stringify(withOspitaTrackingId(state)));

      if (!openConfirmation) return;
      
      // Use direct navigation on mobile to avoid popup blocking
      const confirmUrl = '/reservation-hotel/' + this.lodging.slug + '/reservation/confirm';
      if (this.isPhone) {
        window.location.href = confirmUrl;
      } else {
        window.open(confirmUrl, '_blank');
      }
    },
    koediaRoomId(roomName) {
      if (this.availabilities && this.availabilities[roomName]) {
        return this.availabilities[roomName].room_id;
      }
    },
    saveState() {
      console.log('savingggg  statee.......')
      const state = {
        exclusive: this.exclusive,
        roomChoosed: this.roomChoosed,
        selectedOption: this.selectedOption,
        koediaRoomId: this.koediaRoomId(this.roomChoosed.koedia_room_name),
        koediaSessionId: this.koediaSessionId,
        koediaFrom: this.koediaFrom,
        koediaTo: this.koediaTo,
        user: this.user,
        lodging: this.lodging,
        from: this.koediaFrom,
        to: this.koediaTo,
        tax: this.tax,
        total: this.total,
        adults: parseInt(this.guestNumber),
        childs: this.children,
        children_ages: this.normalizeChildAges(this.childAges),
        childDate: this.childDate,
        nights: Math.ceil((this.toDate(this.to) - this.toDate(this.from)) / (1000 * 60 * 60 * 24)),
        pricePerNightHt: this.chosenIdx ? this.pricePerNightHt(this.chosenIdx) : this.pricePerNightHt,
        totalHt: this.totalHt,
        tva: this.tva,
        totalTtc: this.totalTtc,
        accommodation_code: this.accommodation_code,
        selectedPriceOptionFee: this.selectedPriceOptionFee,
        totalTaxNotKoedia: this.totalTaxNotKoedia,
        totalHtNotKoedia: this.totalHtNotKoedia,
        totalTvaNotKoedia: this.totalTvaNotKoedia,
        totalTtcNotKoedia: this.totalTtcNotKoedia,
        isChoosing: false,
        houseHold: this.houseHold,
        cancellation_message: this.cancellation_message,
        board_type: this.board_type,
        refund: this.refund,
        discountPercentage: this.discountPercentage,
        paymentSchedule: this.lodging?.payment_schedule || null,
        ospita_tracking_id: this.getReservationStateFromStorage()?.ospita_tracking_id || null,
      };
      console.log("state", state)
      this.persistReservationState(state);
    },
    saveStateNotKoedia() {
      console.log('savingggg  statee.......')
      console.log('this.selectedRoomOption', this.selectedRoomOption)
      console.log('this.roomChoosed', this.roomChoosed)
      const roomtoChoose = this.roomChoosed ? {
        ...this.roomChoosed, availabilities: []
      } : null;
      const lodgingWithoutAvailabilities = this.lodging ? {
        ...this.lodging,
        availabilities: [],
        experiences: [],
        lodging_service_entiers: [],
        lodging_services: [],
        service_entiers: [],
        services: [],
        photos_keys: []

      } : null;
      const state = {
        roomChoosed: roomtoChoose,
        selectedOption: this.selectedRoomOption,
        koediaFrom: this.koediaFrom,
        koediaTo: this.koediaTo,
        user: this.user,
        lodging: lodgingWithoutAvailabilities,
        from: this.koediaFrom,
        to: this.koediaTo,
        tax: this.tax,
        total: this.total,
        nights: Math.ceil((this.toDate(this.to) - this.toDate(this.from)) / (1000 * 60 * 60 * 24)),
        pricePerNightHt: this.pricePerNightHt(this.chosenIdx),
        totalHt: this.totalHt,
        tva: this.tva,
        adults: parseInt(this.adults),
        childs: this.children,
        children_ages: this.normalizeChildAges(this.childAges),
        totalTtc: this.totalTtc,
        selectedPriceOptionFee: this.selectedPriceOptionFee,
        totalTaxNotKoedia: this.totalTaxNotKoedia,
        totalHtNotKoedia: this.totalHtNotKoedia,
        totalTvaNotKoedia: this.totalTvaNotKoedia,
        totalTtcNotKoedia: this.totalTtcNotKoedia,
        isChoosing: false,
        houseHold: this.houseHold,
        cancellation_message: this.cancellation_message,
        board_type: this.board_type,
        refund: this.refund,
        discountPercentage: this.discountPercentage,
        paymentSchedule: this.lodging?.payment_schedule || null,
      };
      console.log("state", state)
      this.persistReservationState(state);
      console.log("finsll state", state)

    },
    async displayUserInfoKoedia(room, pricePerNightTtc, totalTtc, koediaRoomAvailability, tariff, tva, priceHt, houseHOld = null, cancellation_message = "", board_type = "", discountPercentage = 0, koediaSessionIdParam = null) {
      if (this.hasMissingChildAgesSelection()) {
        this.openGuestModal();
        return;
      }

      await this.countNights();
      this.nights = isNaN(this.nights) ? 1 : this.nights;
      this.applyReservationMeta({ cancellation_message, board_type, discountPercentage, koediaSessionIdParam });
      console.log("ROOM");
      console.log(room);

      console.log("pricePerNightTtc");
      console.log(pricePerNightTtc);

      console.log("totalTtc");
      console.log(totalTtc);

      console.log("koediaRoomAvailability");
      console.log(koediaRoomAvailability);

      this.roomChoosed = room;
      this.refund = koediaRoomAvailability.refundable
      this.selectedOption = koediaRoomAvailability;
      // this.numberOfRoom = numberOfRoom;
      this.totalTtc = totalTtc;
      this.pricePerNightHt = pricePerNightTtc;
      // this.isChoosing = false;
      this.selectedPriceOptionFee = this.resolveSelectedPriceOptionFee(koediaRoomAvailability, tariff);
      // TAX
      /*if (this.childs === 0) {
        this.totalTaxNotKoedia = (this.tax.tourist_tax * this.nights * this.adults).toFixed(2);
      } else if (this.adults === 0) {
        this.totalTaxNotKoedia = (this.tax.tourist_tax * this.nights * this.childs).toFixed(2);
      } else {
        this.totalTaxNotKoedia = (this.tax.tourist_tax * this.nights * (this.adults + this.childs)).toFixed(2);
      }*/
      let adult_num = this.guestNumber ? parseInt(this.guestNumber) : this.adults ? this.adults : 2
      this.totalTaxNotKoedia = this.lodging.tax ? (adult_num * (this.lodging.tax.tourist_tax * this.nights)).toFixed(2) : 0;

      // TOTAL HT
      this.totalHtNotKoedia = (priceHt * this.nights).toFixed(2);

      // TOTAL TVA
      this.totalTvaNotKoedia = (tva * this.nights).toFixed(2);

      // TOTAL TTC
      this.totalTtcNotKoedia = (parseFloat(this.totalHtNotKoedia) + parseFloat(this.totalTvaNotKoedia) + parseFloat(this.totalTaxNotKoedia)).toFixed(2);
      this.houseHold = houseHOld;
      this.saveState();
    },
    pricePerNightTtc(idx) {
      return parseFloat(this.roomOptions.options[idx].room_price.per_day.rack);
    },
    totalTtc(idx) {
      if (this.accommodation_code) {
        return (parseFloat(this.roomOptions.options[idx].room_price.total.rack)).toFixed(2);
      } else {
        return this.chosendTotalTtc;
      }
    },
    pricePerNightHt(idx) {
      if (this.accommodation_code) {
        return (parseFloat(this.pricePerNightTtc(idx)) / (1 + (parseFloat(this.lodging.tax.tva_rate) / 100))).toFixed(2);
      } else {
        return this.chosentPricePerNightHt;
      }
    },
    totalHt(idx) {
      if (this.accommodation_code) {
        return (parseFloat(this.totalTtc(idx)) / (1 + (parseFloat(this.lodging.tax.tva_rate) / 100))).toFixed(2);
      } else {
        return (parseFloat(this.chosendTotalTtc) / (1 + (parseFloat(this.lodging.tax.tva_rate) / 100))).toFixed(2);
      }
    },
    tva(idx) {
      return (parseFloat(this.totalTtc(idx)) - parseFloat(this.totalHt(idx))).toFixed(2);
    },
    handleClose() {
      this.isChoosing = true;
    },
    getTotalTTC() {
      if (this.total && this.tva) {
        return this.total + this.tva;
      }
      return 0;
    },
    async fetchFood() {
      try {
        const response = await fetcher.get(
          "/departments/" + this.department.id + "/food_specialties/list"
        );
        console.log("food", response.data)
        this.foodMount = response.data;
      } catch (e) {
        console.error(e);
      }
    },
    async fetchExps(cat) {
      try {
        const response = await fetcher.get(
          `/categories/${encodeURI(cat)}/experiences/list?lodging_id=${this.lodging.id}`
        );
        this.experiencesFiltered = response.data?.filter(x => x.photo_key) || [];
      } catch (e) {
        console.error(e);
      }
    },
    async fetchNearby(id) {
      try {
        const response = await fetcher.get(
          `/lodgings/${this.lodging.id}/nearby`
        );
        console.log('response.data.nearby', response.data.nearby)
        console.log('response.data', response.data)
        this.nearbyLodgings = response.data.nearby;
      } catch (e) {
        console.error(e);
      }
    },
    fetchNearby50km(id) {
      fetcher.get(`/lodgings/${id}/nearby?distance=50`)
        .then((response) => {
          this.nearbyLodgings50km = response.data.nearby;
        })
        .catch((error) => {
          console.error("Error fetching nearby lodgings:", error);
        });
    },
    formatDispo(data) {
      if (data === "disponible") {
        return "";
      } else if (data === "extra") {
        return "(en supplément)";
      } else if (data === "on_demand") {
        return "(sur demande)";
      }
    },
    async fetchLodgingByRegion() {
      try {
        const response = await fetcher.get("/reservation-hotel?search=" + this.region.name);
        if(response.data){
          this.lodgingsByRegionMounted = response.data.filter(el => el.name !== this.lodging.name);
        }
      } catch (e) {
        console.error(e);
      }
    },
    shareDevices() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
        return (this.targetShare = true);
      } else {
        return (this.targetShare = false);
      }
    },
    parseDate(dateString) {
      const [day, month, year] = dateString.split('/');
      return new Date(year, month, day);
    },
    toDate(date) {
      let d = new Date(date);
      d.setHours(12, 0, 0, 0);
      return d;
    },
    countNights() {
      console.log('this.koediaFrom nights', this.koediaFrom)
      console.log('this.koediaTo nights', this.koediaTo)

      let from = this.toDate(this.formatDateKoedia(this.koediaFrom));
      let to = this.toDate(this.formatDateKoedia(this.koediaTo));

      console.log("From:", from, "To:", to);

      if (from && to) {
        this.nights = Math.ceil((to - from) / (1000 * 60 * 60 * 24));
      } else {
        this.nights = 0;
        console.warn("Invalid date(s):", this.koediaFrom, this.koediaTo);
      }
      console.log("Nights:", this.nights);
    },
    async checkIfAvailable(checkin, checkout, guests) {
      console.log('in checkIfAvailable')
      this.searched = false;
      this.isSearching = true;
      this.show_resa_card = false;
      if (!this.accommodation_code)
      {
        setTimeout(() => {
          this.searched = true;
          this.isSearching = false;
        }, 6000);
      }
      else {
        this.koediaFrom = checkin;
        this.koediaTo = checkout;
      }
      this.updateCalendarStates();
    },
    checkIfAvailableTwo(checkin, checkout, guests) {
      console.log('checkIfAvailableTwo')
      this.searched = false;
      this.isSearching = true;
      this.show_resa_card = false;
      if (!this.ensureRoomPlansReady()) {
        this.searched = false;
        this.isSearching = false;
        return;
      }
      if (checkin && checkout) {
        console.log('checkin', checkin)
        console.log('checkout', checkout)
        this.startDate = this.formatDateKoedia(checkin);
        this.endDate = this.formatDateKoedia(checkout);
        this.printStart = this.formatDateKoedia(checkin);
        this.printEnd = this.formatDateKoedia(checkout);
        this.koediaFrom = this.formatDateKoedia(this.printStart);
        this.koediaTo = this.formatDateKoedia(this.printEnd);
        this.disstartDate = new Date(this.formatDateKoedia(checkin));
        this.disendDate = new Date(this.formatDateKoedia(checkout));

        this.adults = parseInt(this.guestNumber) || 2;

        const state = {
          koediaFrom: this.koediaFrom,
          koediaTo: this.koediaTo,
          from: this.startDate,
          to: this.endDate,
          childs: this.children,
          children_ages: this.normalizeChildAges(this.childAges),
          room_plans: this.selectMultipleRooms ? normalizeRoomPlans(this.roomPlans) : [],
          ospita_tracking_id: this.getReservationStateFromStorage()?.ospita_tracking_id || null,
        };
        if (!this.lodging.is_entire) {
          state.adults = parseInt(guests)
        }
        console.log("state", state)
        localStorage.setItem('reservationState', JSON.stringify(withOspitaTrackingId(state)));
        this.applyEventLodgingGuestDefaults({ persistState: true });
        this.updateCalendarStates();
        setTimeout(() => {
          this.searched = true;
          this.isSearching = false;
        }, 6000);
        this.scrollToElement(!this.lodging.is_entire ? 'lodging-rooms-container' : 'lodging-entire-container')
      }
    },
    formatEl(el, type) {
      const arr = type === "languages" ? this.lodging.languages : this.lodging.payments;
      return el === arr[arr.length - 1].name ? `${el}.` : `${el}, `;
    },
    formatList(string) {
      return string
        .replaceAll("\n", "")
        .replaceAll("•", "")
        .split("\t")
        .filter((s) => s);
    },
    openModal() {
      this.$root.$emit("openModal");
    },
    showModalGallery() {
      this.modalGallery = !this.modalGallery;
    },
    isUserConnected() {
      console.log("user", this.user)
      return this.user ? this.user : {};
    },
    groupByCat(key) {
      const serviceEntiers = this.service_unique();
      console.log('serviceEntiers', serviceEntiers);

      this.groupedServices = serviceEntiers.reduce((rv, x) => {
        if (x.category && x.category.name) {
          const categoryName = x.category.name;
          if (!rv[categoryName]) {
            rv[categoryName] = [];
          }
          rv[categoryName].push(x);
        } else {
          const undefinedCategory = 'Others';
          if (!rv[undefinedCategory]) {
            rv[undefinedCategory] = [];
          }
          rv[undefinedCategory].push(x);
        }
        return rv;
      }, {});

      console.log('this.groupedServices', this.groupedServices);
      this.categoryServices = Object.keys(this.groupedServices);
    },

    groupByCatEntire() {
      const serviceEntiers = this.service_entiers();
      this.groupedServiceEntiers = serviceEntiers.reduce((rv, x) => {
        const rawCategoryName = x?.category?.name;
        const normalizedCategoryName = (rawCategoryName && rawCategoryName.trim()) ? rawCategoryName.trim() : 'Others';
        const existingCategoryName = Object.keys(rv).find(
          (categoryName) => categoryName.toLowerCase() === normalizedCategoryName.toLowerCase()
        );
        const finalCategoryName = existingCategoryName || normalizedCategoryName;

        if (!rv[finalCategoryName]) {
          rv[finalCategoryName] = [];
        }

        rv[finalCategoryName].push(x);
        return rv;
      }, {});
      this.categoryServiceEntiers = Object.keys(this.groupedServiceEntiers);
    },
    selectCard(attr) {
      this.selectedMarker = !this.selectedMarker;
    },
    greenNotePicto(score) {
      if (score === `${score}`) {
        return require(`../../images/greennote ${score}.svg`);
      } else {
        return require("../../images/blanc.png");
      }
    },
    displayPicto(service) {
      const pictoName = service.name.toLowerCase().replaceAll("/", "-");
      try {
        return require(`../../images/${pictoName}.svg`);
      } catch (e) {
        return require("../../images/blanc.png");
      }
    },
    markerMap() {
      const markers = [];
      markers.push([this.lodging.longitude, this.lodging.latitude]);
      this.experiencesFiltered.map((el) => {
        markers.push([el.longitude, el.latitude]);
      });
      return markers;
    },
    displayMapfind() {
      this.markers = JSON.parse(JSON.stringify(this.markerMap()));
      this.showMapfind = !this.showMapfind;
      if (event.currentTarget.className === "link-hortense main-link") {
        setTimeout(function () {
          document.querySelectorAll(".marker").forEach((marker) => {
            marker.style.display = "none";
            marker.style.pointerEvents = "none";
          });
          if (document.querySelectorAll(".marker")[0]) {
            document.querySelectorAll(".marker")[0].style.display = "block";
          }
        }, 1);
      }
    },
     displayExperienceMap() {
       // Clear any focused experience when opening the general map
       this.saveExperienceMapScrollPosition();
       this.selectedExperienceForMap = null;
       this.showExperienceMap = !this.showExperienceMap;
     },
     showExperienceOnMap(experience) {
       this.saveExperienceMapScrollPosition();
       this.selectedExperienceForMap = experience;
       this.showExperienceMap = true;
     },
     saveExperienceMapScrollPosition() {
       if (!this.isPhone) {
         return;
       }
       // Save the current scroll position before opening the modal
       this.experienceMapScrollPosition = window.scrollY || document.documentElement.scrollTop;
     },
     restoreExperienceMapScrollPosition() {
       if (!this.isPhone) {
         return;
       }
       
       // Restore the saved scroll position after closing the modal
       if (this.experienceMapScrollPosition !== null && this.experienceMapScrollPosition !== undefined) {
         // First ensure body scrolling is re-enabled
         document.body.style.overflow = '';
         document.body.style.position = '';
         document.body.style.width = '';
         document.documentElement.style.overflow = '';
         window.scrollTo(0, this.experienceMapScrollPosition);
         document.documentElement.scrollTop = this.experienceMapScrollPosition;
         document.body.scrollTop = this.experienceMapScrollPosition;
       }
     },
     handleExperienceMapClose() {
       // Handle modal close and restore scroll position
       console.log('handleExperienceMapClose called');
       this.showExperienceMap = false;
       
       if (!this.isPhone) {
         return;
       }
       
       // Ensure DOM is updated and body styles are removed before scrolling
       this.$nextTick(() => {
          this.restoreExperienceMapScrollPosition();
       });
      },
     formatStyle(value) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    scrollToElement(div, offset = 150) {
      const el = document.querySelector(`.${div}`);
      if (!el) return;

      const elementTop = el.getBoundingClientRect().top + window.scrollY;
      const scrollTarget = elementTop - offset;

      window.scrollTo({
        top: scrollTarget,
        behavior: 'smooth'
      });
    },
    async selectOption(e) {
      const clickedAnchor = e.target.closest(".exp-category");
      if (!clickedAnchor) return;

      const activeEl = document.querySelector(".exp-category.active");
      if (activeEl) {
        activeEl.classList.remove("active");
      }

      clickedAnchor.classList.add("active");

      this.SelectedOption = clickedAnchor.querySelector("[data-value]").dataset.value;

      if (this.SelectedOption) {
        console.log(this.SelectedOption);
        await this.fetchExps(this.SelectedOption);
      } else {
        this.experiencesFiltered = [];
      }
    },
    toggleLike() {
      if (this.user && Object.entries(this.user).length !== 0) {
        fetcher.patch("/wishlists/" + this.user.id, { lodging_id: this.lodging.id }).then((res) => {
          this.wishlistLodgings = res.data.lodgings;
        });
        window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event : 'add_to_wishlist',
            ecommerce: {
              items: [{
                item_name: this.lodging.name,
                item_id: this.lodging.id,
                item_city: this.lodging.city ? this.lodging.city.name : 'Pruniers-en-Sologne',
                item_region: this.lodging && this.lodging.region ? this.lodging.region.name : 'Occitanie',
                item_category: 'lodging',
              }]
            }
          });
      } else {
        this.$root.$emit("openModal");
        this.showSignupModal = true
      }
    },
    ratedLodging() {
      if (!this.lodging.reservations) {
        this.ratedLodgings = [];
      } else {
        this.ratedLodgings = this.lodging.reservations.filter((el) => el.rated === true);
      }
      return this.ratedLodgings;
    },
    averageRate() {
      this.ratedLodgings.forEach((el) => {
        this.averageList.push(el.rate_average);
      });
      return this.averageList;
    },
    averageLodging() {
      if (this.averageList && this.averageList.length) {
        this.average = (
          this.averageList.reduce((a, b) => a + b, 0) / this.averageList.length
        ).toFixed(1);
        return this.average;
      } else {
        return (this.average = "-");
      }
    },
    isIncludeInWishlist() {
      if (this.wishlistLodgings) {
        for (const lodging of this.wishlistLodgings) {
          if (lodging.id === this.lodging.id) {
            return true;
          }
        }
      }
      return false;
    },
    fetchLodging() {
      this.ratedLodging();
      this.averageRate();
      this.averageLodging();
      this.groupByCat("category");
      this.groupByCatEntire("category");
      this.fetchLodgingByRegion();
    },
    async fetchWishlist() {
      try {
        if (this.user) {
          const response = await fetcher.get("/wishlists.json");
          this.wishlistLodgings = response.data.lodgings;
        }
      } catch (e) { }
    },
    getLocation() {
      navigator.geolocation.getCurrentPosition((pos) => {
        let currPos = new google.maps.LatLng(pos.coords.latitude, pos.coords.longitude);
        let desti = new google.maps.LatLng(this.lodging.latitude, this.lodging.longitude);
        new google.maps.DistanceMatrixService()
          .getDistanceMatrix({
            origins: [currPos],
            destinations: [desti],
            travelMode: "DRIVING",
          })
          .then((res) => {
            this.distanceBetween = (res.rows[0].elements[0].distance.value / 1000).toFixed();
          });
      });
    },
    handleScroll() {
      const scrollPosition = window.scrollY;

      // Handle sticky search bar
      const searchBar = document.querySelector('.horizontal-search-bar');

      if (searchBar) {
        const searchBarTop = searchBar.offsetTop;

        // Show sticky search bar only if scrolled past search bar AND booking form is not in view
        this.showStickySearchBar = scrollPosition > searchBarTop + 100;
      } else if (searchBar) {
        const searchBarTop = searchBar.offsetTop;
        this.showStickySearchBar = scrollPosition > searchBarTop + 100;
      }

      const top = window.pageYOffset;
      if (top > 200) {
        this.scrolled = true;
      } else {
        this.scrolled = false;
      }
    },
    service_entiers() {
      const lodgingServiceEntiers = this.lodging.lodging_service_entiers;
      const uniqueServiceEntiers = Object.values(
        lodgingServiceEntiers.reduce((acc, service) => {
          acc[service.name] = service;
          return acc;
        }, {})
      );
      return uniqueServiceEntiers;
    },
    service_unique() {
      const lodgingServiceEntiers = this.lodging.lodging_services;
      const uniqueServiceEntiers = Object.values(
        lodgingServiceEntiers.reduce((acc, service) => {
          acc[service.name] = service;
          return acc;
        }, {})
      );
      return uniqueServiceEntiers;
    },
    newFormatDate(date) {
      if (!date) return '';
      const options = { day: 'numeric', month: 'short', year: 'numeric' };
      return date.toLocaleDateString('fr-FR', options).toUpperCase().replace(/\./g, '');
    },
    increase(type) {
      this[type]++;
    },
    decrease(type) {
      if (this[type] > 0) this[type]--;
    },
    formatDate2(date) {
      if (!date) return '';

      const monthsFR = [
        'JANV.', 'FEV.', 'MARS', 'AVR.', 'MAI', 'JUIN',
        'JUIL.', 'AOÛT', 'SEPT.', 'OCT.', 'NOV.', 'DEC.'
      ];

      const day = date.getDate();
      const month = monthsFR[date.getMonth()];
      const year = date.getFullYear();

      return `${day} ${month} ${year}`;
    },
    handleDatesUpdated(payload) {
      // Reload reservation state when dates are updated from LodgingshowEntire
      const state = JSON.parse(localStorage.getItem('reservationState'));
      if (state && state.from && state.to) {
        this.disstartDate = new Date(this.formatDateKoedia(state.from.replace(/^undefined-undefined-/, '')));
        this.disendDate = new Date(this.formatDateKoedia(state.to.replace(/^undefined-undefined-/, '')));
        this.printStarttwo = this.disstartDate;
        this.printEndtwo = this.disendDate;
        this.koediaFrom = state.koediaFrom;
        this.koediaTo = state.koediaTo;
        this.printStart = this.formatDate(state.from);
        this.printEnd = this.formatDate(state.to);
        this.from = state.from;
        this.to = state.to;
        this.guestNumber = state.adults || 2;
        this.adults = state.adults || 2;
        this.children = state.childs || 0;
      }
      this.applyEventLodgingGuestDefaults({ persistState: true });
      // Skip scroll when called from event lodging auto-detection (noScroll flag)
      if (!payload || !payload.noScroll) {
        this.scrollToElement('lodging-rooms-container');
      }
    },
    handleSearchUpdated(val) {
      this.isSearching = val;
    },
    handleRoomAvailabilityUpdate(hasAvailable) {
      if (this.$refs.lodgingEntireComponent) {
        this.$refs.lodgingEntireComponent.handleRoomAvailabilityUpdate(hasAvailable);
      }
    },
    getSliderColor(value) {
      if (value >= 1 && value <= 4) {
        return '#c8e2ab';
      } else if (value === 5) {
        return '#a9d997';
      } else if (value === 6) {
        return '#8ed8a2';
      } else if (value === 7) {
        return '#7dceaf';
      } else if (value === 8) {
        return '#65b193';
      } else if (value === 9) {
        return '#4e8e75';
      } else if (value === 10) {
        return '#3b6152';
      }
      return '#c8e2ab'; // default color
    },
    getGreenNoteImage(score) {
      const roundedScore = Math.round(score);
      if (roundedScore >= 1 && roundedScore <= 4) {
        return require('../../images/greennote 4.svg');
      } else if (roundedScore >= 5 && roundedScore <= 10) {
        return require(`../../images/greennote ${roundedScore}.svg`);
      }
      return require('../../images/greennote 4.svg'); // default
    },
    toggleTooltip(tooltipName) {
      if (this.isPhone) {
        if (this.activeGreenNoteTooltip === tooltipName) {
          this.activeGreenNoteTooltip = null;
        } else {
          this.activeGreenNoteTooltip = tooltipName;
        }
      }
    },
    isLikelyMojibake(str) {
      if (typeof str !== "string" || !str.length) return false;
      // Also catch the Ã + NBSP pattern (à, é, etc. corrupted)
      return /Ã[\u00A0\s]|Ã©|Ã¨|Ã |Ã®|Ã´|Ã»|Ã§|Ã«|Ã¢|Ã¹|Ã¯|Ã¦|Ã¼|Ã½|Â |â€|â€™|â€œ|â€"|â€"/.test(str);
    },

    fixMojibake(str) {
      if (typeof str !== "string" || !str.length) return str;

      try {
        // Step 1: Replace HTML entities that crept in
        let fixed = str
          .replace(/&nbsp;/g, '\u00A0')   // named entity → actual NBSP
          .replace(/&#160;/g, '\u00A0');  // numeric entity → actual NBSP

        // Step 2: Re-encode each char as its Latin-1 byte value, then decode as UTF-8
        const bytes = Uint8Array.from(
          Array.from(fixed, char => char.charCodeAt(0) & 0xFF)
        );

        const decoded = new TextDecoder("utf-8").decode(bytes);

        // Step 3: Clean up any leftover NBSP → regular space
        return decoded.replace(/\u00A0/g, ' ');
      } catch (e) {
        return str;
      }
    },
  },
  mounted() {
    this.tax = this.lodging.tax;

    // Fetch Koedia inventory blocked dates asynchronously on mount.
    // For standard lodgings the blockedDates prop is already populated by Rails.
    if (this.isKoediaLodging) {
      this.fetchKoediaBlockedDates();
    }

    if (this.lodging.eventLodging) {
      const topBar = document.querySelector('.top-bar');
      if (topBar) {
        topBar.style.display = 'none';
      }
    }

    this.fetchNearby(this.lodging.id);
    this.fetchNearby50km(this.lodging.id);
    this.setBannerOffset();
    window.addEventListener('resize', this.setBannerOffset);
    AOS.init();
    window.addEventListener('scroll', this.handleScroll);
    this.fetchLodging();
    this.shareDevices();
    this.fetchFood();
    this.fetchExps("culturelles");
    if (this.lodging.lodging_channel_manager) {
      this.accommodation_code = this.lodging.lodging_channel_manager.accommodation_code;
    }
    if (this.rooms) {
      for (let cpt = 0; cpt < this.rooms.length; cpt++) {
        this.slice_value[cpt] = false;
      }
    }
    // Ensure HTTPS for Google Analytics tracking
    window.dataLayer = window.dataLayer || [];
    const lodgingTypeMapping = {
      Hotel: "hôtels",
      "Maison et Villa": "maisons et villas",
      Guestroom: "chambres d'hôtes",
      Lodge: "lodges et lieux insolites",
      Appartment: "appartements",
      Chalet: "chalets"
    };

    // Add page_location with HTTPS enforcement for Google Analytics
    const currentUrl = window.location.href.replace('http://', 'https://');

    window.dataLayer.push({
      event: 'view_item',
      page_location: currentUrl,
      page_title: document.title,
      ecommerce: {
        items: [{
          item_name: this.lodging.name,
          item_id: this.lodging.id,
          item_city: this.lodging.city ? this.lodging.city.name : 'Pruniers-en-Sologne',
          item_category: 'Nos hébergements',
          item_variant: lodgingTypeMapping[this.lodging.type] || "hôtels",
          item_region: this.lodging && this.lodging.region ? this.lodging.region.name : 'Occitanie'
        }]
      }
    });
    const state = this.getReservationStateFromStorage();
    if (!state && this.lodging.event_lodging) {
      const today = new Date();
      const tomorrow = new Date(today);
      tomorrow.setDate(today.getDate() + 1);
      this.koediaFrom = this.formatDateKoedia(this.formatDate(today));
      this.koediaTo = this.formatDateKoedia(this.formatDate(tomorrow));
      const defaultState = {
        koediaFrom: this.koediaFrom,
        koediaTo: this.koediaTo,
        from: this.koediaFrom,
        to: this.koediaTo,
        adults: 2,
        childs: 0,
        children_ages: [],
      };
      localStorage.setItem('reservationState', JSON.stringify(withOspitaTrackingId(defaultState)));
      this.checkIfAvailable(this.koediaFrom, this.koediaTo, 2);
    }

    if (this.lodging.is_entire && this.lodging.accommodation_capacity > 0 && !hasStoredGuestReservation(state)) {
      this.guestNumber = this.lodging.accommodation_capacity;
    }

    this.applyEventLodgingGuestDefaults({ persistState: true });


    if (this.lodging.is_entire && this.from && this.to) {
      this.koediaFrom = this.formatDateKoedia(this.from);
      this.koediaTo = this.formatDateKoedia(this.to);
      this.from = this.koediaFrom;
      this.to = this.koediaTo;

      // Call checkIfAvailable function after setting the dates
      if (state && state.from && state.to) {
        this.startDate = this.formatDate(state.from);
        this.endDate = this.formatDate(state.to);
        this.printStart = this.formatDate(state.from);
        this.printEnd = this.formatDate(state.to);
        this.koediaFrom = this.formatDateKoedia(this.printStart);
        this.koediaTo = this.formatDateKoedia(this.printEnd);
        console.log('this.startDateabcd', this.startDate)
        console.log('this.endDateteabcd', this.endDate)
        console.log('state', state)
        this.checkIfAvailable(this.koediaFrom, this.koediaTo, this.guestNumber)
      }
    }

    if (this.lodging.is_entire) {
      this.minNightsNew = this.lodging.availabilities[0]?.minimum_nights_stay;
      const urlParams = new URLSearchParams(window.location.search);
      const modify = urlParams.get('modify');

      if (modify === 'true') {
        this.scrollToElement('lodging-entire-container');
      }
    }

    const whatsappBtn = document.getElementById('whatsapp-button');
    if (whatsappBtn && this.isPhone) {
      whatsappBtn.style.setProperty('bottom', '22%', 'important');
    }
  },
  beforeMount() {
    this.fetchWishlist();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    const navbarItems = document.querySelectorAll('.bm-burger-bars');
    navbarItems.forEach((bar) => {
      bar.style.color = 'black';
      bar.style.backgroundColor = 'black';
      bar.style.border = '0.5px solid black';
    });
  },
  computed: {
    // Merges static iCal blocked dates (from Rails) with dynamically fetched
    // Koedia inventory blocked dates.  This is the single source of truth
    // passed down to every CommonDatePicker instance.
    effectiveBlockedDates() {
      const base = Array.isArray(this.blockedDates) ? this.blockedDates : [];
      const koedia = Array.isArray(this.koediaBlockedDates) ? this.koediaBlockedDates : [];
      return [...new Set([...base, ...koedia])];
    },
    supportsStructuredRoomPlans() {
      return Boolean(this.lodging?.lodging_channel_manager);
    },
    eventLodging() {
      return this.lodging.event_lodging;
    },
    roomPlanTotals() {
      return this.roomPlanTotalsFor(this.roomPlansDraft);
    },
    supplementsToDisplay() {
      const SUPPLEMENT_META = [
        { key: 'lit_appoint',     label: "Lit d'appoint",   iconSrc: require('../../images/ic_lit_appoint.svg') },
        { key: 'lit_bebe',        label: 'Lit bébé',         iconSrc: require('../../images/ic_lit_bebe.svg') },
        { key: 'spa',             label: 'Spa',              iconSrc: require('../../images/ic_spa.svg') },
        { key: 'parking',         label: 'Parking',          iconSrc: require('../../images/ic_parking.svg') },
        { key: 'animaux',         label: 'Animaux',          iconSrc: require('../../images/ic_animaux.svg') },
        { key: 'petit_dejeuner',  label: 'Petit déjeuner',   iconSrc: require('../../images/ic_petit_dejeuner.svg') },
        { key: 'dejeuner',        label: 'Déjeuner',         iconSrc: require('../../images/ic_diner.svg') },
        { key: 'diner',           label: 'Diner',            iconSrc: require('../../images/ic_diner.svg') },
        { key: 'panier_repas',    label: 'Panier repas',     iconSrc: require('../../images/ic_panier_repas.svg') },
        { key: 'massages_soins',  label: 'Massages & soins', iconSrc: require('../../images/ic_massages_soins.svg') },
      ];
      const VALID_SELECTIONS = ['sur_demande', 'gratuit', 'payant'];
      const normalizeSelectionOptions = (entry) => {
        if (!entry) return [];

        const fromOptions = Array.isArray(entry.selection_options)
          ? entry.selection_options.filter((value) => VALID_SELECTIONS.includes(value))
          : [];

        if (fromOptions.length > 0) {
          return [...new Set(fromOptions)];
        }

        if (entry.selection && VALID_SELECTIONS.includes(entry.selection)) {
          return [entry.selection];
        }

        return [];
      };

      const raw = this.lodging.lodging_profile && this.lodging.lodging_profile.supplements
        ? { ...this.lodging.lodging_profile.supplements }
        : {};

      if (raw.dejeuner_diner) {
        if (!raw.dejeuner) raw.dejeuner = { ...raw.dejeuner_diner };
        if (!raw.diner) raw.diner = { ...raw.dejeuner_diner };
      }

      return SUPPLEMENT_META
        .filter(meta => normalizeSelectionOptions(raw[meta.key]).length > 0)
        .map(meta => {
          const entry = raw[meta.key] || {};
          const selectionOptions = normalizeSelectionOptions(entry);
          return {
            ...meta,
            price: entry.price || '',
            info: entry.info || '',
            selectionOptions,
          };
        });
    },
     managerMeetTruncateLength() {
       return this.lodging.lodging_description.chief_photo
         ? 350
         : 450;
     },
     managerLineClampClass() {
       const hasNameAndDesignation = this.lodging.lodging_description.manager_name && 
                                     this.lodging.lodging_description.manager_designation;
       return hasNameAndDesignation ? 'line-clamp-6' : 'line-clamp-8';
     },
     chefLineClampClass() {
       const hasNameAndDesignation = this.lodging.lodging_description.chef_name && 
                                     this.lodging.lodging_description.chef_designation;
       return hasNameAndDesignation ? 'line-clamp-6' : 'line-clamp-8';
     },
     environmentImagesExists() {
      return this.lodging.lodging_description.green_host || this.lodging.lodging_description.green_globe ||
              this.lodging.lodging_description.green_key || this.lodging.lodging_description.ecolabel;
    },
    serviceCategoryLimit() {
      return this.isPhone ? 2 : 3;
    },
    limitedGroupedServiceEntiers() {
      if (!this.groupedServiceEntiers) return {};
      const entries = Object.entries(this.groupedServiceEntiers);
      const limited = entries.slice(0, this.serviceCategoryLimit);
      return Object.fromEntries(limited);
    },
    limitedGroupedServices() {
      if (!this.groupedServices) return {};
      const entries = Object.entries(this.groupedServices);
      const limited = entries.slice(0, this.serviceCategoryLimit);
      return Object.fromEntries(limited);
    },
    itemsDisplayLength() {
      return this.isPhone ? 5 : 9;
    },
    importantInfoItems() {
      const items = [];
      
      // Heure d'arrivée
      if (this.lodging.lodging_profile.checkin_hour) {
        items.push({
          type: 'simple',
          class: 'raleway-reg-p15 arrival',
          text: `Heure d'arrivée : ${this.lodging.lodging_profile.checkin_hour}`
        });
      }
      
      // Heure de départ
      if (this.lodging.lodging_profile.checkout_hour) {
        items.push({
          type: 'simple',
          class: 'raleway-reg-p15 departure',
          text: `Heure de départ : ${this.lodging.lodging_profile.checkout_hour}`
        });
      }
      
      // Réservé aux adultes
      if (this.lodging.lodging_profile.adult_only) {
        items.push({
          type: 'simple',
          class: 'raleway-reg-p15 adult-only',
          text: 'Réservé aux adultes'
        });
      }
      
      // Accessible aux PMR
      if (this.lodging.lodging_profile.pmr_access) {
        items.push({
          type: 'simple',
          class: 'raleway-reg-p15 pmr',
          text: 'Accessible aux PMR'
        });
      } else {
        items.push({
          type: 'simple',
          class: 'raleway-reg-p15 pmr',
          text: 'Non accessible aux PMR'
        });
      }
      
      // Chambres fumeurs/non-fumeurs
      if (!this.lodging.lodging_profile.smoking) {
        items.push({
          type: 'simple',
          class: 'raleway-reg-p15 pmr',
          text: 'Chambres non-fumeurs'
        });
      } else {
        items.push({
          type: 'simple',
          class: 'raleway-reg-p15 pmr',
          text: 'Chambres fumeurs'
        });
      }
      
      // Animaux de compagnie
      if (this.lodging.lodging_profile.animal) {
        items.push({
          type: 'simple',
          class: 'raleway-reg-p15 pet-accepted',
          text: 'Animaux de compagnie admis'
        });
      } else {
        items.push({
          type: 'simple',
          class: 'raleway-reg-p15 pet-accepted',
          text: 'Animaux de compagnie non-admis'
        });
      }
      
      // Moyens de paiement acceptés
      if (this.lodging.payments && this.lodging.payments.length > 0) {
        items.push({
          type: 'nested',
          class: 'raleway-reg-p15 mb-0 payement',
          label: 'Moyens de paiement acceptés :',
          items: this.lodging.payments.map(payment => this.formatEl(payment.name, "payments"))
        });
      }
      
      // Lit d'appoint disponible
      if (this.lodging.lodging_profile.extra_bed) {
        items.push({
          type: 'simple',
          class: 'raleway-reg-p15 apoint-bed',
          text: 'Lit d\'appoint disponible'
        });
      }
      
      // Langues parlées
      if (this.lodging.languages && this.lodging.languages.length > 0) {
        items.push({
          type: 'nested',
          class: 'raleway-reg-p15 mb-0 languages',
          label: 'Langues parlées :',
          items: this.lodging.languages.map(language => this.formatEl(language.name, "languages"))
        });
      }
      
      // Gare la plus proche
      if (this.lodging.lodging_profile.nearest_station) {
        items.push({
          type: 'with-paragraph',
          class: 'raleway-reg-p15 mb-0',
          label: 'Gare la plus proche :',
          text: this.lodging.lodging_profile.nearest_station
        });
      }

      // Plage la plus proche
      if (this.lodging.lodging_profile.nearest_beach) {
        items.push({
          type: 'with-paragraph',
          class: 'raleway-reg-p15 mb-0',
          label: 'Plage la plus proche :',
          text: this.lodging.lodging_profile.nearest_beach
        });
      }
      
      return items;
    },
    formattedBannerDates() {
      if (this.printStarttwo && this.printEndtwo) {
        console.log('this.printStarttwo', this.printStarttwo);
        const options = { day: 'numeric', month: 'short' };
        const start = new Date(this.printStarttwo).toLocaleDateString('fr-FR', options);
        const end = new Date(this.printEndtwo).toLocaleDateString('fr-FR', options);
        return `${start} - ${end}`;
      }
      return '';
    },
    photoUrls() {
      return this.lodging.photos_keys ? this.lodging.photos_keys.map(photo => photo.url) : [];
    },
    totalPhotos() {
      return this.photoUrls.length;
    },
    chunkedRooms() {
      if (this.rooms) {
        if (this.rooms.length <= 4) {
          return [this.rooms];
        } else {
          return [this.rooms];
        }
      }
    },
    backgroundClass() {
      return this.lodging.photo_second_banner ? 'dynamic-background' : 'default-background';
    },
    isPhone() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
        return true;
      } else {
        return false;
      }
    },
    /*isAvailable() {
      if(this.accommodation_code)
      {
          return this.roomOptions !== null;
      }else{
        return this.availabilitiesNotKoedia.length > 0;
      }
    },*/
    availabilitySearchButtonCaption() {
      if (this.isSearching) {
        return "Recherche en cours...";
      } else {
        return "Vérifier les disponibilités";
      }
    },
    comments() {
      console.log('this.lodginhg', this.lodging)
      return this.lodging.comments;
    },
    country() {
      return this.lodging.country;
    },
    region() {
      return this.lodging.region;
    },
    department() {
      return this.lodging.department;
    },
    city() {
      return this.lodging.city;
    },
    styles() {
      return this.lodging.styles;
    },
    services() {
      return this.lodging.lodging_services;
    },
    service_rooms() {
      return this.lodging.lodging_service_rooms;
    },
    service_essentials() {
      return this.lodging.service_essentials;
    },
    kids_corners() {
      return this.lodging.kids_corners;
    },
    service_mesures() {
      return this.lodging.service_mesures;
    },
    photos() {
      return this.lodging.photos_keys;
    },
    pol() {
      return this.lodging.average_score_for_POL;
    },
    soc() {
      return this.lodging.average_score_for_SOC;
    },
    per() {
      return this.lodging.average_score_for_PER;
    },
    cli() {
      return this.lodging.average_score_for_CLI;
    },
    ach() {
      return this.lodging.average_score_for_ACH;
    },
    eau() {
      return this.lodging.average_score_for_EAU;
    },
    dec() {
      return this.lodging.average_score_for_DEC;
    },
    ene() {
      return this.lodging.average_score_for_ENE;
    },
    con() {
      return this.lodging.average_score_for_CON;
    },
    env() {
      return this.lodging.average_score_for_ENV;
    },
    resaMount() {
      return this.lodging.reservations;
    },
    standing() {
      return this.lodging.standing;
    },
    questionList() {
      return this.lodging.questions;
    },
    total() {
      if (this.startDate && this.endDate) {
        const datestartDate = this.lodging.availabilities.find((el) => el.date === this.startDate);
        const indexFrom = this.lodging.availabilities.indexOf(datestartDate);
        const dateendDate = this.lodging.availabilities.find((el) => el.date === this.endDate);
        const indexTo = this.lodging.availabilities.indexOf(dateendDate);

        return this.lodging.availabilities
          .slice(indexFrom, indexTo + 1)
          .reduce((acc, current) => acc + current.pricing, 0);
      }
      return 0;
      return (this.tva = ((this.totalHt * this.lodging.tax.tva_rate) / 100).toFixed(2));
    },
    experienceName() {
      if (this.lodging.experience_name) {
        const words = this.lodging.experience_name.split('\n');
        const firstWord = words.shift();
        const restOfSentence = words.join(' ');
        return [firstWord, restOfSentence];
      } else {
        return null;
      }
    },
    fullLocation() {
      const capitalize = (str) => {
        if (!str) return '';
        return str
          .split('-') // split on hyphens
          .map(part =>
            part
              .split(' ') // split on spaces within each hyphen part
              .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
              .join(' ')
          )
          .join('-');
      };

      const { country, region, department } = this.lodging;

      return [country?.name, region?.name, department?.name]
        .filter(Boolean)
        .map(capitalize)
        .join(', ');
    },
    hasTravelGuideLink() {
      const description = this.lodging.lodging_description;
      const hasValidLink = description.travel_guide_link && description.travel_guide_link != '' && description.travel_guide_link != null && description.travel_guide_link != 'null';
      const hasValidImage = description.travel_guide_image && description.travel_guide_image != '' && description.travel_guide_image != null && description.travel_guide_image != 'null';
      return hasValidLink && hasValidImage;
    },

    tripadvisorAllReviews() {
      const all = Array.isArray(this.lodging?.ratings) ? this.lodging.ratings : [];
      const clean = all
        .filter(r => (r && (r.title || r.review)))
        .map((rating) => {
          const nextRating = { ...rating };
          
          if (typeof rating?.review === "string" && this.isLikelyMojibake(rating.review)) {
            const fixedReview = this.fixMojibake(rating.review);
            if (fixedReview) {
              nextRating.review = fixedReview;
            }
          }

          if (typeof rating?.title === "string" && this.isLikelyMojibake(rating.title)) {
            const fixedTitle = this.fixMojibake(rating.title);
            if (fixedTitle) {
              nextRating.title = fixedTitle;
            }
          }

          return nextRating;
        });

      clean.sort((a, b) => {
        const da = new Date(a.rated_at || a.created_at || 0).getTime();
        const db = new Date(b.rated_at || b.created_at || 0).getTime();
        return db - da;
      });

      return clean;
    },

    tripadvisorReviews() {
      return this.tripadvisorAllReviews.slice(0, 10);
    },

    tripadvisorGlobalRating() {
      // const vals = this.tripadvisorAllReviews
      //   .map(r => Number(r.global))
      //   .filter(n => Number.isFinite(n) && n > 0);

      // if (vals.length) {
      //   const avg = vals.reduce((a, b) => a + b, 0) / vals.length;
      //   return avg.toFixed(1);
      // }

      // const raw = this.lodging?.lodging_description?.rating_value ?? this.average;
      // const num = Number(raw);
      // console.log("ids:", this.tripadvisorReviews.map((r, i) => [i, r.id, r.review_id, r.uuid]));

      return ((this.lodging?.lodging_description?.rating_value) && this.lodging?.lodging_description?.rating_value > 0) ? this.lodging?.lodging_description?.rating_value : "5.0";
    },
    tripadvisorReviewsPadded() {
        const list = Array.isArray(this.tripadvisorReviews) ? this.tripadvisorReviews : [];
        const perView = 3;

        if (list.length === 0) return [];

        const target = Math.ceil(list.length / perView) * perView;

        const padded = list.slice();
        let i = 0;

        while (padded.length < target) {
          const base = list[i % list.length];
          padded.push({
            ...base,
            __isClone: true,
            __cloneIndex: padded.length, 
          });
          i++;
        }

        return padded;
      }

  },
};
</script>

<style lang="scss">
.traveler-reviews {
  .slither-slider-slides {
    overflow: visible !important;
    height: fit-content !important;
  }
}
</style>

<style lang="scss">
// ── Tarifs & supplémentaires ──────────────────────────────────────────────────
.tarifs-supplements {
  margin-bottom: 10px;

  h2 {
    color: #1a2e25;
    margin-bottom: 0.2rem;
  }

  .supplements-subtitle {
    color: #555;
    margin-bottom: 1rem;
    margin-top: 0;
  }
  
  .supplements-table {
    display: flex;
    background: #eef4f0;
    border: 1px solid #ccddd5;
    border-radius: 16px;
    overflow: hidden;
  }

  .supplements-table--single {
    width: fit-content;

    .supplement-col {
      flex: 0 0 auto;
      border-right: none;
      min-width: 240px;
    }
  }

  .supplement-col {
    flex: 1 1 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 1rem 1rem 0.95rem;
    border-right: 1px solid #ccddd5;
    min-width: 0;

    &.supplement-col--last {
      border-right: none;
    }
  }

  .supplement-col-icon {
    width: 32px;
    height: 32px;
    object-fit: contain;
    margin-bottom: 0.55rem;
    filter: brightness(0) saturate(100%) invert(27%) sepia(30%) saturate(600%) hue-rotate(110deg) brightness(85%);
  }

  .supplement-col-label {
    font-family: 'Raleway', sans-serif;
    font-weight: 600;
    font-size: 15px;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #3B6152;
    line-height: 1.25;
    margin-bottom: 0.1rem;
    min-height: 1.8em;
  }

  .supplement-col-price {
    font-family: 'Merriweather', serif;
    font-size: 1.5rem;
    font-weight: 400;
    color: #3B6152;
    line-height: 1.1;
    margin-bottom: 0.15rem;
  }

  .supplement-col-info {
    font-family: 'Raleway', sans-serif;
    font-weight: 400;
    color: #3B6152;
    font-size: 0.78rem;
    line-height: 1.3;
    margin-bottom: 0.6rem;
    min-height: 2.1em;
  }

  .supplement-col-badges {
    display: flex;
    flex-wrap: wrap;
    gap: 0.4rem;
    margin-top: auto;
  }

  .supplement-col-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.4rem 1rem;
    border-radius: 999px;
    font-family: 'Raleway', sans-serif;
    font-size: 0.78rem;
    font-weight: 700;
    white-space: nowrap;
    text-align: center;

    &.supplement-badge--sur_demande {
      background-color: #2C5E4B;
      color: #ffffff;
    }

    &.supplement-badge--gratuit {
      background-color: #d4eddf;
      color: #2C5E4B;
      border: 1px solid #2C5E4B;
    }

    &.supplement-badge--payant {
      background-color: #b8924a;
      color: #ffffff;
    }
  }

  // ── Mobile: 2-column grid ──
  @media (max-width: 767px) {
    .supplements-table-wrapper {
      overflow-x: visible;
    }

    .supplements-table {
      display: grid;
      grid-template-columns: 1fr 1fr;
      border-radius: 14px;
      overflow: hidden;
    }

    .supplement-col {
      flex: none;
      border-right: 1px solid #ccddd5;
      border-bottom: 1px solid #ccddd5;
      padding: 0.8rem 0.75rem;
      min-height: 0;

      // Remove right border on every 2nd column (right edge)
      &:nth-child(2n) {
        border-right: none;
      }

      // If only 1 item in last row (odd total), span full width
      &.supplement-col--last:nth-child(odd) {
        grid-column: 1 / -1;
        border-right: none;
      }

      &.supplement-col--last {
        border-bottom: none;
      }
    }

    .supplement-col-icon {
      width: 26px;
      height: 26px;
      margin-bottom: 0.5rem;
    }

    .supplement-col-label {
      font-size: 0.65rem;
      min-height: auto;
      margin-bottom: 0.4rem;
    }

    .supplement-col-price {
      font-size: 1.2rem;
    }

    .supplement-col-info {
      font-size: 0.72rem;
      min-height: auto;
      margin-bottom: 0.6rem;
    }

    .supplement-col-badge {
      font-size: 0.7rem;
      padding: 0.35rem 0.75rem;
    }
  }
}
</style>
<style lang="scss" rel="stylesheet">
@import "app/assets/stylesheets/components/lodging-show.scss";

#lodging-show {
  .vue-slider-disabled {
    opacity: 1 !important;
  }
}

#ending-bar {
  height: 1px;
  background-color: transparent;
}

.kids-mobile {
  display: flex;
  flex-direction: column;

  .image-section {
    width: 100%;
    height: 200px;
    background-image: url("https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/kids-corner.jpg");
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: left;
    justify-content: flex-start;
    padding-left: 1rem;
    padding-top: 1rem;

    h1 {
      font-size: 2rem;
      font-weight: bold;
      color: white;
      text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.6);
    }
  }

  .content {
    padding-top: 20px;
    padding-left: 5px;
    padding-right: 5px;
    padding-bottom: 10px;

    p {
      margin-top: 5px;
    }
  }
}

.kids-corner {
  display: flex;
  flex-direction: row;
  width: 92%;

  .left-section {
    flex: 1;
    background-image: url("https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/kids-corner.jpg");
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    color: white;
    text-align: center;
    padding: 1rem;
    min-height: 100%;
    height: auto;
  }

  .content {
    flex: 1.2;
    padding-left: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .description {
      p {
        margin-top: 10px;
        font-family: "Raleway";
      }

      .dynamic {
        list-style-type: disc;
        padding-left: 20px;
        font-family: "Raleway";
      }
    }
  }
}

.vhd__datepicker__clear-button svg {
  left: -27% !important;
  display: none;
}

.fixed-card {
  position: fixed;
  right: 20px;
  top: 100px;
  width: 350px;
  max-width: 100%;

  .card-resa-entire {
    box-shadow: 0 2px 8px 0 rgba(129, 129, 129, 0.5);
  }
}

.fixed-banner {
  width: 100%;
  background-color: #FFFFFF;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 10px 20px;
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.2);
}

.fixed-banner-main {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.top-note-bar {
  background-color: #CFE5DC;
  text-align: center;
  font-size: 14px;
  padding: 6px 0;
  font-weight: 500;
  color: #2f5d2f;
  font-family: "Raleway";
}

.banner-content {
  display: flex;
  flex-direction: column;
}

.banner-price {
  font-family: $Raleway;
  font-weight: 400;
  font-size: 14px;
  color: black;
}

.banner-dates {
  font-family: "Raleway";
  color: black;
}

.banner-button {
  background-color: #3B6152;
  color: white;
  border: none;
  padding: 10px 8px;
  cursor: pointer;
  font-family: $Raleway;
  font-weight: 700;
  font-size: 13px;
}

.slider-arrow {
  width: 40px;
  height: 40px;
  background-color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  cursor: pointer;
}

.slider-arrow img {
  width: 18px;
  height: 18px;
}

.previousss {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
}

.nexttt {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
}

.arroww {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: white;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.previous-arrow {
  left: -20px;
}

.next-arrow {
  right: -20px;
}

.arroww img {
  width: 20px;
  height: 20px;
}

.slider {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.slider-wrapper {
  display: flex;
  transition: transform 0.4s ease-in-out;
  will-change: transform;
  width: 100%;
  height: 565px;
}

.slider-slide {
  width: 100%;
  flex-shrink: 0;
  position: relative;
}

.slider-image {
  width: 100%;
  height: 565px;
  object-fit: cover;
}

.back-arrow {
  top: 10%;
  left: 10px;
  z-index: 2000;
  position: absolute;
  transform: translateY(-50%);
  background-color: white;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.back-arrow-image {
  width: 24px;
  height: 24px;
}


.arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: white;
  border: none;
  border-radius: 50%;
  width: 3.1rem;
  height: 3.1rem;
  cursor: pointer;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
}


.arrow:hover {
  opacity: 1;
}

.arrow-image {
  width: 0.7rem;
  height: auto;
}

.left-arrow {
  left: 2px;
}

.right-arrow {
  right: 2px;
}

.show-more-btn {
  color: #3B6152;
}

.title-textt {
  text-align: center;
  font: normal normal bold 19px/24px Raleway;
  letter-spacing: 0px;
  color: #000000;
  text-transform: uppercase;
  opacity: 1;
}

.padding_bottom {
  padding-bottom: 10vw;
}

.link-hortense {
  cursor: pointer;
}

.capacity {
  display: flex;
  align-items: center;
  margin-left: 1rem;
  margin-left: auto;
}

.center {
  background-position: center;
  background-size: cover;
}

@media only screen and (max-device-width: 480px) {
  .kids-mobile {
    .content {
      padding-left: 0px;
      padding-right: 0px;
      padding-bottom: 1px;
    }
  }

  .lodging-header-desktop {
    display: none !important;
  }

  .vhd__datepicker__wrapper {
    background: none !important;
  }
}

.vhd__datepicker__wrapper {
  background: none !important;
}

@media only screen and (min-device-width: 481px) {
  .container-lodging {
    margin-top: 0 !important;
  }

  .lodging-header-container {
    display: none;
  }
}

.lodging-made-trip {
  text-align: center;
  border-color: #cddfd3;
  border-style: solid;
  border-width: 1px;
  border-top-right-radius: 20px 20px;
  border-bottom-right-radius: 20px 20px;
  border-bottom-left-radius: 20px 20px;
  height: fit-content;
  width: 200px;
  margin-top: 250px;
  padding: 0.5rem 1rem 0.5rem 0.5rem;
  position: absolute;
  //left: 71%;
  max-width: 400px;
  width: 100%;

  @media (max-width: 480px) {
    left: 4%;
    margin-top: 1em;
    position: relative;
    max-width: 370px;
    width: 92%;
  }

  .image-container {
    display: flex;
    justify-content: start;
    align-items: start;
  }

  .image-container img {
    flex: 1;
    max-width: 100%;
    height: auto;
    width: auto;
    margin: 0;
    padding: 0;
  }

  #navbar-main .nav-phone {
    background-color: transparent !important;
  }

  .head {
    display: flex;

    img {
      width: 32px;
      height: 32px;
    }

    .content {
      display: flex;
      flex-direction: row;
      justify-content: center;
    }

    .modal-arrow {
      .arrow {
        width: 14px;
        height: 14px;
      }
    }
  }

  #lodging-show {
    .nav-lodging {
      height: fit-content !important;
    }
  }
}

.lodging-show-raleway-reg-p26-b {
  font-family: $Merriweather;
  font-weight: 400;
  font-size: 23px;
}

.__card__data {
  margin: 40px 0;
}

.__leave {
  border: 1px solid white;
  border-radius: 100%;
  height: 80px;
  width: 80px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: -40px;
}

.__leave_image {
  width: 80px;
  height: 80px;
  border-radius: 100%;
}

.__border_item {
  border: 1px solid #435f53;
}

._title {
  font-weight: bold;
  font-size: 22px;
}

._sub_title {
  background: #435f53;
  color: white;
  display: inline-block;
  font: normal normal bold 16px/32px Raleway;
  letter-spacing: 0px;
  text-transform: uppercase;
  opacity: 1;
}

._sub_title_right {
  background: black;
  color: white;
  display: inline-block;
  font: normal normal bold 16px/32px Raleway;
  letter-spacing: 0px;
  text-transform: uppercase;
  opacity: 1;
}

.raleway-reg-p24-two {
  text-align: left;
  font: normal normal bold 16px/32px Raleway;
  letter-spacing: 0px;
  text-transform: uppercase;
  opacity: 1;
}

.check {
  gap: 10px;
}

.__bg {
  background: #DFEDE0;
}

.__btn {
  outline: none;
  border: 1px solid #435f53;
  color: #435f53;
  background: transparent;
  padding: 0 12px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  white-space: normal;
  word-wrap: break-word;
}

.__btn___secondary {
  background: #435f53;
  outline: none;
  border: none;
  padding: 10px 24px;
  text-transform: uppercase;
  text-align: center;
  font: normal normal bold 22px/32px Raleway;
  color: #FFFFFF;
  opacity: 1;
}

.__btn_text {
  color: #435f53;
}

.____link {
  display: block;
  color: black;
  text-decoration: underline;
}

.__card_flower {
  position: relative;
  border: 2px solid white;
  height: 100%;
}

.__card_flower:nth-child(2),
.__card_flower:nth-child(3) {
  border-right: none;
}

@media (max-width: 767.98px) {
  .__card_flower .text-center {
    padding: 10px 0;
  }

  .check img {
    width: 50px;
  }

  .check {
    padding-left: 0 !important;
  }

  .__card_flower {
    height: auto;
    margin-bottom: 20px;
  }

  .__leave {
    height: 60px;
    width: 60px;
  }

  .__leave_image {
    width: 60px;
    height: 60px;
  }
}

@media (min-width: 768px) and (max-width: 991.98px) {
  .__card_flower .text-center {
    padding: 15px 0;
  }

  .check img {
    width: 50px;
  }

  .__card_flower {
    height: auto;
  }

  .__leave {
    height: 70px;
    width: 70px;
  }

  .__leave_image {
    width: 70px;
    height: 70px;
  }
}

._raleway-reg-p13 {
  font-family: $Raleway;
  font-weight: 400;
  font-size: 15px;
}

._raleway-reg-text {
  font-family: $Raleway;
  font-size: 12px;
}

.raleway-reg-p24-two {
  text-align: left;
  text-transform: uppercase;
  font-weight: 600;
  font-size: 17px;
}

.card_border {
  border-right: none;
}

/* Icon positioning to make sure it stays at the top */
.__leave {
  border: 1px solid white;
  border-radius: 100%;
  height: 80px;
  width: 80px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: -40px;
  /* Adjust this to make sure the icon stays at the correct height */
}

.mobile-main {
  padding-left: 1rem !important;
}

.__leave_image {
  width: 80px;
  height: 80px;
  border-radius: 100%;
}

.mobile-bullett {
  padding-top: 10px !important;

}

/* Make the container scrollable horizontally */
@media (max-width: 480px) {
  .card-scroll-container {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    padding: 10px 0;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    padding-top: 40px;
  }

  .card-item {
    flex: 0 0 auto;
    width: 90%;
    /* Set the card width as per requirement, change as necessary */
    max-width: 250px;
    /* Maximum width for larger screens */
    scroll-snap-align: start;
    margin-right: 15px;
    /* Adjust for spacing between cards */
  }

  .card_border {
    border-right: 1px solid white;
  }

  .__btn {
    outline: none;
    border: 1px solid #435f53;
    color: #435f53;
    background: transparent;
    padding: 0 12px;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    white-space: normal;
    word-wrap: break-word;
    text-align: center;
  }

  .card-scroll-container>div {
    flex: 0 0 auto;
    scroll-snap-align: start;
    margin-right: 15px;
    /* Adjust for spacing between cards */
  }

  .__card__data .row {
    display: flex;
    overflow-x: auto;
    white-space: nowrap;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
  }

  .__card_flower {
    flex: 0 0 auto;
    min-width: 80%;
    margin-right: 10px;
    scroll-snap-align: center;
  }

  .__leave {
    height: 60px;
    width: 60px;
  }

  .__leave_image {
    width: 60px;
    height: 60px;
  }

  .__btn {
    font-size: 13px;
    padding: 5px 10px;
  }

  .mobile-img {
    margin-top: 10px;
  }

  .mobile-drink {
    width: 100%;
  }

  .mobile-bullett {
    padding-top: 0px !important;
    padding-left: 0px !important;
    padding-bottom: 0px !important;

  }

  .mobile-bul {
    width: 50px;
  }

  .mobile-ujd {
    margin-right: 10px;
    padding-top: 20px;
  }

  /* Ensure the description stays at the bottom and does not scroll */
  ._raleway-reg-text {
    position: static;
    /* Ensure it stays in place */
    padding-top: 20px;
  }

  .h-80 {
    height: 106% !important;
  }
}

.input-wrapper {
  position: relative;
  display: inline-block;
}

.input-icon {
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  pointer-events: none;
}

.person-pad {
  padding-left: 40px;
}

@media screen and (min-width: 769px) {
  .dicsover-lodging-state {
    padding: 1rem 3rem !important;
  }
}



.portrait-custom-border {
  position: relative;
  width: 150px;
  /* Adjust size as needed */
  height: 150px;
  /* Adjust size as needed */
  margin-top: 27px;
}

.portrait-custom-border .background-border {
  position: absolute;
  top: 0;
  left: 0;
  width: 115%;
  height: 115%;
  object-fit: cover;
  z-index: 1;
  /* Below the inner image */
}

.portrait-custom-border .inner-image {
  position: relative;
  width: 150px;
  /* Adjust inner image size */
  height: 150px;
  /* Adjust inner image size */
  object-fit: cover;
  border-radius: 50%;
  /* Keep the image circular */
  z-index: 2;
  /* Above the background border */
  margin-left: 11px;
  margin-top: 11px;
}

.reservation-sorter {
  border: 1px solid black;
  border-radius: 26px;
  padding: 10px 16px;
}

.left-black-bar {
  background-color: black;
  color: white;
  padding: 2rem;
  height: 60%;
  font-family: Arial, sans-serif;
  margin-bottom: 2rem;
  left: 2%;
  margin-top: 2%;
}

.left-black-bar h2 {
  font: normal normal bold 20px/24px Raleway;
  color: #FFFFFF;

}

.left-black-bar p {
  font: normal normal normal 14px/26px Raleway;
  letter-spacing: -0.08px;
  color: #FFFFFF;

}

.left-black-bar ul {
  list-style: none;
  padding: 0;
  margin-bottom: 1.5rem;
  font: normal normal bold 14px/16px Raleway;
  letter-spacing: -0.16px;
  color: #FFFFFF;
}

.left-black-bar ul li {
  font-size: 1rem;
  margin-bottom: 0.5rem;
  font: normal normal bold 14px/16px Raleway;
  letter-spacing: -0.16px;
  color: #FFFFFF;
}

.btn-member {
  display: block;
  width: 100%;
  border: 1px solid #FFFFFF;
  padding: 0.8rem;
  font-size: 0.8rem;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  margin-bottom: 1rem;
  color: #FFFFFF;
}

.already-member {
  font: normal normal normal 14px/26px Raleway;
  letter-spacing: -0.08px;
  color: #FFFFFF;
}

.already-member a {
  color: white;
  text-decoration: underline;
}

.already-member a:hover {
  text-decoration: none;
}

.custom-tick-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 1rem;
}

.custom-tick-list li {
  display: flex;
  align-items: center;
  font-size: 1rem;
  color: white;
  margin-bottom: 0.5rem;
}

.custom-tick-list li::before {
  content: "✔";
  font-size: 0.8rem;
  color: #3b6152;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  background: #ffffff;
  border-radius: 50%;
  margin-right: 10px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

@media (min-width: 768px) {
  .custom-tick-list {
    flex-direction: row;
    flex-wrap: wrap;
  }

  .custom-tick-list li {
    margin-bottom: 0;
    margin-right: 2rem;
  }
}


.nav-phone {
  .logo {
    z-index: 1 !important;
  }
}

.h-80 {
  height: 96% !important;
}

.col-planet {
  background-image: url("../../images/illus green note.png");
}

#main-lodging-resto {
  .lodging-resto-side-section {
    background-image: url("../../images/fond-atable.png");
  }
}

.fixed-bannertwo {
  background-color: #CFE5DC;
  color: #2f5d2f;
  font-weight: 500;
  font-size: 14px;
  padding: 8px 12px;
  border-radius: 2px;
  display: inline-block;
  font-family: "Raleway", sans-serif;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px -3px 50px rgba(0, 0, 0, 0.25);
  white-space: nowrap;
}

.bottom-content {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
}

.pr-6rm {
  padding-right: 6rem !important;
}

.date-block-2 {
  border-right: 1px solid #dee2e6 !important;
}

@media only screen and (max-width: 992px) {
  .pr-6rm {
    padding-right: 15px !important;
  }
}

@media only screen and (max-width: 768px) {

  .card-room {
    padding: 12PX !important;

  }

  .rooms-classy {
    padding: 1rem 3rem !important;
  }

  .date-block {
    margin-bottom: 20px;

  }

  .date-block-2 {
    border-right: none !important;
  }

  .traveler-summary {
    padding-top: 5px;
    border-top: 1px solid #dee2e6 !important;
  }

  .traveler-info {
    margin-top: 20px;
    display: flex;
    align-items: center;
  }

  .traveler-info .label {
    margin-right: 5px;
  }

  .booking-header .date-selector {
    width: 650% !important;
  }

  .booking-header .label,
  .booking-header .value {
    font-size: 14px !important;
  }
}

@media screen and (max-width: 578px) {
  .header-room {
    justify-content: space-between !important;
  }

  .header-room h2 {
    margin-right: 0 !important;
  }

  .rooms-classy {
    padding: 1rem !important;
  }

  .col-room {
    padding: 0 !important;
  }
}

@media screen and (max-width: 410px) {
  .header-room h2 {
    font-size: 18px;
  }
}

@media screen and (max-width: 480px) {
  .vhd__datepicker {
    z-index: 1002 !important;
    max-height: unset !important;
  }

  .fixed-banner {
    z-index: 1001;
  }
}

.no-experience {
  padding-bottom: 5rem;
}
</style>

<style scoped>
/* Tooltip Styles */
.tooltip-icon {
  color: #3B6152;
  cursor: pointer;
  font-size: 14px;
  position: relative;
  transition: color 0.2s ease;
  padding-bottom: 15px;
  margin-right: 5px;
}

.tooltip-icon:hover {
  color: #2d4a3d;
}

.tooltip-content {
  position: absolute;
  top: 15px;
  left: 30px;
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
  z-index: 1001;
  min-width: 300px;
  max-width: 380px;
  pointer-events: auto;
  opacity: 1;
  transform: translateY(0);
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.tooltip-content ul {
  margin: 0;
  padding-left: 18px;
  list-style-type: disc;
}

.tooltip-content li {
  font-family: 'Raleway', sans-serif;
  font-size: 13px;
  line-height: 1.5;
  color: #333;
  margin-bottom: 8px;
}

.tooltip-content li:last-child {
  margin-bottom: 0;
}

/* Container for tooltip positioning */
.title-note {
  .d-flex.align-items-center {
    position: relative;
  }
}

/* Responsive tooltip adjustments */
@media (max-width: 768px) {
  .tooltip-content {
    left: -80px;
    min-width: 280px;
    max-width: 320px;
    top: -10px;
  }

  .tooltip-content::before {
    left: 85px;
    top: -8px;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 8px solid white;
    border-top: none;
  }

  .tooltip-content::after {
    left: 84px;
    top: -9px;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 8px solid #ddd;
    border-top: none;
  }
}

@media (max-width: 480px) {
  .tooltip-content {
    left: -120px;
    min-width: 250px;
    max-width: 280px;
    font-size: 12px;
  }

  .tooltip-content li {
    font-size: 12px;
  }

  .tooltip-content::before {
    left: 125px;
  }

  .tooltip-content::after {
    left: 124px;
  }
}

/* Mobile slider tooltip adjustments */
.mobile-tooltip-portal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1002;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.mobile-tooltip {
  position: relative !important;
  top: auto !important;
  left: auto !important;
  transform: none !important;
  z-index: 1003 !important;
  max-width: 90vw !important;
  max-height: 80vh !important;
  overflow-y: auto !important;
  margin: 0 auto;
}

.mobile-tooltip::before,
.mobile-tooltip::after {
  display: none !important;
}

.mobile-tooltip-header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.mobile-tooltip-close {
  background: none;
  border: none;
  font-size: 24px;
  font-weight: bold;
  color: #666;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s ease;
}

.mobile-tooltip-close:hover {
  background-color: #f0f0f0;
  color: #333;
}

@media (max-width: 480px) {
  .mobile-tooltip {
    padding: 20px !important;
    border-radius: 12px !important;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3) !important;
  }

  .mobile-tooltip li {
    font-size: 14px !important;
    line-height: 1.6 !important;
    margin-bottom: 10px !important;
  }

  .mobile-tooltip-close {
    font-size: 28px;
    width: 35px;
    height: 35px;
  }
}

.hidden-banner {
  visibility: hidden;
}

/* Horizontal Search Bar Styles */
.horizontal-search-bar {
  background: white;
  backdrop-filter: blur(10px);
  border-radius: 15px;
  padding: 8px;
  margin-top: 9rem;
  border: 1px solid #CFE5DC;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  width: 70%;
  z-index: 1;

  @media screen and (max-width: 1570px) {
    width: 75%;
  }

  @media screen and (max-width: 1480px) {
    width: 80%;
  }
  @media screen and (max-width: 1380px) {
    width: 85%;
  }
  @media screen and (max-width: 1320px) {
    width: 90%;
  }

  @media screen and (min-width: 769px) and (max-width: 1417px) {
    margin-top: 6rem !important;
  }

  input[type="checkbox"] {
    position: unset;
    left: unset;
    margin-left: 0;
  }
}


.horizontal-search-bar.sticky-search-bar {
  position: fixed;
  top: 42px;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 1;
  margin-top: 0;
  border-radius: 0;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.15);
  padding: 0;
  margin-top: unset !important;
}

.search-bar-content {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  width: 100%;
  gap: 20px;
  position: relative;
}

.search-bar-info {
  flex-shrink: 0;
}

.search-bar-title {
  font-family: 'Raleway', sans-serif;
  font-weight: 600;
  font-size: 20px;
  color: #333;
  margin: 0 0 5px 0;
}

.search-bar-price {
  margin: 0;
}

.search-bar-inputs {
  display: flex;
  align-items: center;
  gap: 15px;
  flex: 1;
  justify-content: space-evenly;
  position: relative;
}

.booking-header-dates {
  display: flex;
  align-items: stretch;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 8px;
  overflow: hidden;
}

.date-block {
  padding: 8px 16px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  min-width: 140px;
  
  .label {
    margin-bottom: 2px;
    color: #2C5E4BBC;
  }
  
  .value {
    white-space: nowrap;
  }
}

.date-block-separator {
  border-left: 1px solid #CFE5DC;
  border-right: 1px solid #CFE5DC;
}

.search-bar-button {
  flex-shrink: 0;
}

.search-btn {
  padding: 12px 24px;
  white-space: nowrap;
  min-width: 180px;
}

/* Mobile adjustments */
@media (max-width: 768px) {
  .horizontal-search-bar {
    display: none;
  }
}

/* Sticky search bar adjustments */
.sticky-search-bar .search-bar-content {
  padding: 15px 20px;
}

.sticky-search-bar .date-block {
  padding: 6px 12px;
  min-width: 120px;
}

.sticky-search-bar .search-btn {
  padding: 10px 20px;
  min-width: 160px;
}

.search-bar-multiple-rooms-toggle {
  margin-top: 8px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;

  input {
    width: 16px;
    height: 16px;
    accent-color: #3B6152;
    cursor: pointer;
    margin-left: 10px;
  }

  span {
    color: #3B6152;
    white-space: nowrap;
  }
}

.search-bar-edit-room-plans {
  border: 0;
  background: transparent;
  color: #3B6152;
  text-decoration: underline;
  padding: 0;
  line-height: 1;
}

.green-note-slider {
  padding: 2px 0 !important;
}

.guest-icon {
  width: 15px;
  height: 20px;
  object-fit: contain;
}

.guest-info-banner {
  position: relative;
}

.guest-info-overlay {
  position: fixed !important;
  bottom: 40%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 999;
  width: 90%;
  max-width: 400px;
  margin-top: 0;
  top: unset !important;
  padding-bottom: 10px;
}

@media screen and (min-width: 700px) {

  .greennote-lodge-container {
    min-height: unset !important;

    .bottom-note .tooltip-content {
      top: -180px !important;
    }
  }
}

@media screen and (max-width: 699px) {
  .container-profil {
    min-height: unset !important;
    width: 100% !important;
  }
}

@media screen and (min-width: 700px) {
  .container-profil {
    min-height: unset !important;
    height: unset !important;
    width: 100% !important;
  }
}



.main-content-wrapper {
  width: 100%;
  @media (max-width: 768px) {
    padding: 0 15px !important;
    flex-direction: column;
    gap: 20px;
  }
  .content-left {
    width: 67%;
    padding: 32px 1% 0px 3% !important;

    @media (max-width: 768px) {
      padding: 16px 0 !important;
      width: 100% !important;
    }
  }

  .content-right {
    padding-right: 2%;
    width: 33%;
    position: sticky;
    top: 90px;
    align-self: flex-start;
    max-height: calc(100vh - 80px);
    overflow-y: auto;

    @media (max-width: 768px) {
      width: 100% !important;
      position: relative;
      top: auto;
      max-height: none;
      overflow-y: visible;
    }
    .lodge-info-container {
      height: fit-content;
      background: #CFE5DC99 0% 0% no-repeat padding-box;
      border-radius: 15px;
      opacity: 1;
      display: flex;
      flex-direction: column;
      padding: 20px;
      gap: 20px;
    }
  }
}

.secondary-content-wrapper {
  width:  100%;
  margin-top: 20px;
}

.text-green {
  color: #2C5E4B;
}

.green-notes-container {
  opacity: 1;
  padding: 40px 80px;

  @media screen and (max-width: 480px) {
    padding: unset;
    overflow-x: scroll;
    box-shadow: unset;
    border-radius: unset;
  }
}

.label-environment {
  .label-environment-items {
    gap: 140px;
    @media (max-width: 768px) {
      gap: 20px;
    }

    .item-data {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }
  }
}

.promise-conditions-container {
  background: #CFE5DC64 0% 0% no-repeat padding-box;
  border-radius: 15px;
  padding: 20px 32px 40px 40px;

  @media screen and (max-width: 480px) {
    padding: 20px 10px;
  }
}

.lodging-info {
  height: auto;
  width: 100%;
  background: #F5F5F5A7 0% 0% no-repeat padding-box;

  .lodge-type {
    border: 1px solid #2C5E4B;
    border-radius : 15px;
    color: #2C5E4B;
    padding: 15px;
    height: 37px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .green_score_cont {
    height: 52px;
    border: 1px solid #CFE5DC;
    border-radius: 15px;
    padding: 15px;
    display: flex;
    justify-content: center;
    align-items: center;

    @media screen and (max-width: 480px) {
      height: 30px;
      padding: 10px;
    }
  }
}
.good-2-know-content {
  padding-left: calc(4% + 25px);
  @media screen and (max-width: 480px) {
    padding-left: 6px;
  }
}

.exp-category.active {
  p {
    font-weight: 600 !important;
  }
}

.host-card-container {
  height: 100%;
  position: relative;
  
  img {
    object-fit: cover;
    flex-shrink: 0;
  }
  
  .host-content {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    
    .manager-text-wrapper,
    .chef-text-wrapper {
      flex: 1;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      min-height: 0;
      
      p {
        &.manager-text,
        &.chef-text {
          margin-bottom: 0;
          -webkit-box-orient: vertical;
          display: -webkit-box;
          overflow: hidden;
          word-break: break-word;
          
          /* Default line clamp (6 lines when name and designation present) */
          line-clamp: 6;
          -webkit-line-clamp: 6;
          
          @media (max-width: 1024px) {
            line-clamp: 4;
            -webkit-line-clamp: 4;
          }
          
          @media (max-width: 768px) {
            line-clamp: 3;
            -webkit-line-clamp: 3;
          }
          
          /* Line clamp 8 when no name and designation */
          &.line-clamp-8 {
            line-clamp: 8;
            -webkit-line-clamp: 8;
            
            @media (max-width: 1024px) {
              line-clamp: 5;
              -webkit-line-clamp: 5;
            }
            
            @media (max-width: 768px) {
              line-clamp: 3;
              -webkit-line-clamp: 3;
            }
          }
          
          /* Line clamp 6 when name and designation present */
          &.line-clamp-6 {
            line-clamp: 6;
            -webkit-line-clamp: 6;
            
            @media (max-width: 1024px) {
              line-clamp: 4;
              -webkit-line-clamp: 4;
            }
            
            @media (max-width: 768px) {
              line-clamp: 3;
              -webkit-line-clamp: 3;
            }
          }
        }
      }
      
      &.expanded {
        p {
          &.manager-text,
          &.chef-text {
            line-clamp: unset;
            -webkit-line-clamp: unset;
            display: block;
            overflow: visible;
          }
        }
      }
    }
  }
  
  .show-more-btn {
    align-self: flex-start;
    margin-top: 8px;
    white-space: nowrap;
    padding: 0;
    border: none;
    background: none;
    cursor: pointer;
    
    &:hover {
      opacity: 0.8;
    }
  }
}

@media (max-width: 768px) {
  .host-card-container {
    height: auto;
    
    .host-content {
      flex: unset;
    }
  }
}

.experiences-lodging {
  .slither-slider-slide {
    grid-template-columns: repeat(2, minmax(0px, 1fr)) !important;
  }
}

.good-2-know-content {
  ul {
    padding-left: 0 !important;
  }
}

@media screen and (min-width: 700px) {
  .information-importantes {
    .accordion-body.active {
      padding-left: 4%;

      ul {
        padding-left: 25px;
      }
    } 
  }

  .lodge-kids-corner {
    .accordion-body.active {
      padding-left: calc(4% + 40px);
    }
  }
}

.traveler-reviews {
  text-align: left;

  .ta-review-slide {
    padding-right: 16px;
  }

  .ta-review-card {
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 12px;
    padding: 20px;
    height: 100%;
  }

  .ta-avatar {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
  }

  .ta-muted {
    color: #707070;
  }
}
.traveler-reviews {
  position: relative;
}

.ta-subtitle {
  margin-top: 6px;
  margin-bottom: 12px;
}

.ta-global-summary {
  gap: 6px;
  margin-bottom: 10px;
}

.ta-star {
  color: #2C5E4B;
}

.ta-starr {
  color: #D3AF6C;
}

.ta-avatar {
  width: 38px;
  height: 38px;
  border-radius: 999px;
  color: white;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  background: #3B6152;
  border: 1px solid rgba(44, 94, 75, 0.18);
}

.ta-slider-hint {
  white-space: nowrap;
}

.ta-desktop-divider {
  border: 0;
  height: 1px;
  background: rgba(0,0,0,0.08);
  margin: 14px 0 6px 0;
}

.ta-rating .ta-star {
  color: #2C5E4B; 
}

.ta-content.is-clamped {
  display: -webkit-box;
  -webkit-line-clamp: 4;   
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.ta-content:not(.is-clamped){
  display: block;
  overflow: visible;
  max-height: none;
}

.ta-see-more {
  margin-top: 8px;
  background: transparent;
  border: 0;
  cursor: pointer;
}

.ta-footer {
  padding-top: 6px;
}

@media (min-width: 768px) {
  .traveler-reviews {
    border-top: 1px solid rgba(0,0,0,0.08);
    border-bottom: 1px solid rgba(0,0,0,0.08);
    padding-top: 18px;
    padding-bottom: 18px;
  }
}

@media (max-width: 768px) {
  .traveler-reviews-slider {
    overflow: visible !important;      /* allow peek */
    padding-right: 22px;               /* space to reveal next slide */
  }

  .traveler-reviews-slider .ta-review-slide {
    width: 88vw !important;            /* less than 100% so next appears */
    margin-right: 12px;                /* gap between slides */
  }

  .traveler-reviews-slider * {
    overflow: visible;
  }
}



  .circle-iconn {
        width: 43px;
        height: 43px;
        border: 1px solid #F7F7F7;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        background: #00000053 0% 0% no-repeat padding-box;
      }
      .previous-slide-buttonn {
        position: absolute;
        top: 30%;
        transform: translateY(-50%);
        left: -3%;
        color: #F7F7F7;
        background: #00000053 0% 0% no-repeat padding-box;

        img {
          width: 26px !important;
          height: 15px !important;
        }
      }

      .next-slide-buttonn {
        position: absolute;
        top: 30%;
        transform: translateY(-50%);
        right: 2.5%;
        color: #F7F7F7;
        background: #00000053 0% 0% no-repeat padding-box;

        img {
          width: 26px !important;
          height: 15px !important;
        }
      }
      @media (max-width: 768px) {
        .traveler-reviews-slider.is-peek,
        .traveler-reviews-slider.is-peek .tns-outer,
        .traveler-reviews-slider.is-peek .tns-ovh,
        .traveler-reviews-slider.is-peek .slither-viewport,
        .traveler-reviews-slider.is-peek .swiper {
          overflow: visible !important;
        }

        .traveler-reviews-slider.is-peek .ta-review-slide {
          padding-right: 12px;
        }
      }


.traveler-reviews {
  --ta-card-h: 320px;
}

.ta-review-slide {
  display: flex;         
}

.ta-review-card {
  width: 100%;
  height: var(--ta-card-h);
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  padding: 20px;
  overflow: hidden;       
}

.ta-review-card.is-expanded {
  height: auto;            
  overflow: visible;
}

.ta-content.is-clamped {
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.ta-content:not(.is-clamped) {
  display: block;
  overflow: visible;
  max-height: none;
}

.ta-see-more {
  margin-top: auto;
  background: transparent;
  border: 0;
  cursor: pointer;
}
@media (max-width: 768px) {
  .traveler-reviews {
    --ta-card-h: 290px; /* mobile card height */
  }

  .traveler-reviews-slider.is-peek,
  .traveler-reviews-slider.is-peek .tns-outer,
  .traveler-reviews-slider.is-peek .tns-ovh,
  .traveler-reviews-slider.is-peek .slither-viewport,
  .traveler-reviews-slider.is-peek .swiper {
    overflow: visible !important;
  }

  /* ✅ show 1.5 cards: card width = (container - gap)/1.5 */
  .traveler-reviews-slider.is-peek .ta-review-slide {
    width: calc((100% - 12px) / 1.5) !important;
    margin-right: 12px;
  }

  .traveler-reviews-slider.is-peek {
    padding-right: 18px;
  }
}
.traveler-reviews-scroll {
  display: flex;
  gap: 16px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scroll-snap-type: x mandatory;
  padding-bottom: 12px;
  padding-right: 16px; /* shows the “half next card” nicely */
}

.traveler-reviews-scroll::-webkit-scrollbar {
  display: none;
}

.traveler-reviews-scroll .ta-review-slide {
  flex: 0 0 84%;          /* adjust 82–88% depending on your padding */
  max-width: 84%;
  scroll-snap-align: start;
}
.ta-content.is-clamped {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5; /* change lines */
  overflow: hidden;
}
.ta-review-card.is-expanded {
  max-height: none !important;
  height: auto !important;
  overflow: visible !important;
}

.ta-content.is-clamped {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 6; /* keep your clamp */
  overflow: hidden;
}

.ta-review-card.is-expanded .ta-content {
  display: block;
  -webkit-line-clamp: unset;
  overflow: visible;
}
.ta-content.is-clamped{
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  overflow: hidden;
}

.traveler-reviews {
  --ta-card-h: 320px;
}

/* slide/card layout */
.ta-review-slide {
  display: flex;
}

.ta-review-card {
  width: 100%;
  height: var(--ta-card-h);
  display: flex;
  flex-direction: column;
  padding: 20px;
  border-radius: 12px;
  border: 1px solid rgba(0,0,0,0.08);
  background: #fff;
  overflow: hidden; /* collapse mode */
}

.ta-review-card.is-expanded {
  height: auto !important;
  min-height: var(--ta-card-h);
  overflow: visible !important;
}

.ta-content {
  display: block;
  overflow: visible;
}

.ta-content.is-clamped {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  overflow: hidden;
}

.ta-see-more {
  margin-top: 10px !important;
  background: transparent;
  border: 0;
  cursor: pointer;
  align-self: flex-start;
}

@media (max-width: 768px) {
  .fixed-banner {
    padding: 10px;
  }
}

.search-bar-button-phone {
  width: 100%;

  .search-bar-multiple-rooms-toggle {
    margin-top: 0;
    justify-content: flex-start;
    gap: 6px;
    color: #3B6152;

    span {
      color: #3B6152;
      white-space: normal;
      line-height: 1.2;
    }
  }

  input[type="checkbox"] {
    position: unset;
    left: unset;
    margin-left: 0;
    flex-shrink: 0;
  }
}

@media (max-width: 400px) {
  .bottom-bar-font {
    font-size: 12px !important;
  }
}
</style>
